// import React, { useState, useEffect, useRef } from "react";
// import { useSelector } from "react-redux";
// import "../../Styles/ManagementPages.css";
// import {
//   getAllMasterRoutes,
//   getMasterRouteById,
//   createMasterRoute,
//   updateMasterRoute,
//   deleteMasterRoute,
//   toggleMasterRouteStatus,
//   searchMasterRoutesByCities,
//   searchMasterRouteIntermediateStops,
//   searchRouteIntermediateStops,
// } from "../../Services/Operations/ProductAPI";
// import { toast } from "react-toastify";
// import "../../Styles/RouteManage.css";
// import {
//   getPlacePredictions,
//   getPlaceDetails,
//   getDistanceMatrix,
// } from "../../utilis/mapUtils";
// import CityAutocomplete from "./CityAutocomplete";
// import CitySearchInput from "./CitySearchInput";

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td>
//       <div className="skeleton-cell"></div>
//     </td>
//     <td>
//       <div className="skeleton-cell"></div>
//     </td>
//     <td>
//       <div className="skeleton-cell"></div>
//     </td>
//     <td>
//       <div className="skeleton-cell"></div>
//     </td>
//     <td>
//       <div className="skeleton-cell"></div>
//     </td>
//     <td>
//       <div className="skeleton-cell"></div>
//     </td>
//     <td>
//       <div className="skeleton-badge"></div>
//     </td>
//     <td>
//       <div className="skeleton-badge"></div>
//     </td>
//     <td>
//       <div className="skeleton-actions"></div>
//     </td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Route Name</th>
//           <th>Origin</th>
//           <th>Destination</th>
//           <th>Distance</th>
//           <th>Stops</th>
//           <th>Type</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const LocationInput = ({
//   value,
//   onChange,
//   placeholder,
//   onLocationSelect,
//   isManual,
// }) => {
//   const [searchQuery, setSearchQuery] = useState(value || "");
//   const [suggestions, setSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const timeoutRef = useRef(null);

//   useEffect(() => {
//     setSearchQuery(value || "");
//   }, [value]);

//   useEffect(() => {
//     if (isManual) {
//       setSuggestions([]);
//       setShowSuggestions(false);
//     }
//   }, [isManual]);

//   const searchLocations = async (query) => {
//     if (isManual)
//       return;
//     if (!query || query.trim().length < 2) {
//       setSuggestions([]);
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const predictions = await getPlacePredictions(query);
//       setSuggestions(predictions);
//       setShowSuggestions(predictions.length > 0);
//     } catch (error) {
//       console.error("Search error:", error);
//       setSuggestions([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSelect = async (prediction) => {
//     if (isManual)
//       return;
//     setIsLoading(true);
//     try {
//       const placeDetails = await getPlaceDetails(prediction.place_id);
//       if (placeDetails) {
//         setSearchQuery(placeDetails.name || placeDetails.address);
//         setShowSuggestions(false);
//         if (onLocationSelect) {
//           onLocationSelect({
//             name: placeDetails.name,
//             address: placeDetails.address,
//             city:
//               placeDetails.city ||
//               prediction.structured_formatting?.secondary_text?.split(",")[0] ||
//               "",
//             state:
//               placeDetails.state ||
//               prediction.structured_formatting?.secondary_text
//                 ?.split(",")[1]
//                 ?.trim() ||
//               "",
//             coordinates: placeDetails.coordinates || { lat: 0, lng: 0 },
//             placeId: prediction.place_id,
//           });
//         }
//       }
//     } catch (error) {
//       console.error("Error getting place details:", error);
//       toast.error("Failed to get location details");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleTextChange = (e) => {
//     const newValue = e.target.value;
//     setSearchQuery(newValue);
//     onChange(newValue);

//     if (isManual)
//       return;

//     if (timeoutRef.current)
//       clearTimeout(timeoutRef.current);
//     timeoutRef.current = setTimeout(() => {
//       searchLocations(newValue);
//     }, 500);
//   };

//   useEffect(() => {
//     return () => {
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//     };
//   }, []);

//   return (
//     <div className="location-input-container">
//       <div className="location-input-wrapper">
//         <input
//           type="text"
//           value={searchQuery}
//           onChange={handleTextChange}
//           onFocus={() => {
//             if (!isManual && suggestions.length > 0) {
//               setShowSuggestions(true);
//             }
//           }}
//           onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
//           className="edit-input"
//           placeholder={placeholder}
//         />
//         {isLoading && !isManual && (
//           <div className="location-loading">
//             <div className="spinner"></div>
//           </div>
//         )}
//       </div>

//       {!isManual && showSuggestions && suggestions.length > 0 && (
//         <div className="location-suggestions">
//           <div className="suggestions-header">
//             <span>Search Results</span>
//           </div>
//           {suggestions.map((prediction, index) => (
//             <div
//               key={prediction.place_id || index}
//               className="suggestion-item"
//               onClick={() => handleSelect(prediction)}
//             >
//               <div className="suggestion-main">
//                 {prediction.structured_formatting?.main_text ||
//                   prediction.description}
//               </div>
//               <div className="suggestion-secondary">
//                 {prediction.structured_formatting?.secondary_text}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const Checkbox = ({ label, checked, onChange }) => (
//   <label className="checkbox-container">
//     <input
//       type="checkbox"
//       checked={checked}
//       onChange={onChange}
//       className="checkbox-input"
//     />
//     <span className="checkbox-label">{label}</span>
//   </label>
// );

// const MasterRouteSelector = ({
//   value,
//   onChange,
//   onRouteNameChange,
//   token,
//   disabled,
// }) => {
//   const [masterRoutes, setMasterRoutes] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [source, setSource] = useState("");
//   const [destination, setDestination] = useState("");
//   const [isManualEntry, setIsManualEntry] = useState(false);
//   const [routeNameValue, setRouteNameValue] = useState("");
//   const [selectedRouteValue, setSelectedRouteValue] = useState(null);
//   const [selectedRouteDetails, setSelectedRouteDetails] = useState(null);

//   const [sourceSuggestions, setSourceSuggestions] = useState([]);
//   const [destSuggestions, setDestSuggestions] = useState([]);
//   const [isLoadingSource, setIsLoadingSource] = useState(false);
//   const [isLoadingDest, setIsLoadingDest] = useState(false);

//   const sourceTimeoutRef = useRef(null);
//   const destTimeoutRef = useRef(null);

//   useEffect(() => {
//     if (value && value.masterRouteName) {
//       setRouteNameValue(value.masterRouteName);
//       setSelectedRouteValue(value);
//       if (value.origin?.city) setSource(value.origin.city);
//       if (value.destination?.city) setDestination(value.destination.city);
//     } else {
//       setRouteNameValue("");
//       setSelectedRouteValue(null);
//       setSource("");
//       setDestination("");
//       setMasterRoutes([]);
//       setShowDropdown(false);
//       setIsManualEntry(false);
//     }
//   }, [value]);

//   const fetchMasterRoutesByCities = async (
//     sourceCity,
//     destCity,
//     isSourceSearch = true,
//   ) => {
//     if (!sourceCity && !destCity) {
//       setMasterRoutes([]);
//       setShowDropdown(false);
//       setSourceSuggestions([]);
//       setDestSuggestions([]);
//       return;
//     }

//     if (isSourceSearch) {
//       setIsLoadingSource(true);
//     } else {
//       setIsLoadingDest(true);
//     }

//     try {
//       console.log("Fetching routes with:", { sourceCity, destCity });
//       const response = await searchMasterRoutesByCities(
//         token,
//         sourceCity,
//         destCity,
//       );
//       console.log("API Response:", response);

//       if (response.success && response.data) {
//         const routesData =
//           response.data.routes ||
//           (Array.isArray(response.data) ? response.data : []);

//         if (routesData.length > 0) {
//           const mappedRoutes = routesData.map((route) => ({
//             _id: route._id,
//             masterRouteName: route.masterRouteName,
//             description: route.description || "",
//             originCity: route.origin?.city || "",
//             originState: route.origin?.state || "",
//             originAddress: route.origin?.address || "",
//             originTerminal: route.origin?.terminal || "",
//             originCoords: route.origin?.coordinates || null,
//             destinationCity: route.destination?.city || "",
//             destinationState: route.destination?.state || "",
//             destinationAddress: route.destination?.address || "",
//             destinationTerminal: route.destination?.terminal || "",
//             destinationCoords: route.destination?.coordinates || null,
//             totalDistance: route.routeDetails?.totalDistance || 0,
//             durationHours: route.routeDetails?.estimatedDuration?.hours || 0,
//             durationMinutes:
//               route.routeDetails?.estimatedDuration?.minutes || 0,
//             intermediateStops: route.intermediateStops || [],
//             isRoundTrip: route.isRoundTrip || false,
//             returnJourney: route.returnJourney || null,
//           }));

//           console.log("Mapped routes:", mappedRoutes);
//           setMasterRoutes(mappedRoutes);
//           setShowDropdown(true);
//         } else {
//           setMasterRoutes([]);
//           setShowDropdown(true);
//         }

//         if (response.data.sourceSuggestions) {
//           setSourceSuggestions(response.data.sourceSuggestions);
//         }
//         if (response.data.destinationSuggestions) {
//           setDestSuggestions(response.data.destinationSuggestions);
//         }
//       } else {
//         setMasterRoutes([]);
//         setShowDropdown(true);
//       }
//     } catch (error) {
//       console.error("Error fetching routes:", error);
//       setMasterRoutes([]);
//       setShowDropdown(true);
//     } finally {
//       setIsLoadingSource(false);
//       setIsLoadingDest(false);
//     }
//   };
//   const handleSourceSelect = (selectedCity) => {
//     if (!selectedCity) return;

//     const cityName =
//       typeof selectedCity === "object" ? selectedCity.city : selectedCity;
//     setSource(cityName);
//     setShowDropdown(false);

//     if (selectedRouteValue) {
//       setSelectedRouteValue(null);
//       onChange(null);
//     }

//     if (sourceTimeoutRef.current)
//       clearTimeout(sourceTimeoutRef.current);
//     sourceTimeoutRef.current = setTimeout(() => {
//       fetchMasterRoutesByCities(cityName, destination);
//     }, 500);
//   };

//   const handleDestinationSelect = (selectedCity) => {
//     if (!selectedCity) return;

//     const cityName =
//       typeof selectedCity === "object" ? selectedCity.city : selectedCity;
//     setDestination(cityName);
//     setShowDropdown(false);

//     if (selectedRouteValue) {
//       setSelectedRouteValue(null);
//       onChange(null);
//     }

//     if (destTimeoutRef.current)
//       clearTimeout(destTimeoutRef.current);
//     destTimeoutRef.current = setTimeout(() => {
//       fetchMasterRoutesByCities(source, cityName);
//     }, 500);
//   };

//   const handleSourceInputChange = (value) => {
//     setSource(value);
//     setShowDropdown(false);

//     if (selectedRouteValue) {
//       setSelectedRouteValue(null);
//       onChange(null);
//     }

//     if (sourceTimeoutRef.current)
//       clearTimeout(sourceTimeoutRef.current);
//     sourceTimeoutRef.current = setTimeout(() => {
//       if (value.length >= 2 || destination.length >= 2) {
//         fetchMasterRoutesByCities(value, destination, true);
//       } else {
//         setMasterRoutes([]);
//         setSourceSuggestions([]);
//       }
//     }, 500);
//   };

//   const handleDestinationInputChange = (value) => {
//     setDestination(value);
//     setShowDropdown(false);

//     if (selectedRouteValue) {
//       setSelectedRouteValue(null);
//       onChange(null);
//     }

//     if (destTimeoutRef.current)
//       clearTimeout(destTimeoutRef.current);
//     destTimeoutRef.current = setTimeout(() => {
//       if (source.length >= 2 || value.length >= 2) {
//         fetchMasterRoutesByCities(source, value, false);
//       } else {
//         setMasterRoutes([]);
//         setDestSuggestions([]);
//       }
//     }, 500);
//   };
//   const handleRouteSelect = async (route) => {
//     console.log("Route selected:", route);
//     setSelectedRouteDetails(route);
//     setShowDropdown(false);

//     try {
//       setIsLoading(true);

//       const response = await getMasterRouteById(route._id, token);
//       console.log("Complete route details:", response);

//       if (response.success && response.data) {
//         const fullRoute = response.data;

//         setSource(fullRoute.origin?.city || "");
//         setDestination(fullRoute.destination?.city || "");
//         setRouteNameValue(fullRoute.masterRouteName);

//         const selectedRouteObj = {
//           _id: fullRoute._id,
//           masterRouteName: fullRoute.masterRouteName,
//           description: fullRoute.description || "",
//           isManual: false,
//           origin: {
//             city: fullRoute.origin?.city || "",
//             state: fullRoute.origin?.state || "",
//             address: fullRoute.origin?.address || "",
//             terminal: fullRoute.origin?.terminal || "",
//             coordinates: fullRoute.origin?.coordinates || null,
//           },
//           destination: {
//             city: fullRoute.destination?.city || "",
//             state: fullRoute.destination?.state || "",
//             address: fullRoute.destination?.address || "",
//             terminal: fullRoute.destination?.terminal || "",
//             coordinates: fullRoute.destination?.coordinates || null,
//           },
//           intermediateStops: fullRoute.intermediateStops || [],
//           routeDetails: {
//             totalDistance: fullRoute.routeDetails?.totalDistance || 0,
//             estimatedDuration: {
//               hours: fullRoute.routeDetails?.estimatedDuration?.hours || 0,
//               minutes: fullRoute.routeDetails?.estimatedDuration?.minutes || 0,
//             },
//           },
//           isRoundTrip: fullRoute.isRoundTrip || false,
//           returnJourney: fullRoute.returnJourney || null,
//         };

//         console.log(
//           "Calling onChange with full route object:",
//           selectedRouteObj,
//         );
//         onChange(selectedRouteObj);
//         if (onRouteNameChange) onRouteNameChange(fullRoute.masterRouteName);
//       } else {
//         toast.error("Failed to load complete route details");
//       }
//     } catch (error) {
//       console.error("Error fetching full route details:", error);
//       toast.error("Failed to load route details. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRouteNameChange = (e) => {
//     const newName = e.target.value;
//     setRouteNameValue(newName);
//     if (onRouteNameChange) onRouteNameChange(newName);
//     if (selectedRouteValue)
//       onChange({ ...selectedRouteValue, masterRouteName: newName });
//   };

//   const handleClearSelection = () => {
//     setSelectedRouteValue(null);
//     setSelectedRouteDetails(null);
//     setRouteNameValue("");
//     setSource("");
//     setDestination("");
//     setMasterRoutes([]);
//     setShowDropdown(false);
//     setIsManualEntry(false);
//     onChange(null);
//     if (onRouteNameChange) onRouteNameChange("");
//   };

//   const handleOpenManualEntry = () => {
//     setIsManualEntry(true);
//     setShowDropdown(false);
//   };

//   const handleManualEntrySubmit = () => {
//     if (!routeNameValue.trim()) {
//       toast.error("Please enter a route name");
//       return;
//     }

//     const emptyRoute = {
//       _id: null,
//       masterRouteName: routeNameValue.trim(),
//       isManual: true,
//       origin: { city: source || "", state: "" },
//       destination: { city: destination || "", state: "" },
//       routeDetails: { totalDistance: 0 },
//       isRoundTrip: false,
//     };

//     setIsManualEntry(false);
//     setSelectedRouteValue(emptyRoute);
//     onChange(emptyRoute);
//   };

//   const handleCancelManualEntry = () => {
//     setIsManualEntry(false);
//     setRouteNameValue("");
//   };

//   const showSearchFields = !selectedRouteValue && !isManualEntry;

//   useEffect(() => {
//     return () => {
//       if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
//       if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
//     };
//   }, []);

//   return (
//     <div
//       className="master-route-selector"
//       style={{ position: "relative", width: "100%" }}
//     >
//       {showSearchFields && (
//         <>
//           <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
//             <div className="form-group" style={{ flex: 1 }}>
//               <label>Source City</label>
//               <CityAutocomplete
//                 type="source"
//                 value={source}
//                 onChange={handleSourceInputChange}
//                 onSelect={handleSourceSelect}
//                 placeholder="Enter source city..."
//                 suggestions={sourceSuggestions}
//                 isLoading={isLoadingSource}
//                 disabled={disabled}
//               />
//             </div>
//             <div className="form-group" style={{ flex: 1 }}>
//               <label>Destination City</label>
//               <CityAutocomplete
//                 type="destination"
//                 value={destination}
//                 onChange={handleDestinationInputChange}
//                 onSelect={handleDestinationSelect}
//                 placeholder="Enter destination city..."
//                 suggestions={destSuggestions}
//                 isLoading={isLoadingDest}
//                 disabled={disabled}
//               />
//             </div>
//           </div>


//           {(showDropdown || isLoading) && (
//             <div
//               style={{
//                 border: "1px solid #ddd",
//                 borderRadius: "4px",
//                 boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                 backgroundColor: "white",
//                 maxHeight: "300px",
//                 overflowY: "auto",
//                 marginBottom: "10px",
//                 zIndex: 1000,
//                 position: "relative",
//               }}
//             >
//               {isLoading ? (
//                 <div
//                   style={{
//                     padding: "12px",
//                     textAlign: "center",
//                     color: "#666",
//                   }}
//                 >
//                   <div className="spinner-small"></div> Searching...
//                 </div>
//               ) : masterRoutes.length > 0 ? (
//                 <>
//                   <div
//                     style={{
//                       padding: "8px 12px",
//                       backgroundColor: "#f8f9fa",
//                       borderBottom: "1px solid #eee",
//                       fontSize: "12px",
//                       color: "#666",
//                     }}
//                   >
//                     Found {masterRoutes.length} matching route(s)
//                   </div>
//                   {masterRoutes.map((route) => (
//                     <div
//                       key={route._id}
//                       onClick={() => handleRouteSelect(route)}
//                       style={{
//                         padding: "10px 12px",
//                         cursor: "pointer",
//                         borderBottom: "1px solid #f0f0f0",
//                         transition: "background-color 0.2s",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.backgroundColor = "#f0f7ff")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.backgroundColor = "white")
//                       }
//                     >
//                       <div style={{ fontWeight: "500", marginBottom: "3px" }}>
//                         {route.masterRouteName}
//                       </div>
//                       <div style={{ fontSize: "12px", color: "#6c757d" }}>
//                         {route.originCity || route.origin?.city || "N/A"} →{" "}
//                         {route.destinationCity ||
//                           route.destination?.city ||
//                           "N/A"}{" "}
//                         &nbsp;•&nbsp;
//                         {route.isRoundTrip ? "Round Trip" : "One Way"}{" "}
//                         &nbsp;•&nbsp;
//                         {route.totalDistance ||
//                           route.routeDetails?.totalDistance ||
//                           0}{" "}
//                         km
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               ) : (
//                 <div
//                   style={{
//                     padding: "12px",
//                     textAlign: "center",
//                     color: "#666",
//                   }}
//                 >
//                   No routes found for this route.
//                   <button
//                     type="button"
//                     onClick={handleOpenManualEntry}
//                     style={{
//                       color: "#007bff",
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       padding: "0 0 0 5px",
//                     }}
//                   >
//                     Create new route instead
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}

//           <div style={{ textAlign: "right" }}>
//             <button
//               type="button"
//               className="btn btn-secondary btn-sm"
//               onClick={handleOpenManualEntry}
//               style={{ padding: "5px 12px", fontSize: "12px" }}
//             >
//               + Create New Route (skip search)
//             </button>
//           </div>
//         </>
//       )}

//       {isManualEntry && (
//         <div
//           className="selector-input-group"
//           style={{
//             display: "flex",
//             gap: "10px",
//             alignItems: "center",
//             flexDirection: "column",
//           }}
//         >
//           <div style={{ width: "100%" }}>
//             <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//               <input
//                 type="text"
//                 value={routeNameValue}
//                 onChange={handleRouteNameChange}
//                 placeholder="Enter new master route name..."
//                 className="form-input"
//                 style={{ flex: 1 }}
//                 disabled={disabled}
//               />
//               <button
//                 type="button"
//                 className="btn btn-primary"
//                 onClick={handleManualEntrySubmit}
//                 style={{ padding: "8px 16px", whiteSpace: "nowrap" }}
//               >
//                 Save Manual
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={handleCancelManualEntry}
//                 style={{ padding: "8px 16px" }}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//           <small className="helper-text" style={{ color: "#666" }}>
//             You're creating a new master route. Fill in the details below.
//           </small>
//         </div>
//       )}

//       {selectedRouteValue &&
//         selectedRouteValue.masterRouteName &&
//         !isManualEntry && (
//           <div style={{ marginBottom: "5px" }}>
//             <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//               <input
//                 type="text"
//                 value={routeNameValue}
//                 onChange={handleRouteNameChange}
//                 placeholder="Enter master route name..."
//                 className="form-input"
//                 style={{ flex: 1 }}
//                 disabled={disabled}
//               />
//               <button
//                 type="button"
//                 className="btn btn-secondary btn-sm"
//                 onClick={handleClearSelection}
//                 style={{ padding: "8px 14px", whiteSpace: "nowrap" }}
//                 title="Clear and search again"
//               >
//                 ✕ Change
//               </button>
//             </div>
//             <small
//               style={{
//                 color: selectedRouteValue.isManual ? "#007bff" : "#28a745",
//                 display: "block",
//                 marginTop: "4px",
//               }}
//             >
//               {selectedRouteValue.isManual
//                 ? "ℹ️ New route — fill in details below"
//                 : `✓ Auto-filled from "${selectedRouteValue.masterRouteName}" — edit name above if needed`}
//             </small>
//           </div>
//         )}
//     </div>
//   );
// };

// const MasterRouteManage = () => {
//   const { token } = useSelector((state) => state.user);
//   const [selectorKey, setSelectorKey] = useState(0);
//   const [routes, setRoutes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [editingRoute, setEditingRoute] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingRoute, setViewingRoute] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [isRoundTrip, setIsRoundTrip] = useState(true);
//   const [activeRouteTab, setActiveRouteTab] = useState("UP");
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [isUpdatingRoute, setIsUpdatingRoute] = useState(false);
//   const [editUpIndex, setEditUpIndex] = useState(null);
//   const [editDownIndex, setEditDownIndex] = useState(null);
//   const [isManualStop, setIsManualStop] = useState(true);
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [showCityDropdown, setShowCityDropdown] = useState(false);
//   const [editCitySuggestions, setEditCitySuggestions] = useState([]);
//   const [showEditCityDropdown, setShowEditCityDropdown] = useState(false);
//   const [modalCitySuggestions, setModalCitySuggestions] = useState([]);
//   const [showModalCityDropdown, setShowModalCityDropdown] = useState(false);
//   const [editViaInput, setEditViaInput] = useState("");

//   const [isOriginManual, setIsOriginManual] = useState(true);
//   const [isDestinationManual, setIsDestinationManual] = useState(true);

//   const [originManualDistance, setOriginManualDistance] = useState("");
//   const [destinationManualDistance, setDestinationManualDistance] =
//     useState("");

//   const [inlineInsertIndex, setInlineInsertIndex] = useState(null);
//   const [inlineInsertForm, setInlineInsertForm] = useState({
//     city: "",
//     state: "",
//     address: "",
//     terminal: "",
//     stopType: "none",
//     distFromPrev: "",
//     distToNext: "",
//     isManual: true,
//   });
//   const [inlineInsertCitySuggestions, setInlineInsertCitySuggestions] =
//     useState([]);
//   const [showInlineInsertDropdown, setShowInlineInsertDropdown] =
//     useState(false);

//   const [showStopEditModal, setShowStopEditModal] = useState(false);
//   const [stopBeingEdited, setStopBeingEdited] = useState(null);
//   const [stopEditForm, setStopEditForm] = useState({
//     city: "",
//     state: "",
//     address: "",
//     terminal: "",
//     stopType: "none",
//     manualDistFromPrev: "",
//     manualDistToNext: "",
//     isManualStop: true,
//   });

//   const [showStopModal, setShowStopModal] = useState(false);
//   const [stopModalMode, setStopModalMode] = useState("add");
//   const [tempStopForm, setTempStopForm] = useState({
//     city: "",
//     state: "",
//     address: "",
//     terminal: "",
//     stopType: "none",
//     distFromPrev: "",
//     distToNext: "",
//     isManual: true,
//   });
//   const [tempInsertIndex, setTempInsertIndex] = useState(null);
//   const [tempEditStopIndex, setTempEditStopIndex] = useState(null);

//   const [newRoute, setNewRoute] = useState({
//     masterRouteName: "",
//     description: "",
//     via: [],

//     upOriginCity: "",
//     upOriginState: "",
//     upOriginAddress: "",
//     upOriginTerminal: "",
//     upOriginCoords: null,
//     upDestCity: "",
//     upDestState: "",
//     upDestAddress: "",
//     upDestTerminal: "",
//     upDestCoords: null,
//     upTotalDistance: "",
//     upDurationHours: "",
//     upDurationMinutes: "",

//     upManualFirstLeg: "",
//     downManualFirstLeg: "",

//     upManualFinalLeg: "",
//     downManualFinalLeg: "",

//     destManualDistFromLastStop: "",

//     downTotalDistance: "",
//     downDurationHours: "",
//     downDurationMinutes: "",

//     stopCity: "",
//     stopState: "",
//     stopAddress: "",
//     stopTerminal: "",
//     stopCoords: null,
//     stopDistFromPrev: "",
//     stopDistToNext: "",
//   });

//   const [viaInput, setViaInput] = useState("");

//   const addEditViaCity = () => {
//     if (!editViaInput.trim()) {
//       toast.error("Please enter a via city name");
//       return;
//     }

//     const newVia = {
//       city: editViaInput.trim(),
//       state: "",
//       sequence: (editForm.via?.length || 0) + 1,
//     };

//     setEditForm((prev) => ({
//       ...prev,
//       via: [...(prev.via || []), newVia],
//     }));
//     setEditViaInput("");
//   };

//   const removeEditViaCity = (index) => {
//     const updatedVia = (editForm.via || []).filter((_, i) => i !== index);
//     const resequencedVia = updatedVia.map((item, idx) => ({
//       ...item,
//       sequence: idx + 1,
//     }));

//     setEditForm((prev) => ({
//       ...prev,
//       via: resequencedVia,
//     }));
//   };

//   const updateEditViaCity = (index, field, value) => {
//     const updatedVia = [...(editForm.via || [])];
//     updatedVia[index] = { ...updatedVia[index], [field]: value };
//     setEditForm((prev) => ({
//       ...prev,
//       via: updatedVia,
//     }));
//   };

//   const addViaCity = () => {
//     if (!viaInput.trim()) {
//       toast.error("Please enter a via city name");
//       return;
//     }

//     const newVia = {
//       city: viaInput.trim(),
//       state: "",
//       sequence: newRoute.via.length + 1,
//     };

//     setNewRoute((prev) => ({
//       ...prev,
//       via: [...prev.via, newVia],
//     }));
//     setViaInput("");
//   };

//   const removeViaCity = (index) => {
//     const updatedVia = newRoute.via.filter((_, i) => i !== index);
//     const resequencedVia = updatedVia.map((item, idx) => ({
//       ...item,
//       sequence: idx + 1,
//     }));

//     setNewRoute((prev) => ({
//       ...prev,
//       via: resequencedVia,
//     }));
//   };

//   const updateViaCity = (index, field, value) => {
//     const updatedVia = [...newRoute.via];
//     updatedVia[index] = { ...updatedVia[index], [field]: value };
//     setNewRoute((prev) => ({
//       ...prev,
//       via: updatedVia,
//     }));
//   };
// const formatDistance = (value) => {
//   if (value === null || value === undefined || value === '') return '';
//   const num = parseFloat(value);
//   if (isNaN(num)) return '';
//   return parseFloat(num.toFixed(2));
// };

//   const upTotalDistance = parseFloat(newRoute.upTotalDistance);
//   const checkOriginManual = () => {
//     return (
//       isOriginManual ||
//       !newRoute.upOriginCoords ||
//       (newRoute.upOriginCoords.lat === 0 && newRoute.upOriginCoords.lng === 0)
//     );
//   };

//   const checkDestinationManual = () => {
//     return (
//       isDestinationManual ||
//       !newRoute.upDestCoords ||
//       (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0)
//     );
//   };

//   const toProperCase = (str) => {
//     if (!str || typeof str !== "string") return str;
//     return str
//       .toLowerCase()
//       .split(" ")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(" ");
//   };

//   const [upStops, setUpStops] = useState([]);
//   const [downStops, setDownStops] = useState([]);
//   const [editingStopIndex, setEditingStopIndex] = useState(null);
//   const [insertIndex, setInsertIndex] = useState(null);
//   const [isCreatingRoute, setIsCreatingRoute] = useState(false);
//   const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
//   const [isDistanceCalculated, setIsDistanceCalculated] = useState({
//     up: false,
//     down: false,
//   });
//   const [activeTab, setActiveTab] = useState("basic");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRoutes, setTotalRoutes] = useState(0);
//   const [pageSize] = useState(10);

//   const [selectedMasterRoute, setSelectedMasterRoute] = useState(null);

//   const CitySearchDropdown = ({
//     value,
//     onChange,
//     onSelect,
//     token,
//     activeRouteTab,
//     placeholder = "Type city name (min 2 characters)...",
//   }) => {
//     const [suggestions, setSuggestions] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const timeoutRef = useRef(null);

//     const search = async (q) => {
//       if (q.length < 2) {
//         setSuggestions([]);
//         setShowDropdown(false);
//         return;
//       }
//       setIsLoading(true);
//       try {
//         const fn =
//           activeRouteTab === "UP"
//             ? searchRouteIntermediateStops
//             : searchRouteIntermediateStops;
//         const res = await fn(token, q);
//         if (res.success && res.cities) {
//           setSuggestions(res.cities);
//           setShowDropdown(res.cities.length > 0);
//         } else {
//           setSuggestions([]);
//           setShowDropdown(false);
//         }
//       } catch (e) {
//         console.error("City search error:", e);
//         setSuggestions([]);
//         setShowDropdown(false);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     const handleChange = (e) => {
//       const val = e.target.value;
//       onChange(val);
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//       timeoutRef.current = setTimeout(() => search(val), 500);
//     };

//     const handleSelect = (city) => {
//       onSelect(city);
//       setSuggestions([]);
//       setShowDropdown(false);
//     };

//     useEffect(
//       () => () => {
//         if (timeoutRef.current) clearTimeout(timeoutRef.current);
//       },
//       [],
//     );

//     return (
//       <div style={{ position: "relative" }}>
//         <input
//           type="text"
//           value={value}
//           onChange={handleChange}
//           onFocus={() => suggestions.length > 0 && setShowDropdown(true)}
//           onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
//           placeholder={placeholder}
//           className="form-input"
//         />
//         {isLoading && (
//           <div
//             style={{
//               position: "absolute",
//               right: 10,
//               top: "50%",
//               transform: "translateY(-50%)",
//             }}
//           >
//             <div className="spinner-small"></div>
//           </div>
//         )}
//         {showDropdown && suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               top: "100%",
//               left: 0,
//               right: 0,
//               backgroundColor: "white",
//               border: "1px solid #ddd",
//               borderRadius: "4px",
//               maxHeight: "200px",
//               overflowY: "auto",
//               zIndex: 2000,
//               boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//             }}
//           >
//             {suggestions.map((city, idx) => (
//               <div
//                 key={city.id || idx}
//                 onMouseDown={() => handleSelect(city)}
//                 style={{
//                   padding: "10px 12px",
//                   cursor: "pointer",
//                   borderBottom: "1px solid #f0f0f0",
//                 }}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.backgroundColor = "#f0f7ff")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.backgroundColor = "white")
//                 }
//               >
//                 <div style={{ fontWeight: "500" }}>{city.name}</div>
//                 <div style={{ fontSize: "12px", color: "#6c757d" }}>
//                   {city.state}
//                   {city.terminal ? ` • ${city.terminal}` : ""}
//                 </div>
//                 {city.address && city.address !== city.name && (
//                   <div
//                     style={{
//                       fontSize: "11px",
//                       color: "#999",
//                       marginTop: "2px",
//                     }}
//                   >
//                     {city.address}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   const isNextStopAuto = (currentIndex) => {
//     const stops = getActiveStops();
//     const nextStop = stops[currentIndex + 1];
//     return (
//       nextStop &&
//       nextStop.coordinates &&
//       (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0)
//     );
//   };

//   const getDefaultStateForStop = (upStops, newRoute, activeRouteTab) => {
//     if (activeRouteTab === "UP") {
//       if (upStops.length > 0) {
//         const lastStop = upStops[upStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           return lastStop.state;
//         }
//       }
//       if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
//         return newRoute.upOriginState;
//       }
//       if (newRoute.upDestState && newRoute.upDestState.trim()) {
//         return newRoute.upDestState;
//       }
//     } else if (activeRouteTab === "DOWN") {
//       const downStops = getActiveStops();
//       if (downStops.length > 0) {
//         const lastStop = downStops[downStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           return lastStop.state;
//         }
//       }
//       if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
//         return newRoute.upOriginState;
//       }
//       if (newRoute.upDestState && newRoute.upDestState.trim()) {
//         return newRoute.upDestState;
//       }
//     }
//     return "";
//   };

//   const handleCitySearch = async (value) => {
//     console.log("Searching for:", value);
//     console.log("Active route tab:", activeRouteTab);

//     try {
//       const searchFn =
//         activeRouteTab === "UP"
//           ? searchRouteIntermediateStops
//           : searchRouteIntermediateStops;

//       console.log("Using search function:", searchFn.name);
//       const response = await searchFn(token, value);
//       console.log("API Response:", response);

//       if (response.success && response.cities) {
//         console.log("Found cities:", response.cities);
//         setCitySuggestions(response.cities);
//         setShowCityDropdown(true);
//       }
//     } catch (error) {
//       console.error("Search error details:", error);
//       console.error("Error response:", error.response);
//     }
//   };

//   const isFirstStopManual = () => {
//     const stops = getActiveStops();
//     if (stops.length === 0) return false;
//     const firstStop = stops[0];
//     return (
//       !firstStop.coordinates ||
//       (firstStop.coordinates.lat === 0 && firstStop.coordinates.lng === 0) ||
//       firstStop.isManualStop === true
//     );
//   };
// const handleOriginCitySelect = (cityObj) => {
//   setNewRoute((prev) => ({
//     ...prev,
//     upOriginCity: cityObj.city,
//     upOriginState: cityObj.state,
//     upOriginAddress: cityObj.address,
//     upOriginTerminal: cityObj.terminal,
//     upOriginCoords: cityObj.coordinates || null,
//   }));
//   const hasGPS =
//     cityObj.coordinates &&
//     (cityObj.coordinates.lat !== 0 || cityObj.coordinates.lng !== 0);
//   setIsOriginManual(!hasGPS);
//   setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
// };

// const handleDestCitySelect = (cityObj) => {
//   setNewRoute((prev) => ({
//     ...prev,
//     upDestCity: cityObj.city,
//     upDestState: cityObj.state,
//     upDestAddress: cityObj.address,
//     upDestTerminal: cityObj.terminal,
//     upDestCoords: cityObj.coordinates || null,
//   }));
//   const hasGPS =
//     cityObj.coordinates &&
//     (cityObj.coordinates.lat !== 0 || cityObj.coordinates.lng !== 0);
//   setIsDestinationManual(!hasGPS);
//   setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
// };

// const handleEditOriginCitySelect = (cityObj) => {
//   setEditForm((prev) => ({
//     ...prev,
//     originCity: cityObj.city,
//     originState: cityObj.state,
//     originAddress: cityObj.address,
//     originTerminal: cityObj.terminal,
//     originCoords: cityObj.coordinates || { lat: 0, lng: 0 },
//   }));
// };

// const handleEditDestCitySelect = (cityObj) => {
//   setEditForm((prev) => ({
//     ...prev,
//     destCity: cityObj.city,
//     destState: cityObj.state,
//     destAddress: cityObj.address,
//     destTerminal: cityObj.terminal,
//     destCoords: cityObj.coordinates || { lat: 0, lng: 0 },
//   }));
// };

//   const isLastStopManual = () => {
//     const stops = getActiveStops();
//     if (stops.length === 0) return false;
//     const lastStop = stops[stops.length - 1];
//     return (
//       !lastStop.coordinates ||
//       (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0) ||
//       lastStop.isManualStop === true
//     );
//   };
//   const syncDestinationDistance = (value, source) => {
//     if (source === "upManualFinalLeg") {
//       setNewRoute((prev) => ({
//         ...prev,
//         upManualFinalLeg: value,
//         destManualDistFromLastStop: !checkDestinationManual()
//           ? value
//           : prev.destManualDistFromLastStop,
//       }));
//     } else if (source === "destManualDistFromLastStop") {
//       setNewRoute((prev) => ({
//         ...prev,
//         destManualDistFromLastStop: value,
//         upManualFinalLeg: checkDestinationManual()
//           ? value
//           : prev.upManualFinalLeg,
//       }));
//     }
//   };

//   const autoFillFromMasterRoute = (masterRoute) => {
//     if (!masterRoute) return;

//     console.log("Auto-filling from master route:", masterRoute);

//     setSelectedMasterRoute(masterRoute);

//     if (masterRoute.isManual) {
//       setNewRoute((prev) => ({
//         ...prev,
//         masterRouteName: masterRoute.masterRouteName,
//         via: masterRoute.via || [],
//       }));
//       return;
//     }

//     setNewRoute((prev) => ({
//       ...prev,
//       masterRouteName: masterRoute.masterRouteName,
//       description: masterRoute.description || "",
//       via: masterRoute.via || [],
//     }));
//     if (masterRoute.origin) {
//       setNewRoute((prev) => ({
//         ...prev,
//         upOriginCity: masterRoute.origin.city || "",
//         upOriginState: masterRoute.origin.state || "",
//         upOriginAddress:
//           masterRoute.origin.address ||
//           `${masterRoute.origin.city || ""}, ${masterRoute.origin.state || "India"}`,
//         upOriginTerminal:
//           masterRoute.origin.terminal ||
//           `${masterRoute.origin.city || ""} Bus Stand`,
//         upOriginCoords: masterRoute.origin.coordinates || null,
//       }));

//       const hasValidCoords =
//         masterRoute.origin.coordinates &&
//         (masterRoute.origin.coordinates.lat !== 0 ||
//           masterRoute.origin.coordinates.lng !== 0);
//       setIsOriginManual(!hasValidCoords);
//     }

//     if (masterRoute.destination) {
//       setNewRoute((prev) => ({
//         ...prev,
//         upDestCity: masterRoute.destination.city || "",
//         upDestState: masterRoute.destination.state || "",
//         upDestAddress:
//           masterRoute.destination.address ||
//           `${masterRoute.destination.city || ""}, ${masterRoute.destination.state || "India"}`,
//         upDestTerminal:
//           masterRoute.destination.terminal ||
//           `${masterRoute.destination.city || ""} Bus Stand`,
//         upDestCoords: masterRoute.destination.coordinates || null,
//         upTotalDistance: masterRoute.routeDetails?.totalDistance || "",
//         upDurationHours:
//           masterRoute.routeDetails?.estimatedDuration?.hours || "",
//         upDurationMinutes:
//           masterRoute.routeDetails?.estimatedDuration?.minutes || "",
//       }));

//       const hasValidCoords =
//         masterRoute.destination.coordinates &&
//         (masterRoute.destination.coordinates.lat !== 0 ||
//           masterRoute.destination.coordinates.lng !== 0);
//       setIsDestinationManual(!hasValidCoords);
//     }

//     let lastStopToDestinationDistance = 0;
//     const upTotalDist =
//       parseFloat(masterRoute.routeDetails?.totalDistance) || 0;

//     if (masterRoute.intermediateStops &&
//     masterRoute.intermediateStops.length > 0) {
//       const lastStopDistance =
//         masterRoute.intermediateStops[masterRoute.intermediateStops.length - 1]
//           .distanceFromOrigin || 0;
//       lastStopToDestinationDistance = formatDistance(upTotalDist - lastStopDistance);
//       if (lastStopToDestinationDistance < 0) lastStopToDestinationDistance = 0;
//     } else if (upTotalDist > 0) {
//       lastStopToDestinationDistance = upTotalDist;
//     }

//     const isDestManualLocal =
//       isDestinationManual ||
//       !masterRoute.destination?.coordinates ||
//       (masterRoute.destination.coordinates.lat === 0 &&
//         masterRoute.destination.coordinates.lng === 0);

//     if (isDestManualLocal) {
//       setNewRoute((prev) => ({
//         ...prev,
//         upManualFinalLeg:
//           lastStopToDestinationDistance > 0
//             ? lastStopToDestinationDistance.toFixed(1)
//             : "",
//       }));
//     } else if (
//       masterRoute.intermediateStops &&
//       masterRoute.intermediateStops.length > 0
//     ) {
//       const lastStop =
//         masterRoute.intermediateStops[masterRoute.intermediateStops.length - 1];
//       const isLastStopManual =
//         !lastStop.coordinates ||
//         (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0);

//       if (isLastStopManual) {
//         setNewRoute((prev) => ({
//           ...prev,
//           destManualDistFromLastStop:
//             lastStopToDestinationDistance > 0
//               ? lastStopToDestinationDistance.toFixed(1)
//               : "",
//         }));
//       }
//     }

//     if (masterRoute.intermediateStops &&
//     masterRoute.intermediateStops.length > 0) {
//       const transformedUpStops = masterRoute.intermediateStops.map(
//         (stop, index, array) => {
//           const isManualStop =
//             !stop.coordinates ||
//             (stop.coordinates.lat === 0 && stop.coordinates.lng === 0) ||
//             stop.isManualStop === true;

//           let distanceFromPrev = null;
//           const currentDistance = stop.distanceFromOrigin || 0;

//           if (index === 0) {
//             const originDistance = masterRoute.origin?.distanceFromOrigin || 0;
//             distanceFromPrev = currentDistance - originDistance;
//           } else {
//             const prevDistance = array[index - 1].distanceFromOrigin || 0;
//             distanceFromPrev = currentDistance - prevDistance;
//           }

//           if (distanceFromPrev > 0) {
//             distanceFromPrev = parseFloat(distanceFromPrev.toFixed(1));
//           }

//           return {
//             sequence: index + 1,
//             city: stop.city || "",
//             state: stop.state || "",
//             address:
//               stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
//             terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
//             stopType: stop.stopType || "none",
//             coordinates: stop.coordinates || { lat: 0, lng: 0 },
//             distanceFromOrigin: currentDistance,
//             manualDistFromPrev: formatDistance(distanceFromPrev),
//             manualDistToNext: stop.manualDistToNext || null,
//             isManualStop: isManualStop,
//           };
//         },
//       );
//       setUpStops(transformedUpStops);

//       console.log(
//         "Calculated segment distances:",
//         transformedUpStops.map((s) => ({
//           city: s.city,
//           distanceFromOrigin: s.distanceFromOrigin,
//           distanceFromPrev: s.manualDistFromPrev,
//         })),
//       );
//       console.log(
//         "Last stop to destination distance:",
//         lastStopToDestinationDistance,
//       );

//       const allHaveDistances = transformedUpStops.every(
//         (stop) => stop.distanceFromOrigin > 0,
//       );
//       setIsDistanceCalculated((prev) => ({ ...prev, up: allHaveDistances }));
//     } else {
//       setUpStops([]);
//       setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
//     }

//     if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
//       setIsRoundTrip(true);
//       setActiveRouteTab("UP");

//       const returnJourney = masterRoute.returnJourney;

//       if (returnJourney.routeDetails) {
//         const returnTotalDist = returnJourney.routeDetails.totalDistance || 0;

//         setNewRoute((prev) => ({
//           ...prev,
//           downTotalDistance: returnTotalDist,
//           downDurationHours:
//             returnJourney.routeDetails.estimatedDuration?.hours || "",
//           downDurationMinutes:
//             returnJourney.routeDetails.estimatedDuration?.minutes || "",
//         }));

//         let returnLastStopToDestDistance = 0;
//         if (
//           returnJourney.intermediateStops &&
//           returnJourney.intermediateStops.length > 0
//         ) {
//           const returnLastStopDistance =
//             returnJourney.intermediateStops[
//               returnJourney.intermediateStops.length - 1
//             ].distanceFromOrigin || 0;
//           returnLastStopToDestDistance =
//             parseFloat(returnTotalDist) - returnLastStopDistance;
//           if (returnLastStopToDestDistance < 0)
//             returnLastStopToDestDistance = 0;

//           setNewRoute((prev) => ({
//             ...prev,
//             downManualFinalLeg:
//               returnLastStopToDestDistance > 0
//                 ? returnLastStopToDestDistance.toFixed(1)
//                 : "",
//           }));
//         }
//       }

//       if (returnJourney.intermediateStops &&
//       returnJourney.intermediateStops.length > 0) {
//         const transformedDownStops = returnJourney.intermediateStops.map(
//           (stop, index, array) => {
//             const isManualStop =
//               !stop.coordinates ||
//               (stop.coordinates.lat === 0 && stop.coordinates.lng === 0) ||
//               stop.isManualStop === true;

//             let distanceFromPrev = null;
//             const currentDistance = stop.distanceFromOrigin || 0;

//             if (index === 0) {
//               const returnOriginDistance =
//                 returnJourney.origin?.distanceFromOrigin || 0;
//               distanceFromPrev = currentDistance - returnOriginDistance;
//             } else {
//               const prevDistance = array[index - 1].distanceFromOrigin || 0;
//               distanceFromPrev = currentDistance - prevDistance;
//             }

//             if (distanceFromPrev > 0) {
//               distanceFromPrev = parseFloat(distanceFromPrev.toFixed(1));
//             }

//             return {
//               sequence: index + 1,
//               city: stop.city || "",
//               state: stop.state || "",
//               address:
//                 stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
//               terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
//               stopType: stop.stopType || "none",
//               coordinates: stop.coordinates || { lat: 0, lng: 0 },
//               distanceFromOrigin: currentDistance,
//               manualDistFromPrev: distanceFromPrev,
//               manualDistToNext: stop.manualDistToNext || null,
//               isManualStop: isManualStop,
//             };
//           },
//         );
//         setDownStops(transformedDownStops);

//         const allHaveDistances = transformedDownStops.every(
//           (stop) => stop.distanceFromOrigin > 0,
//         );
//         setIsDistanceCalculated((prev) => ({
//           ...prev,
//           down: allHaveDistances,
//         }));
//       } else {
//         setDownStops([]);
//         setIsDistanceCalculated((prev) => ({ ...prev, down: false }));
//       }
//     } else {
//       setIsRoundTrip(false);
//       setDownStops([]);
//       setIsDistanceCalculated((prev) => ({ ...prev, down: false }));
//     }

//     toast.success(
//       `Master route "${masterRoute.masterRouteName}" loaded successfully! Segment distances calculated from cumulative distances.`,
//     );
//   };

//   const formatDuration = (hours, minutes) => {
//     if (!hours && !minutes) return "N/A";
//     const parts = [];
//     if (hours) parts.push(`${hours}h`);
//     if (minutes) parts.push(`${minutes}m`);
//     return parts.join(" ");
//   };

//   const handleSelectOrigin = (location) => {
//     setNewRoute((prev) => ({
//       ...prev,
//       upOriginCity: location.city || location.name || "",
//       upOriginState: location.state || "",
//       upOriginAddress: location.address || "",
//       upOriginCoords: location.coordinates || { lat: 0, lng: 0 },
//     }));
//     setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
//   };

//   const handleSelectDest = (location) => {
//     setNewRoute((prev) => ({
//       ...prev,
//       upDestCity: location.city || location.name || "",
//       upDestState: location.state || "",
//       upDestAddress: location.address || "",
//       upDestCoords: location.coordinates || { lat: 0, lng: 0 },
//     }));
//     setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
//   };

//   const handleSelectStop = (location) => {
//     let autoState = location.state || "";

//     if (!autoState && activeRouteTab === "UP") {
//       if (upStops.length > 0) {
//         const lastStop = upStops[upStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           autoState = lastStop.state;
//         }
//       }
//       if (
//         !autoState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         autoState = newRoute.upOriginState;
//       }
//     } else if (!autoState && activeRouteTab === "DOWN") {
//       if (downStops.length > 0) {
//         const lastStop = downStops[downStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           autoState = lastStop.state;
//         }
//       }
//       if (
//         !autoState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         autoState = newRoute.upOriginState;
//       }
//     }

//     setNewRoute((prev) => ({
//       ...prev,
//       stopCity: location.city || location.name || "",
//       stopState: autoState,
//       stopAddress: location.address || "",
//       stopCoords: location.coordinates || { lat: 0, lng: 0 },
//     }));
//     setIsManualStop(true);
//   };

//   const handleStopEditLocationSelect = (location) => {
//     setStopEditForm((prev) => ({
//       ...prev,
//       city: location.city || location.name || "",
//       state: location.state || "",
//       address: location.address || "",
//       isManualStop: false,
//     }));
//   };

//   const saveEditedStop = () => {
//     if (!stopEditForm.city) {
//       toast.error("City is required");
//       return;
//     }

//     const isManualLocation = stopEditForm.isManualStop;

//     if (isManualLocation &&
//     (!stopEditForm.manualDistFromPrev ||
//       parseFloat(stopEditForm.manualDistFromPrev) <= 0)) {
//       toast.error(
//         "For manual stops, please provide distance from previous stop",
//       );
//       return;
//     }

//     const stopAddress =
//       stopEditForm.address ||
//       `${stopEditForm.city}, ${stopEditForm.state || "India"}`;

//     const updatedStop = {
//       city: stopEditForm.city,
//       state: stopEditForm.state || "",
//       address: stopAddress,
//       terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
//       stopType: stopEditForm.stopType,
//       coordinates: isManualLocation
//         ? { lat: 0, lng: 0 }
//         : stopBeingEdited.originalStop.coordinates,
//       manualDistFromPrev: isManualLocation
//         ? formatDistance(stopEditForm.manualDistFromPrev)
//         : null,
//       manualDistToNext: stopEditForm.manualDistToNext
//         ? formatDistance(stopEditForm.manualDistToNext)
//         : null,
//       distanceFromOrigin: formatDistance(stopBeingEdited.originalStop.distanceFromOrigin || 0),
//       isManualStop: isManualLocation,
//     };

//     const { index, type } = stopBeingEdited;
//     setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

//     if (type === "up") {
//       const updatedStops = [...upStops];
//       updatedStops[index] = updatedStop;
//       setUpStops(updatedStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     } else {
//       const updatedStops = [...downStops];
//       updatedStops[index] = updatedStop;
//       setDownStops(updatedStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     }

//     setShowStopEditModal(false);
//     setStopBeingEdited(null);
//     setStopEditForm({
//       city: "",
//       state: "",
//       address: "",
//       terminal: "",
//       stopType: "none",
//       manualDistFromPrev: "",
//       manualDistToNext: "",
//       isManualStop: false,
//     });

//     toast.success("Stop updated successfully");
//   };

//   const validateRouteDistances = (stops, totalDistance, routeName = "") => {
//     if (!stops.length) return true;

//     let lastDistance = 0;

//     for (let i = 0; i < stops.length; i++) {
//       const stop = stops[i];
//       const stopDistance = parseFloat(stop.distanceFromOrigin);

//       if (isNaN(stopDistance)) {
//         toast.error(
//           `${routeName} Stop "${stop.city}" has invalid distance value`,
//         );
//         return false;
//       }

//       if (stopDistance < 0) {
//         toast.error(
//           `${routeName} Stop "${stop.city}" distance cannot be negative`,
//         );
//         return false;
//       }

//       if (stopDistance <= lastDistance && i > 0) {
//         toast.error(
//           `${routeName} Stop distances must be in increasing order. Check "${stop.city}"`,
//         );
//         return false;
//       }

//       lastDistance = stopDistance;
//     }

//     return true;
//   };

//   const syncDownStopsWithUpStops = (forcePrompt = false) => {
//     const hasManualStops = upStops.some(
//       (s) =>
//         !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
//     );

//     if (forcePrompt && !isDistanceCalculated.up && hasManualStops) {
//       toast.warning(
//         "Please calculate distances for UP route before syncing the return route.",
//       );
//       return;
//     }

//     const doSync = () => {
//       const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;

//       const upPoints = [];

//       upPoints.push({
//         city: newRoute.upOriginCity,
//         state: newRoute.upOriginState,
//         address: newRoute.upOriginAddress,
//         terminal: newRoute.upOriginTerminal,
//         cumulativeDistance: 0,
//         coordinates: newRoute.upOriginCoords,
//         stopType: "origin",
//         isManualStop: checkOriginManual(),
//       });

//       upStops.forEach((stop, idx) => {
//         upPoints.push({
//           city: stop.city,
//           state: stop.state,
//           address: stop.address,
//           terminal: stop.terminal,
//           cumulativeDistance: stop.distanceFromOrigin || 0,
//           coordinates: stop.coordinates,
//           stopType: stop.stopType,
//           isManualStop: stop.isManualStop,
//         });
//       });

//       upPoints.push({
//         city: newRoute.upDestCity,
//         state: newRoute.upDestState,
//         address: newRoute.upDestAddress,
//         terminal: newRoute.upDestTerminal,
//         cumulativeDistance: upTotalDist,
//         coordinates: newRoute.upDestCoords,
//         stopType: "destination",
//         isManualStop: checkDestinationManual(),
//       });

//       const downPoints = [...upPoints].reverse();

//       const reversedStopsWithDistances = [];

//       for (let i = 0; i < downPoints.length; i++) {
//         const point = downPoints[i];

//         const downCumulativeDistance = upTotalDist - point.cumulativeDistance;

//         point.downCumulativeDistance = downCumulativeDistance;
//       }

//       for (let i = 1; i < downPoints.length - 1; i++) {
//         const point = downPoints[i];

//         const prevPoint = downPoints[i - 1];
//         const segmentDistance =
//           point.downCumulativeDistance - prevPoint.downCumulativeDistance;

//         let newStopType = point.stopType;
//         if (point.stopType === "boarding") {
//           newStopType = "dropping";
//         } else if (point.stopType === "dropping") {
//           newStopType = "boarding";
//         } else if (point.stopType === "both") {
//           newStopType = "both";
//         } else if (
//           point.stopType === "origin" ||
//           point.stopType === "destination"
//         ) {
//           newStopType = "none";
//         }

//         reversedStopsWithDistances.push({
//           city: point.city,
//           state: point.state || "",
//           address:
//             point.address || `${point.city || ""}, ${point.state || "India"}`,
//           terminal: point.terminal || `${point.city || ""} Bus Stand`,
//           stopType: newStopType,
//           coordinates: point.coordinates || { lat: 0, lng: 0 },
//           sequence: i,
//           distanceFromOrigin: parseFloat(
//             point.downCumulativeDistance.toFixed(1),
//           ),
//           manualDistFromPrev:
//             segmentDistance > 0 ? formatDistance(segmentDistance) : null,
//           manualDistToNext: null,
//           isManualStop: point.isManualStop,
//         });
//       }

//       const downTotalDistance = upTotalDist;

//       console.log("DOWN stops created:", reversedStopsWithDistances);
//       console.log("DOWN total distance:", downTotalDistance);

//       setDownStops(reversedStopsWithDistances);
//       setNewRoute((prev) => ({
//         ...prev,
//         downTotalDistance: downTotalDistance.toFixed(1),
//       }));

//       if (editingRoute) {
//         setEditForm((prev) => ({
//           ...prev,
//           returnTotalDistance: downTotalDistance.toFixed(1),
//         }));
//       }

//       setIsDistanceCalculated((prev) => ({ ...prev, down: false }));

//       toast.success(
//         `DOWN route populated with ${reversedStopsWithDistances.length} stops. Cumulative distances: ${reversedStopsWithDistances.map((s) => `${s.city}(${s.distanceFromOrigin}km)`).join(", ")}`,
//       );
//     };

//     if (forcePrompt && downStops.length > 0) {
//       if (
//         window.confirm(
//           "This will update your Return Route stops based on your Main Route. Proceed?",
//         )
//       ) {
//         doSync();
//       }
//     } else {
//       doSync();
//     }
//   };

//   const toggleRoundTrip = () => {
//     const newVal = !isRoundTrip;
//     setIsRoundTrip(newVal);

//     if (newVal) {
//       if (downStops.length === 0 && upStops.length > 0) {
//         const reversed = [...upStops].reverse().map((s, idx) => {
//           let newStopType = s.stopType;
//           if (s.stopType === "boarding") {
//             newStopType = "dropping";
//           } else if (s.stopType === "dropping") {
//             newStopType = "boarding";
//           }

//           return {
//             city: s.city,
//             state: s.state || "",
//             address: s.address || "",
//             terminal: s.terminal || "",
//             stopType: newStopType,
//             coordinates: s.coordinates || { lat: 0, lng: 0 },
//             sequence: idx + 1,
//             manualDistFromPrev: s.manualDistToNext || null,
//             manualDistToNext: s.manualDistFromPrev || null,
//             distanceFromOrigin: 0,
//           };
//         });
//         setDownStops(reversed);
//       }
//       setActiveRouteTab("DOWN");
//     } else {
//       setActiveRouteTab("UP");
//     }
//     clearStopForm();
//   };

//   const handleTabSwitch = (tab) => {
//     if (tab === "DOWN" && downStops.length === 0 && upStops.length > 0) {
//       syncDownStopsWithUpStops(false);
//     }
//     setActiveRouteTab(tab);
//     clearStopForm();
//   };

//   const getActiveStops = () => {
//     if (activeRouteTab === "UP") return upStops;
//     return downStops;
//   };
//   const setActiveStops = (stops) => {
//     if (activeRouteTab === "UP") {
//       setUpStops(stops);
//     } else {
//       setDownStops(stops);
//     }
//   };

//   const clearStopForm = () => {
//     let defaultState = "";

//     if (activeRouteTab === "UP") {
//       if (upStops.length > 0) {
//         const lastStop = upStops[upStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           defaultState = lastStop.state;
//         }
//       }
//       if (
//         !defaultState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         defaultState = newRoute.upOriginState;
//       }
//       if (
//         !defaultState &&
//         newRoute.upDestState &&
//         newRoute.upDestState.trim()
//       ) {
//         defaultState = newRoute.upDestState;
//       }
//     } else if (activeRouteTab === "DOWN") {
//       if (downStops.length > 0) {
//         const lastStop = downStops[downStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           defaultState = lastStop.state;
//         }
//       }
//       if (
//         !defaultState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         defaultState = newRoute.upOriginState;
//       }
//       if (
//         !defaultState &&
//         newRoute.upDestState &&
//         newRoute.upDestState.trim()
//       ) {
//         defaultState = newRoute.upDestState;
//       }
//     }

//     setNewRoute((prev) => ({
//       ...prev,
//       stopCity: "",
//       stopState: defaultState,
//       stopAddress: "",
//       stopTerminal: "",
//       stopCoords: null,
//       stopDistFromPrev: "",
//       stopDistToNext: "",
//       stopType: "none",
//     }));
//     setEditingStopIndex(null);
//     setInsertIndex(null);
//     setIsManualStop(true);

//     setTempStopForm({
//       city: "",
//       state: defaultState,
//       address: "",
//       terminal: "",
//       stopType: "none",
//       distFromPrev: "",
//       distToNext: "",
//       isManual: false,
//     });
//   };
//   const openAddStopModal = () => {
//     let defaultState = "";

//     if (activeRouteTab === "UP") {
//       if (upStops.length > 0) {
//         const lastStop = upStops[upStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           defaultState = lastStop.state;
//         }
//       }
//       if (
//         !defaultState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         defaultState = newRoute.upOriginState;
//       }
//     } else {
//       if (downStops.length > 0) {
//         const lastStop = downStops[downStops.length - 1];
//         if (lastStop.state && lastStop.state.trim()) {
//           defaultState = lastStop.state;
//         }
//       }
//       if (
//         !defaultState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         defaultState = newRoute.upOriginState;
//       }
//     }

//     setTempStopForm({
//       city: "",
//       state: defaultState,
//       address: "",
//       terminal: "",
//       stopType: "none",
//       distFromPrev: "",
//       distToNext: "",
//       isManual: true,
//     });
//     setStopModalMode("add");
//     setTempInsertIndex(null);
//     setTempEditStopIndex(null);
//     setShowStopModal(true);
//   };

//   const saveInlineInsert = () => {
//     if (!inlineInsertForm.city) {
//       toast.error("City is required");
//       return;
//     }
//     if (
//       inlineInsertForm.isManual &&
//       (!inlineInsertForm.distFromPrev ||
//         parseFloat(inlineInsertForm.distFromPrev) <= 0)
//     ) {
//       toast.error("Distance from previous stop is required");
//       return;
//     }

//     const type = activeRouteTab === "UP" ? "up" : "down";
//     const currentStops = type === "up" ? [...upStops] : [...downStops];

//     const manualDistFromPrev = inlineInsertForm.isManual
//       ? formatDistance(parseFloat(inlineInsertForm.distFromPrev))
//       : null;
//     const manualDistToNext = inlineInsertForm.distToNext
//       ? formatDistance(parseFloat(inlineInsertForm.distToNext))
//       : null;

//     let distanceFromOrigin = 0;
//     if (inlineInsertIndex > 0 && currentStops[inlineInsertIndex - 1]) {
//       distanceFromOrigin =
//         (currentStops[inlineInsertIndex - 1].distanceFromOrigin || 0) +
//         (manualDistFromPrev || 0);
//     } else {
//       distanceFromOrigin = manualDistFromPrev || 0;
//     }

//     const newStop = {
//       city: inlineInsertForm.city,
//       state: inlineInsertForm.state || "",
//       address:
//         inlineInsertForm.address ||
//         `${inlineInsertForm.city}, ${inlineInsertForm.state || "India"}`,
//       terminal:
//         inlineInsertForm.terminal || `${inlineInsertForm.city} Bus Stand`,
//       stopType: inlineInsertForm.stopType,
//       coordinates: inlineInsertForm.isManual ? { lat: 0, lng: 0 } : null,
//       manualDistFromPrev,
//       manualDistToNext,
//     distanceFromOrigin: formatDistance(distanceFromOrigin),
//       isManualStop: inlineInsertForm.isManual,
//     };

//     currentStops.splice(inlineInsertIndex, 0, newStop);
//     setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

//     if (type === "up")
//       setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     else setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));

//     toast.success(
//       `Stop "${inlineInsertForm.city}" inserted at position ${inlineInsertIndex + 1}`,
//     );
//     setInlineInsertIndex(null);
//     setInlineInsertCitySuggestions([]);
//     setShowInlineInsertDropdown(false);
//   };

//   const openInsertStopModal = (index) => {
//     let defaultState = "";

//     if (activeRouteTab === "UP") {
//       if (upStops.length > 0 && index > 0) {
//         const prevStop = upStops[index - 1];
//         if (prevStop.state && prevStop.state.trim()) {
//           defaultState = prevStop.state;
//         }
//       }
//       if (
//         !defaultState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         defaultState = newRoute.upOriginState;
//       }
//     } else {
//       if (downStops.length > 0 && index > 0) {
//         const prevStop = downStops[index - 1];
//         if (prevStop.state && prevStop.state.trim()) {
//           defaultState = prevStop.state;
//         }
//       }
//       if (
//         !defaultState &&
//         newRoute.upOriginState &&
//         newRoute.upOriginState.trim()
//       ) {
//         defaultState = newRoute.upOriginState;
//       }
//     }

//     setTempStopForm({
//       city: "",
//       state: defaultState,
//       address: "",
//       terminal: "",
//       stopType: "none",
//       distFromPrev: "",
//       distToNext: "",
//       isManual: false,
//     });
//     setStopModalMode("insert");
//     setTempInsertIndex(index);
//     setTempEditStopIndex(null);
//     setShowStopModal(true);
//   };

//   const openEditStopModal = (index, type = "up") => {
//     const stop = type === "up" ? upStops[index] : downStops[index];
//     const isManual =
//       !stop.coordinates ||
//       (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

//     setTempStopForm({
//       city: stop.city || "",
//       state: stop.state || "",
//       address: stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
//       terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
//       stopType: stop.stopType || "none",
//       distFromPrev: stop.manualDistFromPrev
//         ? String(stop.manualDistFromPrev)
//         : "",
//       distToNext: stop.manualDistToNext ? String(stop.manualDistToNext) : "",
//       isManual:
//         isManual ||
//         (stop.manualDistFromPrev !== null &&
//           stop.manualDistFromPrev !== undefined),
//     });
//     setStopModalMode("edit");
//     setTempInsertIndex(null);
//     setTempEditStopIndex({ index, type });
//     setShowStopModal(true);
//   };
//   const saveStopFromModal = () => {
//     if (!tempStopForm.city) {
//       toast.error("City is required");
//       return;
//     }

//     const isManualLocation = tempStopForm.isManual;

//     if (
//       isManualLocation &&
//       (!tempStopForm.distFromPrev || parseFloat(tempStopForm.distFromPrev) <= 0)
//     ) {
//       toast.error(
//         "For manual stops, please provide distance from previous stop",
//       );
//       return;
//     }

//     const type = activeRouteTab === "UP" ? "up" : "down";
//     let currentStops = type === "up" ? [...upStops] : [...downStops];

//     const stopAddress =
//       tempStopForm.address ||
//       `${tempStopForm.city}, ${tempStopForm.state || "India"}`;

//     let coordinates = null;
//     let manualDistFromPrev = null;
//     let manualDistToNext = null;
//     let distanceFromOrigin = 0;

//     if (isManualLocation) {
//       coordinates = { lat: 0, lng: 0 };
//       manualDistFromPrev = parseFloat(tempStopForm.distFromPrev);
//       if (tempStopForm.distToNext && parseFloat(tempStopForm.distToNext) > 0) {
//         manualDistToNext = parseFloat(tempStopForm.distToNext);
//       }
//     }

//     if (stopModalMode === "edit" && tempEditStopIndex) {
//       const editIndex = tempEditStopIndex.index;

//       if (editIndex === 0) {
//         distanceFromOrigin =
//           manualDistFromPrev || currentStops[editIndex].distanceFromOrigin;
//       } else {
//         const prevStop = currentStops[editIndex - 1];
//         const prevDistance = prevStop.distanceFromOrigin || 0;
//         distanceFromOrigin = prevDistance + (manualDistFromPrev || 0);
//       }

//       const updatedStop = {
//         ...currentStops[editIndex],
//         city: tempStopForm.city,
//         state: tempStopForm.state || "",
//         address: stopAddress,
//         terminal: tempStopForm.terminal || `${tempStopForm.city} Bus Stand`,
//         stopType: tempStopForm.stopType,
//         coordinates: coordinates,
//         manualDistFromPrev: manualDistFromPrev,
//         manualDistToNext: manualDistToNext,
// distanceFromOrigin: parseFloat(formatDistance(distanceFromOrigin).toFixed(2)),
//         isManualStop: isManualLocation,
//       };

//       currentStops[editIndex] = updatedStop;

//       for (let i = editIndex + 1; i < currentStops.length; i++) {
//         const prevStop = currentStops[i - 1];
//         const prevDistance = prevStop.distanceFromOrigin || 0;

//         if (currentStops[i].manualDistFromPrev &&
//         currentStops[i].manualDistFromPrev > 0) {
//           currentStops[i].distanceFromOrigin =
//             prevDistance + currentStops[i].manualDistFromPrev;
//         }
//       }

//       toast.success(`Stop "${tempStopForm.city}" updated successfully`);
//     } else {
//       const insertAtPosition =
//         stopModalMode === "insert" && tempInsertIndex !== null
//           ? tempInsertIndex
//           : currentStops.length;

//       if (insertAtPosition === 0) {
//         distanceFromOrigin = manualDistFromPrev || 0;
//       } else {
//         const prevStop = currentStops[insertAtPosition - 1];
//         const prevDistance = prevStop.distanceFromOrigin || 0;
//         distanceFromOrigin = prevDistance + (manualDistFromPrev || 0);
//       }

//       const newStop = {
//         city: tempStopForm.city,
//         state: tempStopForm.state || "",
//         address: stopAddress,
//         terminal: tempStopForm.terminal || `${tempStopForm.city} Bus Stand`,
//         stopType: tempStopForm.stopType,
//         coordinates: coordinates,
//         manualDistFromPrev: manualDistFromPrev,
//         manualDistToNext: manualDistToNext,
// distanceFromOrigin: parseFloat(formatDistance(distanceFromOrigin).toFixed(2)),
//         isManualStop: isManualLocation,
//       };

//       currentStops.splice(insertAtPosition, 0, newStop);

//       for (let i = insertAtPosition + 1; i < currentStops.length; i++) {
//         const prevStop = currentStops[i - 1];
//         const prevDistance = prevStop.distanceFromOrigin || 0;

//         if (
//           currentStops[i].manualDistFromPrev &&
//           currentStops[i].manualDistFromPrev > 0
//         ) {
//           currentStops[i].distanceFromOrigin =
//             prevDistance + currentStops[i].manualDistFromPrev;
//         } else if (currentStops[i].distanceFromOrigin > 0) {
//           currentStops[i].distanceFromOrigin =
//             prevDistance +
//             (currentStops[i].distanceFromOrigin -
//               (currentStops[insertAtPosition - 1]?.distanceFromOrigin || 0));
//         }
//       }

//       if (insertAtPosition + 1 < currentStops.length &&
//       currentStops[insertAtPosition + 1].manualDistFromPrev) {
//         const newPrevStop = currentStops[insertAtPosition];
//         currentStops[insertAtPosition + 1].distanceFromOrigin =
//           newPrevStop.distanceFromOrigin +
//           currentStops[insertAtPosition + 1].manualDistFromPrev;
//       }

//       toast.success(
//         stopModalMode === "insert"
//           ? `Stop "${tempStopForm.city}" inserted at position ${insertAtPosition + 1}`
//           : `Stop "${tempStopForm.city}" added successfully`,
//       );
//     }

//     setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

//     if (type === "up") {
//       setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     } else {
//       setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     }

//     setShowStopModal(false);
//     setTempInsertIndex(null);
//     setTempEditStopIndex(null);
//   };

//   const addIntermediateStop = (type = "up") => {
//     if (!newRoute.stopCity) {
//       toast.error("City is required.");
//       return;
//     }

//     let coordinates = newRoute.stopCoords;
//     let manualDistFromPrev = null;
//     let manualDistToNext = null;

//     const isManualLocation =
//       isManualStop ||
//       !newRoute.stopCoords ||
//       (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

//     if (isManualLocation) {
//       if (
//         !newRoute.stopDistFromPrev ||
//         parseFloat(newRoute.stopDistFromPrev) <= 0
//       ) {
//         toast.error(
//           "For manual stops, please provide distance from previous stop",
//         );
//         return;
//       }
//       coordinates = { lat: 0, lng: 0 };
//       manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);

//       const stops = getActiveStops();
//       const currentIndex =
//         editingStopIndex !== null
//           ? editingStopIndex
//           : insertIndex !== null
//             ? insertIndex
//             : stops.length;
//       const nextStop = stops[currentIndex];
//       const isNextAuto =
//         nextStop &&
//         nextStop.coordinates &&
//         (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);

//       if (
//         isNextAuto &&
//         newRoute.stopDistToNext &&
//         parseFloat(newRoute.stopDistToNext) > 0
//       ) {
//         manualDistToNext = parseFloat(newRoute.stopDistToNext);
//       }
//     }

//     const stopType = newRoute.stopType || "none";

//     const stopAddress =
//       newRoute.stopAddress ||
//       `${newRoute.stopCity}, ${newRoute.stopState || "India"}`;

//     let distanceFromOrigin = 0;
//     const stops = getActiveStops();

//     if (stops.length > 0) {
//       const lastStop = stops[stops.length - 1];
//       if (lastStop.distanceFromOrigin > 0) {
//         distanceFromOrigin = lastStop.distanceFromOrigin + manualDistFromPrev;
//       } else if (lastStop.manualDistFromPrev) {
//         distanceFromOrigin =
//           (lastStop.distanceFromOrigin || 0) + manualDistFromPrev;
//       } else {
//         distanceFromOrigin = manualDistFromPrev;
//       }
//     } else {
//       distanceFromOrigin = manualDistFromPrev;
//     }

//     const newStop = {
//       city: newRoute.stopCity,
//       state: newRoute.stopState || "",
//       address: stopAddress,
//       terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
//       stopType: stopType,
//       coordinates: coordinates,
//     manualDistFromPrev: manualDistFromPrev ? formatDistance(manualDistFromPrev) : null,
// manualDistToNext: manualDistToNext ? formatDistance(manualDistToNext) : null,
//       distanceFromOrigin: formatDistance(distanceFromOrigin),
//       isManualStop: isManualLocation,
//     };

//     setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

//     let currentStops = type === "up" ? [...upStops] : [...downStops];
//     let editingIndex = null;

//     if (type === "up" && editUpIndex !== null) {
//       editingIndex = editUpIndex;
//     } else if (type === "down" && editDownIndex !== null) {
//       editingIndex = editDownIndex;
//     }

//     if (editingIndex !== null) {
//       currentStops[editingIndex] = {
//         ...currentStops[editingIndex],
//         ...newStop,
//         sequence: editingIndex + 1,
//       };
//       if (type === "up") {
//         setEditUpIndex(null);
//       } else {
//         setEditDownIndex(null);
//       }
//       setEditingStopIndex(null);
//       toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
//     } else if (insertIndex !== null) {
//       currentStops.splice(insertIndex, 0, newStop);
//       setInsertIndex(null);
//       toast.success(
//         `Stop "${newRoute.stopCity}" inserted at position ${insertIndex + 1}`,
//       );
//     } else {
//       currentStops.push(newStop);
//       toast.success(`Stop "${newRoute.stopCity}" added successfully`);
//     }

//     if (type === "up") {
//       setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     } else {
//       setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     }

//     clearStopForm();
//   };

//   const getNextStopInfo = () => {
//     const stops = getActiveStops();
//     let nextStop = null;

//     if (stopModalMode === "insert" && tempInsertIndex !== null) {
//       nextStop = stops[tempInsertIndex];
//     } else if (stopModalMode === "edit" && tempEditStopIndex) {
//       nextStop = stops[tempEditStopIndex.index + 1];
//     } else {
//       nextStop = stops[stops.length];
//     }

//     if (
//       nextStop &&
//       nextStop.coordinates &&
//       (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0)
//     ) {
//       return nextStop;
//     }
//     return null;
//   };

//   const renderInlineInsertPanel = (idx) => {
//     const stops = getActiveStops();
//     const prevStop = idx > 0 ? stops[idx - 1] : null;
//     const nextStop = stops[idx] || null;
//     const nextHasGPS =
//       nextStop?.coordinates?.lat && nextStop.coordinates.lat !== 0;
//     const cityOk = inlineInsertForm.city.trim().length > 0;
//     const distOk = parseFloat(inlineInsertForm.distFromPrev) > 0;
//     const canInsert = cityOk && (!inlineInsertForm.isManual || distOk);

//     const fieldStyle = {
//       display: "flex",
//       flexDirection: "column",
//       gap: 5,
//     };
//     const labelStyle = {
//       fontSize: 11,
//       fontWeight: 500,
//       color: "var(--color-text-secondary, #777)",
//       letterSpacing: ".2px",
//     };
//     const inputStyle = (hasErr = false) => ({
//       width: "100%",
//       height: 38,
//       padding: "0 12px",
//       border: `1px solid ${hasErr ? "#e24b4a" : "var(--color-border-secondary, rgba(0,0,0,.2))"}`,
//       borderRadius: 8,
//       fontSize: 13,
//       background: hasErr
//         ? "rgba(252,235,235,.05)"
//         : "var(--color-background-primary, #fff)",
//       color: "var(--color-text-primary, #333)",
//       outline: "none",
//       boxSizing: "border-box",
//     });
//     const selectStyle = {
//       ...inputStyle(),
//       appearance: "none",
//       backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
//       backgroundRepeat: "no-repeat",
//       backgroundPosition: "right 12px center",
//       paddingRight: 32,
//     };
//     const sectionHead = (label) => (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 8,
//           margin: "18px 0 12px",
//         }}
//       >
//         <span
//           style={{
//             fontSize: 11,
//             fontWeight: 500,
//             color: "var(--color-text-secondary, #888)",
//             letterSpacing: ".4px",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {label}
//         </span>
//         <div
//           style={{
//             flex: 1,
//             height: 1,
//             background: "var(--color-border-tertiary, rgba(0,0,0,.1))",
//           }}
//         />
//       </div>
//     );

//     return (
//       <div
//         style={{
//           width: "100%",
//           background: "var(--color-background-primary, #fff)",
//           border: "1.5px solid #378add",
//           borderRadius: 14,
//           overflow: "hidden",
//           margin: "6px 0",
//           alignSelf: "stretch",
//         }}
//       >

//         <div
//           style={{
//             background: "linear-gradient(135deg, #185fa5 0%, #378add 100%)",
//             padding: "14px 18px",
//             display: "flex",
//             alignItems: "flex-start",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <div
//               style={{
//                 width: 34,
//                 height: 34,
//                 borderRadius: 8,
//                 background: "rgba(255,255,255,.18)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 18,
//                 flexShrink: 0,
//               }}
//             >
//               📍
//             </div>
//             <div>

//               <div
//                 style={{
//                   fontSize: 11,
//                   color: "rgba(255,255,255,.7)",
//                   marginTop: 3,
//                 }}
//               >
//                 New stop will be placed at position {idx + 1}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={() => {
//               setInlineInsertIndex(null);
//               setInlineInsertCitySuggestions([]);
//               setShowInlineInsertDropdown(false);
//             }}
//             style={{
//               width: 26,
//               height: 26,
//               borderRadius: 6,
//               border: "1px solid rgba(255,255,255,.3)",
//               background: "transparent",
//               color: "#fff",
//               cursor: "pointer",
//               fontSize: 15,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             ×
//           </button>
//         </div>


//         <div style={{ padding: 18 }}>

//           <label
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//               padding: "10px 12px",
//               background: "var(--color-background-secondary, #f7f7f5)",
//               border:
//                 "0.5px solid var(--color-border-tertiary, rgba(0,0,0,.1))",
//               borderRadius: 8,
//               cursor: "pointer",
//               userSelect: "none",
//             }}
//           >
//             <input
//               type="checkbox"
//               checked={inlineInsertForm.isManual}
//               onChange={() =>
//                 setInlineInsertForm((prev) => ({
//                   ...prev,
//                   isManual: !prev.isManual,
//                   city: "",
//                   address: "",
//                   state: "",
//                   terminal: "",
//                   distFromPrev: "",
//                   distToNext: "",
//                 }))
//               }
//               style={{
//                 width: 16,
//                 height: 16,
//                 accentColor: "#378add",
//                 cursor: "pointer",
//               }}
//             />
//             <span
//               style={{ fontSize: 13, color: "var(--color-text-primary, #333)" }}
//             >
//               Manually typed stop (no map suggestions)
//             </span>
//           </label>


//           {sectionHead("Stop details")}


//           <div style={{ marginBottom: 12 }}>
//             <div style={fieldStyle}>
//               <label style={labelStyle}>
//                 City / stop name <span style={{ color: "#e24b4a" }}>*</span>
//               </label>
//               {!inlineInsertForm.isManual ? (
//                 <LocationInput
//                   value={inlineInsertForm.city}
//                   onChange={(v) =>
//                     setInlineInsertForm((prev) => ({ ...prev, city: v }))
//                   }
//                   onLocationSelect={(loc) =>
//                     setInlineInsertForm((prev) => ({
//                       ...prev,
//                       city: loc.city || loc.name || "",
//                       state: loc.state || prev.state,
//                       address: loc.address || "",
//                     }))
//                   }
//                   placeholder="Search stop city or address…"
//                 />
//               ) : (
//                 <div style={{ position: "relative" }}>
//                   <input
//                     type="text"
//                     value={inlineInsertForm.city}
//                     onChange={async (e) => {
//                       const value = e.target.value;
//                       setInlineInsertForm((prev) => ({
//                         ...prev,
//                         city: value,
//                         address: "",
//                         state: "",
//                         terminal: "",
//                       }));
//                       if (value.length >= 2) {
//                         try {
//                           const searchFn =
//                             activeRouteTab === "UP"
//                               ? searchRouteIntermediateStops
//                               : searchRouteIntermediateStops;
//                           const res = await searchFn(token, value);
//                           if (res.success && res.cities?.length > 0) {
//                             setInlineInsertCitySuggestions(res.cities);
//                             setShowInlineInsertDropdown(true);
//                           } else {
//                             setInlineInsertCitySuggestions([]);
//                             setShowInlineInsertDropdown(false);
//                           }
//                         } catch {
//                           setInlineInsertCitySuggestions([]);
//                           setShowInlineInsertDropdown(false);
//                         }
//                       } else {
//                         setInlineInsertCitySuggestions([]);
//                         setShowInlineInsertDropdown(false);
//                       }
//                     }}
//                     onFocus={() =>
//                       inlineInsertCitySuggestions.length > 0 &&
//                       setShowInlineInsertDropdown(true)
//                     }
//                     onBlur={() =>
//                       setTimeout(() => setShowInlineInsertDropdown(false), 200)
//                     }
//                     placeholder="Type city name (min 2 chars)…"
//                     style={inputStyle()}
//                   />
//                   {showInlineInsertDropdown &&
//                     inlineInsertCitySuggestions.length > 0 && (
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "100%",
//                           left: 0,
//                           right: 0,
//                           background: "white",
//                           border: "1px solid #ddd",
//                           borderRadius: 8,
//                           maxHeight: 200,
//                           overflowY: "auto",
//                           zIndex: 10000,
//                           boxShadow: "0 4px 12px rgba(0,0,0,.12)",
//                         }}
//                       >
//                         {inlineInsertCitySuggestions.map((city, i) => (
//                           <div
//                             key={city.id || i}
//                             onMouseDown={() => {
//                               setInlineInsertForm((prev) => ({
//                                 ...prev,
//                                 city: city.name,
//                                 address: city.address || city.name,
//                                 state: city.state || "",
//                                 terminal:
//                                   city.terminal || `${city.name} Bus Stand`,
//                               }));
//                               setShowInlineInsertDropdown(false);
//                               setInlineInsertCitySuggestions([]);
//                             }}
//                             style={{
//                               padding: "9px 12px",
//                               cursor: "pointer",
//                               borderBottom: "0.5px solid #f0f0f0",
//                             }}
//                             onMouseEnter={(e) =>
//                               (e.currentTarget.style.background = "#f0f7ff")
//                             }
//                             onMouseLeave={(e) =>
//                               (e.currentTarget.style.background = "white")
//                             }
//                           >
//                             <div style={{ fontWeight: 500, fontSize: 13 }}>
//                               {city.name}
//                             </div>
//                             <div style={{ fontSize: 11, color: "#888" }}>
//                               {city.state}
//                               {city.terminal ? ` · ${city.terminal}` : ""}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                 </div>
//               )}
//             </div>
//           </div>


//           <div style={{ marginBottom: 12 }}>
//             <div style={fieldStyle}>
//               <label style={labelStyle}>Address</label>
//               <input
//                 type="text"
//                 value={inlineInsertForm.address}
//                 onChange={(e) =>
//                   setInlineInsertForm((prev) => ({
//                     ...prev,
//                     address: e.target.value,
//                   }))
//                 }
//                 placeholder="e.g. NH-19, Near Bus Stand"
//                 style={inputStyle()}
//               />
//             </div>
//           </div>


//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: 12,
//               marginBottom: 4,
//             }}
//           >
//             <div style={fieldStyle}>
//               <label style={labelStyle}>State</label>
//               <input
//                 type="text"
//                 value={inlineInsertForm.state}
//                 onChange={(e) =>
//                   setInlineInsertForm((prev) => ({
//                     ...prev,
//                     state: e.target.value,
//                   }))
//                 }
//                 placeholder="State"
//                 style={inputStyle()}
//               />
//             </div>
//             <div style={fieldStyle}>
//               <label style={labelStyle}>Terminal</label>
//               <input
//                 type="text"
//                 value={inlineInsertForm.terminal}
//                 onChange={(e) =>
//                   setInlineInsertForm((prev) => ({
//                     ...prev,
//                     terminal: e.target.value,
//                   }))
//                 }
//                 placeholder="Terminal name"
//                 style={inputStyle()}
//               />
//             </div>
//           </div>


//           {sectionHead("Distance")}

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: nextHasGPS ? "1fr 1fr" : "1fr",
//               gap: 12,
//               marginBottom: 4,
//             }}
//           >

//             <div
//               style={{
//                 border: "1px solid rgba(226,75,74,.4)",
//                 borderRadius: 10,
//                 padding: 14,
//                 background: "rgba(252,235,235,.04)",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 11,
//                   fontWeight: 500,
//                   color: "#a32d2d",
//                   marginBottom: 6,
//                 }}
//               >
//                 From previous stop <span style={{ color: "#e24b4a" }}>*</span>
//               </div>
//               <input
//                 type="number"
//                 value={inlineInsertForm.distFromPrev}
//                 onChange={(e) =>
//                   setInlineInsertForm((prev) => ({
//                     ...prev,
//                     distFromPrev: e.target.value,
//                   }))
//                 }
//                 placeholder="0"
//                 min="0"
//                 step="0.1"
//                 style={{ ...inputStyle(true), border: "1px solid #e24b4a" }}
//               />
//               <div
//                 style={{
//                   fontSize: 11,
//                   color: "#a32d2d",
//                   marginTop: 5,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 4,
//                 }}
//               >
//                 ⚠ Required for manual stops
//               </div>
//               <div
//                 style={{
//                   fontSize: 11,
//                   color: "var(--color-text-secondary, #888)",
//                   marginTop: 2,
//                 }}
//               >
//                 km
//               </div>
//             </div>


//             {nextHasGPS && (
//               <div
//                 style={{
//                   border: "1px solid rgba(55,138,221,.3)",
//                   borderRadius: 10,
//                   padding: 14,
//                   background: "rgba(230,241,251,.04)",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 11,
//                     fontWeight: 500,
//                     color: "#185fa5",
//                     marginBottom: 6,
//                   }}
//                 >
//                   To next stop — {nextStop.city}
//                 </div>
//                 <input
//                   type="number"
//                   value={inlineInsertForm.distToNext}
//                   onChange={(e) =>
//                     setInlineInsertForm((prev) => ({
//                       ...prev,
//                       distToNext: e.target.value,
//                     }))
//                   }
//                   placeholder="0"
//                   min="0"
//                   step="0.1"
//                   style={{
//                     ...inputStyle(),
//                     border: "1px solid rgba(55,138,221,.5)",
//                   }}
//                 />
//                 <div
//                   style={{
//                     fontSize: 11,
//                     color: "#185fa5",
//                     marginTop: 5,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 4,
//                   }}
//                 >
//                   ℹ Next stop has GPS — helps accuracy
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 11,
//                     color: "var(--color-text-secondary, #888)",
//                     marginTop: 2,
//                   }}
//                 >
//                   km
//                 </div>
//               </div>
//             )}
//           </div>


//           {sectionHead("Stop type")}


//         </div>


//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "flex-end",
//             gap: 8,
//             padding: "12px 18px",
//             borderTop:
//               "1px solid var(--color-border-tertiary, rgba(0,0,0,.08))",
//             background: "var(--color-background-secondary, #fafafa)",
//           }}
//         >
//           <button
//             type="button"
//             onClick={() => {
//               setInlineInsertIndex(null);
//               setInlineInsertCitySuggestions([]);
//               setShowInlineInsertDropdown(false);
//             }}
//             style={{
//               padding: "8px 18px",
//               fontSize: 13,
//               borderRadius: 8,
//               border: "1px solid var(--color-border-secondary, rgba(0,0,0,.2))",
//               background: "transparent",
//               cursor: "pointer",
//               color: "var(--color-text-secondary, #666)",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             type="button"
//             onClick={saveInlineInsert}
//             disabled={!canInsert}
//             style={{
//               padding: "8px 22px",
//               fontSize: 13,
//               borderRadius: 8,
//               border: "none",
//               background: "#378add",
//               color: "#fff",
//               fontWeight: 500,
//               cursor: canInsert ? "pointer" : "not-allowed",
//               opacity: canInsert ? 1 : 0.45,
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//             }}
//           >
//             ✓ Insert stop
//           </button>
//         </div>
//       </div>
//     );
//   };

//   const handleEditStop = (index, type = "up") => {
//     openEditStopModal(index, type);
//   };
//   const handleDeleteStop = (index) => {
//     const isUp = activeRouteTab === "UP";
//     setIsDistanceCalculated((prev) => ({
//       ...prev,
//       [isUp ? "up" : "down"]: false,
//     }));

//     if (isUp) {
//       const updated = upStops.filter((_, i) => i !== index);
//       setUpStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
//       if (editingStopIndex === index && editUpIndex === index) clearStopForm();
//     } else {
//       const updated = downStops.filter((_, i) => i !== index);
//       setDownStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
//       if (editingStopIndex === index && editDownIndex === index)
//         clearStopForm();
//     }
//     toast.success("Stop deleted successfully");
//   };

//   const handleCalculateDistances = async () => {
//     const isUp = activeRouteTab === "UP";
//     const stops = isUp ? upStops : downStops;

//     if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//       toast.error("Main Route Origin and Destination required.");
//       return;
//     }

//     const isOriginManualLocal = checkOriginManual();
//     const isDestManualLocal = checkDestinationManual();

//     if (stops.length > 0 && stops[0]) {
//       const isFirstStopManual = stops[0].isManualStop;
//       if (isFirstStopManual &&
//       stops[0].manualDistFromPrev &&
//       parseFloat(stops[0].manualDistFromPrev) > 0) {
//         console.log(
//           "First stop already has distance from origin:",
//           stops[0].manualDistFromPrev,
//         );
//       } else if (
//         (isOriginManualLocal && !isFirstStopManual) ||
//         (!isOriginManualLocal && isFirstStopManual)
//       ) {
//         const firstLeg = isUp
//           ? newRoute.upManualFirstLeg
//           : newRoute.downManualFirstLeg;
//         if (!firstLeg || parseFloat(firstLeg) <= 0) {
//           toast.error("Please provide distance from origin to first stop.");
//           setIsCalculatingDistances(false);
//           return;
//         }
//       }
//     }

//     if (stops.length > 0 && stops[stops.length - 1]) {
//       const isLastStopManual = stops[stops.length - 1].isManualStop;
//       if (isDestManualLocal) {
//         const finalLeg = isUp
//           ? newRoute.upManualFinalLeg
//           : newRoute.downManualFinalLeg;
//         if (!finalLeg || parseFloat(finalLeg) <= 0) {
//           toast.error(
//             "Destination is manual. Please provide distance from last stop to destination.",
//           );
//           setIsCalculatingDistances(false);
//           return;
//         }
//       } else if (!isDestManualLocal && isLastStopManual) {
//         const finalLeg = isUp
//           ? newRoute.destManualDistFromLastStop
//           : newRoute.downManualFinalLeg;
//         if (!finalLeg || parseFloat(finalLeg) <= 0) {
//           toast.error(
//             "Last stop is manual, destination has GPS. Please provide distance to destination.",
//           );
//           setIsCalculatingDistances(false);
//           return;
//         }
//       }
//     }

//     let originNode, destNode;

//     if (isUp) {
//       originNode = {
//         id: "origin",
//         name: newRoute.upOriginCity,
//         lat: newRoute.upOriginCoords?.lat || 0,
//         lng: newRoute.upOriginCoords?.lng || 0,
//         isManual: isOriginManualLocal,
//       };
//       destNode = {
//         id: "destination",
//         name: newRoute.upDestCity,
//         lat: newRoute.upDestCoords?.lat || 0,
//         lng: newRoute.upDestCoords?.lng || 0,
//         isManual: isDestManualLocal,
//       };
//     } else {
//       originNode = {
//         id: "origin",
//         name: newRoute.upDestCity,
//         lat: newRoute.upDestCoords?.lat || 0,
//         lng: newRoute.upDestCoords?.lng || 0,
//         isManual: isDestManualLocal,
//       };
//       destNode = {
//         id: "destination",
//         name: newRoute.upOriginCity,
//         lat: newRoute.upOriginCoords?.lat || 0,
//         lng: newRoute.upOriginCoords?.lng || 0,
//         isManual: isOriginManualLocal,
//       };
//     }

//     setIsCalculatingDistances(true);
//     toast.info(`Calculating ${activeRouteTab} route distances...`);

//     try {
//       const stopNodes = stops.map((s, i) => ({
//         id: `stop_${i}`,
//         name: s.city,
//         lat: s.coordinates?.lat,
//         lng: s.coordinates?.lng,
//         manualFromPrev: s.manualDistFromPrev,
//         manualToNext: s.manualDistToNext,
//         isManual:
//           s.isManualStop ||
//           !s.coordinates ||
//           (s.coordinates.lat === 0 && s.coordinates.lng === 0),
//         originalStop: s,
//       }));

//       const fullPath = [originNode, ...stopNodes, destNode];
//       const validNodes = fullPath.filter(
//         (s) => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual,
//       );

//       let matrixResponse = null;
//       if (validNodes.length >= 2) {
//         matrixResponse = await getDistanceMatrix(validNodes, validNodes);
//       }

//       let cumulativeDist = 0;
//       let lastAutoNodeIndex = -1;
//       let sumManualSinceLastAuto = 0;
//       const updatedStops = [];
//       let validNodeCounter = -1;
//       let prevStopCumulativeDist = 0;

//       const segmentDistances = [];

//       if (stops.length > 0 && stops[0]) {
//         const isFirstStopManual = stops[0].isManualStop;

//         if (isFirstStopManual &&
//         stops[0].manualDistFromPrev &&
//         parseFloat(stops[0].manualDistFromPrev) > 0) {
//           const firstLeg = parseFloat(stops[0].manualDistFromPrev);
//           cumulativeDist = firstLeg;
//           sumManualSinceLastAuto = firstLeg;
//           prevStopCumulativeDist = cumulativeDist;
//           segmentDistances.push(firstLeg);
//           if (!isFirstStopManual) {
//             sumManualSinceLastAuto = 0;
//           }
//         } else if (
//           (isOriginManualLocal && !isFirstStopManual) ||
//           (!isOriginManualLocal && isFirstStopManual)
//         ) {
//           const firstLeg =
//             parseFloat(
//               isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg,
//             ) || 0;
//           cumulativeDist = firstLeg;
//           sumManualSinceLastAuto = firstLeg;
//           prevStopCumulativeDist = cumulativeDist;
//           segmentDistances.push(firstLeg);
//           if (!isFirstStopManual) {
//             sumManualSinceLastAuto = 0;
//           }
//         } else if (!isOriginManualLocal && !isFirstStopManual) {
//           lastAutoNodeIndex = 0;
//           validNodeCounter = 0;
//         } else if (isOriginManualLocal && isFirstStopManual) {
//           cumulativeDist = 0;
//           prevStopCumulativeDist = 0;
//         }
//       }

//       for (let i = 0; i < stopNodes.length; i++) {
//         const currNode = stopNodes[i];
//         const isManual = currNode.isManual;

//         if (isManual) {
//           if (i === 0 &&
//           stops[0].manualDistFromPrev &&
//           parseFloat(stops[0].manualDistFromPrev) > 0) {
//             const segment = parseFloat(stops[0].manualDistFromPrev) || 0;
//             cumulativeDist = segment;
//             sumManualSinceLastAuto = segment;
//             prevStopCumulativeDist = cumulativeDist;
//             segmentDistances.push(segment);

//             updatedStops.push({
//               ...stops[i],
//               distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//               manualDistFromPrev: segment,
//               manualDistToNext: currNode.manualToNext
//                 ? parseFloat(currNode.manualToNext)
//                 : null,
//             });
//           } else if (
//             currNode.manualFromPrev !== null &&
//             currNode.manualFromPrev !== undefined &&
//             currNode.manualFromPrev !== ""
//           ) {
//             const segment = parseFloat(currNode.manualFromPrev) || 0;
//             cumulativeDist += segment;
//             sumManualSinceLastAuto += segment;
//             segmentDistances.push(segment);

//             updatedStops.push({
//               ...stops[i],
//               distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//               manualDistFromPrev: segment,
//               manualDistToNext: currNode.manualToNext
//                 ? parseFloat(currNode.manualToNext)
//                 : null,
//             });

//             prevStopCumulativeDist = cumulativeDist;

//             if (currNode.manualToNext && currNode.manualToNext > 0) {
//               sumManualSinceLastAuto = currNode.manualToNext;
//             }
//           } else {
//             toast.error(
//               `Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`,
//             );
//             setIsCalculatingDistances(false);
//             return;
//           }
//         } else {
//           validNodeCounter++;
//           let apiDistance = 0;

//           let matrixOriginIndex = lastAutoNodeIndex;
//           let matrixDestIndex = validNodeCounter;

//           if (isOriginManualLocal && lastAutoNodeIndex === -1) {
//             matrixOriginIndex = 0;
//             matrixDestIndex = validNodeCounter;
//           } else if (isOriginManualLocal && lastAutoNodeIndex !== -1) {
//             matrixOriginIndex = lastAutoNodeIndex;
//             matrixDestIndex = validNodeCounter;
//           }

//           if (
//             matrixResponse &&
//             matrixOriginIndex >= 0 &&
//             matrixDestIndex >= 0
//           ) {
//             const element =
//               matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//             if (element?.status === "OK") {
//               apiDistance = element.distance.value / 1000;
//             }
//           }

//           let segment = apiDistance - sumManualSinceLastAuto;
//           if (segment < 0) segment = 0;

//           if (cumulativeDist > 0 || i > 0) {
//             cumulativeDist += segment;
//           } else if (apiDistance > 0) {
//             cumulativeDist = segment;
//           }

//           if (lastAutoNodeIndex === -1) {
//             lastAutoNodeIndex = validNodeCounter;
//           }

//           if (matrixOriginIndex >= 0) {
//             lastAutoNodeIndex = validNodeCounter;
//           }

//           sumManualSinceLastAuto = 0;

//           const distanceFromPrev = cumulativeDist - prevStopCumulativeDist;
//           prevStopCumulativeDist = cumulativeDist;
//           segmentDistances.push(distanceFromPrev);

//           updatedStops.push({
//             ...stops[i],
//             distanceFromOrigin: parseFloat(cumulativeDist.toFixed(2)),
//             manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(2)),
//             manualDistToNext: currNode.manualToNext
//               ? parseFloat(currNode.manualToNext)
//               : null,
//           });
//         }
//       }

//       let finalSegment = 0;
//       const lastStop =
//         stopNodes.length > 0 ? stopNodes[stopNodes.length - 1] : null;
//       const isLastStopManualFlag = lastStop && lastStop.isManual;

//       if (isDestManualLocal) {
//         const finalLeg = parseFloat(
//           isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg,
//         );
//         if (isNaN(finalLeg) || finalLeg <= 0) {
//           toast.error(
//             `Destination is manual. Please provide distance from last stop to destination.`,
//           );
//           setIsCalculatingDistances(false);
//           return;
//         }
//         finalSegment = finalLeg;
//       } else if (!isDestManualLocal && isLastStopManualFlag) {
//         const finalLeg = parseFloat(
//           isUp
//             ? newRoute.destManualDistFromLastStop
//             : newRoute.downManualFinalLeg,
//         );
//         if (isNaN(finalLeg) || finalLeg <= 0) {
//           toast.error(
//             `Last stop is manual, destination has GPS. Please provide distance to destination.`,
//           );
//           setIsCalculatingDistances(false);
//           return;
//         }
//         finalSegment = finalLeg;
//       } else if (
//         !isDestManualLocal &&
//         !isLastStopManualFlag &&
//         stopNodes.length > 0
//       ) {
//         validNodeCounter++;
//         let apiDistance = 0;

//         let matrixOriginIndex = lastAutoNodeIndex;
//         let matrixDestIndex = validNodeCounter;

//         if (isOriginManualLocal && lastAutoNodeIndex === -1) {
//           matrixOriginIndex = 0;
//           matrixDestIndex = validNodeCounter;
//         } else if (isOriginManualLocal && lastAutoNodeIndex !== -1) {
//           matrixOriginIndex = lastAutoNodeIndex;
//           matrixDestIndex = validNodeCounter;
//         }

//         if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//           const element =
//             matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//           if (element?.status === "OK") {
//             apiDistance = element.distance.value / 1000;
//           }
//         }
//         finalSegment = apiDistance - sumManualSinceLastAuto;
//         if (finalSegment < 0) finalSegment = 0;
//       } else if (stopNodes.length === 0) {
//         if (isOriginManualLocal && isDestManualLocal) {
//           const totalDistance = parseFloat(newRoute.upTotalDistance);
//           if (isNaN(totalDistance) || totalDistance <= 0) {
//             toast.error(
//               "Both origin and destination are manual. Please provide total distance.",
//             );
//             setIsCalculatingDistances(false);
//             return;
//           }
//           finalSegment = totalDistance;
//         } else if (
//           !isOriginManualLocal &&
//           !isDestManualLocal &&
//           matrixResponse
//         ) {
//           const element = matrixResponse.rows[0]?.elements[1];
//           if (element?.status === "OK") {
//             finalSegment = element.distance.value / 1000;
//           } else {
//             toast.error(
//               "Could not calculate distance between origin and destination. Please check addresses or enter manually.",
//             );
//             setIsCalculatingDistances(false);
//             return;
//           }
//         } else if (isOriginManualLocal && !isDestManualLocal) {
//           toast.error(
//             "Origin is manual, destination has GPS. Please add stops or provide total distance.",
//           );
//           setIsCalculatingDistances(false);
//           return;
//         } else if (!isOriginManualLocal && isDestManualLocal) {
//           toast.error(
//             "Destination is manual, origin has GPS. Please add stops or provide total distance.",
//           );
//           setIsCalculatingDistances(false);
//           return;
//         }
//       }

//       cumulativeDist += finalSegment;

//       if (updatedStops.length > 0 && finalSegment > 0) {
//         const lastStopIndex = updatedStops.length - 1;
//         updatedStops[lastStopIndex] = {
//           ...updatedStops[lastStopIndex],
//           manualDistToNext: parseFloat(finalSegment.toFixed(1)),
//         };
//       }

//       setActiveStops(updatedStops);
//       setNewRoute((prev) => ({
//         ...prev,
//         [isUp ? "upTotalDistance" : "downTotalDistance"]:
//           cumulativeDist.toFixed(1),
//       }));

//       if (editingRoute) {
//         if (isUp) {
//           setEditForm((prev) => ({
//             ...prev,
//             totalDistance: cumulativeDist.toFixed(1),
//           }));
//         } else {
//           setEditForm((prev) => ({
//             ...prev,
//             returnTotalDistance: cumulativeDist.toFixed(1),
//           }));
//         }
//       }

//       setIsDistanceCalculated((prev) => ({
//         ...prev,
//         [activeRouteTab.toLowerCase()]: true,
//       }));
//       console.log(
//         `${activeRouteTab} route distances calculated - Segment distances:`,
//         segmentDistances,
//       );

//       toast.success(
//         `${activeRouteTab} route distances calculated! Each stop now has distance from previous stop stored.`,
//       );
//     } catch (error) {
//       console.error("Distance calculation error:", error);
//       toast.error("Calculation failed. Please enter distances manually.");
//     } finally {
//       setIsCalculatingDistances(false);
//     }
//   };

//   const fetchRoutes = async () => {
//     try {
//       setLoading(true);
//       const response = await getAllMasterRoutes(
//         token,
//         currentPage,
//         pageSize,
//         searchTerm,
//       );

//       if (response && response.success) {
//         const routesData = response.data?.routes || [];

//         const transformedRoutes = routesData.map((route, index) => ({
//           id: route._id || route.id,
//           serialNo: (currentPage - 1) * pageSize + index + 1,
//           masterRouteNumber: route.masterRouteNumber || "N/A",
//           masterRouteName: route.masterRouteName || "N/A",
//           originCity: route.origin?.city || "N/A",
//           destinationCity: route.destination?.city || "N/A",
//           distance: route.routeDetails?.totalDistance || 0,
//           duration: formatDuration(
//             route.routeDetails?.estimatedDuration?.hours,
//             route.routeDetails?.estimatedDuration?.minutes,
//           ),
//           stops: route.intermediateStops?.length || 0,
//           status: route.isActive ? "Active" : "Inactive",
//           isActive: route.isActive,
//           createdAt: route.createdAt,
//           updatedAt: route.updatedAt,
//           creatorType: route.creatorType || "Admin",
//           creatorName: route.creatorName || "Admin",
//           isRoundTrip: route.isRoundTrip || false,
//           description: route.description || "",
//           fullData: route,
//         }));

//         setRoutes(transformedRoutes);

//         if (response.data?.pagination) {
//           setTotalPages(response.data.pagination.totalPages || 1);
//           setTotalRoutes(response.data.pagination.total || 0);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching master routes:", err);
//       toast.error("Failed to fetch master routes");
//     } finally {
//       setLoading(false);
//     }
//   };

// useEffect(() => {
//     const timer = setTimeout(() => {
//         fetchRoutes();
//     }, 500);
    
//     return () => clearTimeout(timer);
// }, [searchTerm, currentPage]);

//   const handleSaveRoute = async () => {
//     const isOriginManualLocal = checkOriginManual();
//     const isDestManualLocal = checkDestinationManual();

//     if (!isOriginManualLocal &&
//     (!newRoute.upOriginCoords ||
//       (newRoute.upOriginCoords.lat === 0 &&
//         newRoute.upOriginCoords.lng === 0))) {
//       toast.error(
//         'Please select Origin from suggestions to get valid coordinates, or check "Manual Origin"',
//       );
//       return;
//     }

//     if (!isDestManualLocal &&
//     (!newRoute.upDestCoords ||
//       (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0))) {
//       toast.error(
//         'Please select Destination from suggestions to get valid coordinates, or check "Manual Destination"',
//       );
//       return;
//     }

//     const invalidStops = upStops.filter((stop) => {
//       if (!stop.city?.trim()) return true;
//       if (
//         !stop.isManualStop &&
//         (!stop.coordinates ||
//           (stop.coordinates.lat === 0 && stop.coordinates.lng === 0))
//       ) {
//         return true;
//       }
//       return false;
//     });

//     if (invalidStops.length > 0) {
//       toast.error(
//         `Stop(s) missing required fields: ${invalidStops.map((s) => s.city || "Unknown").join(", ")}`,
//       );
//       return;
//     }

//     if (!isDistanceCalculated.up) {
//       toast.error("Please calculate UP route distances first");
//       return;
//     }

//     const upTotalDistance = parseFloat(newRoute.upTotalDistance);
//     if (isNaN(upTotalDistance) || upTotalDistance <= 0) {
//       toast.error("UP route total distance must be greater than 0");
//       return;
//     }

//     if (upStops.length > 0 && upStops[0]) {
//       const isFirstStopManual = upStops[0].isManualStop;
//       if (isFirstStopManual &&
//       upStops[0].manualDistFromPrev &&
//       parseFloat(upStops[0].manualDistFromPrev) > 0) {
//         console.log(
//           "First stop already has distance from origin:",
//           upStops[0].manualDistFromPrev,
//         );
//       } else if (
//         (isOriginManualLocal && !isFirstStopManual) ||
//         (!isOriginManualLocal && isFirstStopManual)
//       ) {
//         if (
//           !newRoute.upManualFirstLeg ||
//           parseFloat(newRoute.upManualFirstLeg) <= 0
//         ) {
//           toast.error("Please provide distance from origin to first stop.");
//           return;
//         }
//       }
//     }

//     if (upStops.length > 0 && upStops[upStops.length - 1]) {
//       const isLastStopManual = upStops[upStops.length - 1].isManualStop;

//       if (isDestManualLocal) {
//         if (!newRoute.upManualFinalLeg ||
//         parseFloat(newRoute.upManualFinalLeg) <= 0) {
//           toast.error(
//             "Destination is manual. Please provide distance from last stop to destination.",
//           );
//           return;
//         }
//       } else if (!isDestManualLocal && isLastStopManual) {
//         if (!newRoute.destManualDistFromLastStop ||
//         parseFloat(newRoute.destManualDistFromLastStop) <= 0) {
//           toast.error(
//             "Last stop is manual, destination has GPS. Please provide distance to destination.",
//           );
//           return;
//         }
//       }
//     }

//     let lastDistance = 0;
//     for (let i = 0; i < upStops.length; i++) {
//       const stopDistance = parseFloat(upStops[i].distanceFromOrigin);
//       if (isNaN(stopDistance)) {
//         toast.error(`Stop "${upStops[i].city}" has invalid distance`);
//         return;
//       }
//       if (stopDistance <= lastDistance && i > 0) {
//         toast.error(
//           `Stop distances must be in increasing order. Check stop "${upStops[i].city}"`,
//         );
//         return;
//       }
//       lastDistance = stopDistance;
//     }

//     if (isRoundTrip) {
//       if (!isDistanceCalculated.down) {
//         toast.error("Please calculate DOWN route distances first");
//         return;
//       }

//       const downTotalDistance = parseFloat(newRoute.downTotalDistance);
//       if (isNaN(downTotalDistance) || downTotalDistance <= 0) {
//         toast.error("DOWN route total distance must be greater than 0");
//         return;
//       }

//       const invalidDownStops = downStops.filter((stop) => {
//         if (!stop.city?.trim()) return true;
//         if (
//           !stop.isManualStop &&
//           (!stop.coordinates ||
//             (stop.coordinates.lat === 0 && stop.coordinates.lng === 0))
//         ) {
//           return true;
//         }
//         return false;
//       });

//       if (invalidDownStops.length > 0) {
//         toast.error(
//           `DOWN route stop(s) missing required fields: ${invalidDownStops.map((s) => s.city || "Unknown").join(", ")}`,
//         );
//         return;
//       }

//       let lastDownDistance = 0;
//       for (let i = 0; i < downStops.length; i++) {
//         const stopDistance = parseFloat(downStops[i].distanceFromOrigin);
//         if (isNaN(stopDistance)) {
//           toast.error(`DOWN stop "${downStops[i].city}" has invalid distance`);
//           return;
//         }
//         if (stopDistance <= lastDownDistance && i > 0) {
//           toast.error(
//             `DOWN stop distances must be in increasing order. Check stop "${downStops[i].city}"`,
//           );
//           return;
//         }
//         lastDownDistance = stopDistance;
//       }
//     }

//     setIsCreatingRoute(true);

//     try {
//       const originCoordinates = isOriginManualLocal
//         ? { lat: 0, lng: 0 }
//         : {
//             lat: newRoute.upOriginCoords.lat,
//             lng: newRoute.upOriginCoords.lng,
//           };

//       const destCoordinates = isDestManualLocal
//         ? { lat: 0, lng: 0 }
//         : { lat: newRoute.upDestCoords.lat, lng: newRoute.upDestCoords.lng };

//       const originData = {
//         city: newRoute.upOriginCity.trim(),
//         state: newRoute.upOriginState?.trim() || "",
//         address:
//           newRoute.upOriginAddress?.trim() || `${newRoute.upOriginCity}, India`,
//         terminal:
//           newRoute.upOriginTerminal?.trim() ||
//           `${newRoute.upOriginCity} Terminal`,
//         coordinates: originCoordinates,
//         distanceFromOrigin: 0,
//         isManual: isOriginManualLocal,
//       };

//       const destData = {
//         city: newRoute.upDestCity.trim(),
//         state: newRoute.upDestState?.trim() || "",
//         address:
//           newRoute.upDestAddress?.trim() || `${newRoute.upDestCity}, India`,
//         terminal:
//           newRoute.upDestTerminal?.trim() || `${newRoute.upDestCity} Terminal`,
//         coordinates: destCoordinates,
//         distanceFromOrigin: upTotalDistance,
//         isManual: isDestManualLocal,
//       };

//       const cleanStops = (list, isReturnJourney = false) => {
//         return list.map((s, index) => {
//           const city = s.city?.trim();
//           if (!city) {
//             throw new Error(`Stop ${index + 1} is missing city name`);
//           }

//           const state = s.state?.trim() || "";
//           const address = s.address?.trim() || `${city}, ${state}, India`;
//           const terminal = s.terminal?.trim() || `${city} Terminal`;

//           let distanceFromOrigin = parseFloat(s.distanceFromOrigin);
//           if (isNaN(distanceFromOrigin)) {
//             distanceFromOrigin = 0;
//           }

//           const stopPayload = {
//             sequence: index + 1,
//             city: city,
//             state: state,
//             address: address,
//             terminal: terminal,
//             stopType: s.stopType || "none",
//             coordinates:
//               s.coordinates && s.coordinates.lat && s.coordinates.lng
//                 ? {
//                     lat: s.coordinates.lat,
//                     lng: s.coordinates.lng,
//                   }
//                 : { lat: 0, lng: 0 },
//             distanceFromOrigin: parseFloat(distanceFromOrigin.toFixed(1)),
//           };

//           if (s.manualDistFromPrev && parseFloat(s.manualDistFromPrev) > 0) {
//             stopPayload.manualDistFromPrev = parseFloat(s.manualDistFromPrev);
//           }
//           if (s.manualDistToNext && parseFloat(s.manualDistToNext) > 0) {
//             stopPayload.manualDistToNext = parseFloat(s.manualDistToNext);
//           }

//           return stopPayload;
//         });
//       };

//       const finalPayload = {
//         masterRouteName: newRoute.masterRouteName.trim(),
//         description: newRoute.description?.trim() || "",
//         via: newRoute.via.map((v) => ({
//           city: v.city.trim(),
//           state: v.state || "",
//           sequence: v.sequence,
//         })),
//         origin: originData,
//         destination: destData,
//         intermediateStops: cleanStops(upStops, false),
//         routeDetails: {
//           totalDistance: parseFloat(upTotalDistance.toFixed(1)),
//           estimatedDuration: {
//             hours: parseInt(newRoute.upDurationHours || 0, 10),
//             minutes: parseInt(newRoute.upDurationMinutes || 0, 10),
//           },
//         },
//         isRoundTrip: isRoundTrip,
//       };

//       if (isRoundTrip) {
//         const downTotalDistance = parseFloat(newRoute.downTotalDistance);

//         const returnOriginData = {
//           city: destData.city,
//           state: destData.state,
//           address: destData.address,
//           terminal: destData.terminal,
//           coordinates: destData.coordinates,
//           distanceFromOrigin: 0,
//           isManual: destData.isManual,
//         };

//         const returnDestData = {
//           city: originData.city,
//           state: originData.state,
//           address: originData.address,
//           terminal: originData.terminal,
//           coordinates: originData.coordinates,
//           distanceFromOrigin: downTotalDistance,
//           isManual: originData.isManual,
//         };

//         finalPayload.returnJourney = {
//           origin: returnOriginData,
//           destination: returnDestData,
//           intermediateStops: cleanStops(downStops, true),
//           routeDetails: {
//             totalDistance: parseFloat(downTotalDistance.toFixed(1)),
//             estimatedDuration: {
//               hours: parseInt(newRoute.downDurationHours || 0, 10),
//               minutes: parseInt(newRoute.downDurationMinutes || 0, 10),
//             },
//           },
//         };
//       }

//       console.log("Final Payload:", JSON.stringify(finalPayload, null, 2));

//       const response = await createMasterRoute(finalPayload, token);

//       if (response && response.success) {
//         toast.success(
//           isRoundTrip
//             ? "Round trip master route created successfully!"
//             : "Master route created successfully!",
//         );

//         setShowAddModal(false);
//         resetNewRouteForm();
//         await fetchRoutes();
//       } else {
//         throw new Error(response?.message || "Failed to create master route");
//       }
//     } catch (err) {
//       console.error("Error creating master route:", err);
//       if (err.response) {
//         const serverError =
//           err.response.data?.message || err.response.data?.error || err.message;
//         toast.error(serverError);
//         console.error("Server error details:", err.response.data);
//       } else if (err.request) {
//         toast.error(
//           "No response from server. Please check your network connection.",
//         );
//       } else {
//         toast.error(
//           err.message || "Failed to create master route. Please try again.",
//         );
//       }
//     } finally {
//       setIsCreatingRoute(false);
//     }
//   };

//   const resetNewRouteForm = () => {
//     setNewRoute({
//       masterRouteName: "",
//       description: "",
//       via: [],
//       upOriginCity: "",
//       upOriginState: "",
//       upOriginAddress: "",
//       upOriginTerminal: "",
//       upOriginCoords: null,
//       upDestCity: "",
//       upDestState: "",
//       upDestAddress: "",
//       upDestTerminal: "",
//       upDestCoords: null,
//       upTotalDistance: "",
//       upDurationHours: "",
//       upDurationMinutes: "",
//       upManualFirstLeg: "",
//       downManualFirstLeg: "",
//       upManualFinalLeg: "",
//       downManualFinalLeg: "",
//       destManualDistFromLastStop: "",
//       downTotalDistance: "",
//       downDurationHours: "",
//       downDurationMinutes: "",
//       stopCity: "",
//       stopState: "",
//       stopAddress: "",
//       stopTerminal: "",
//       stopCoords: null,
//       stopDistFromPrev: "",
//       stopDistToNext: "",
//       isBoarding: false,
//       isDropping: false,
//     });
//     setViaInput("");
//     setUpStops([]);
//     setDownStops([]);
//     setIsRoundTrip(false);
//     setActiveRouteTab("UP");
//     setIsDistanceCalculated({ up: false, down: false });
//     setActiveTab("basic");
//     setSelectedMasterRoute(null);
//     setIsOriginManual(false);
//     setIsDestinationManual(false);
//     setSelectorKey((prev) => prev + 1);
//   };

//   const handleViewRoute = async (route) => {
//     try {
//       const routeData = await getMasterRouteById(route.id, token);
//       setViewingRoute(routeData.data || routeData);
//     } catch (err) {
//       setViewingRoute(route.fullData);
//       toast.warning(
//         "Could not fetch latest route details. Showing cached data.",
//       );
//     }
//   };

//   const handleEditRoute = async (route) => {
//     try {
//       const response = await getMasterRouteById(route.id, token);
//       const routeData = response.data || route.fullData;

//       console.log("Master route data for edit:", routeData);

//       setEditingRoute(routeData);

//       const origin = routeData.origin || {};
//       const destination = routeData.destination || {};
//       const routeDetails = routeData.routeDetails || {};
//       const estimatedDuration = routeDetails.estimatedDuration || {};

//       const hasOriginCoords =
//         origin.coordinates &&
//         (origin.coordinates.lat !== 0 || origin.coordinates.lng !== 0);
//       const hasDestCoords =
//         destination.coordinates &&
//         (destination.coordinates.lat !== 0 ||
//           destination.coordinates.lng !== 0);

//       setIsOriginManual(!hasOriginCoords);
//       setIsDestinationManual(!hasDestCoords);

//       const viaData = (routeData.via || []).map((v, index) => ({
//         city: v.city || "",
//         state: v.state || "",
//         sequence: v.sequence || index + 1,
//       }));

//       console.log("Via data loaded:", viaData);

//       setNewRoute((prev) => ({
//         ...prev,
//         masterRouteName: routeData.masterRouteName || "",
//         description: routeData.description || "",
//         via: viaData,
//         upOriginCity: origin.city || "",
//         upOriginState: origin.state || "",
//         upOriginAddress:
//           origin.address || `${origin.city || ""}, ${origin.state || "India"}`,
//         upOriginTerminal: origin.terminal || `${origin.city || ""} Terminal`,
//         upOriginCoords: origin.coordinates || { lat: 0, lng: 0 },
//         upDestCity: destination.city || "",
//         upDestState: destination.state || "",
//         upDestAddress:
//           destination.address ||
//           `${destination.city || ""}, ${destination.state || "India"}`,
//         upDestTerminal:
//           destination.terminal || `${destination.city || ""} Terminal`,
//         upDestCoords: destination.coordinates || { lat: 0, lng: 0 },
//         upTotalDistance: routeDetails.totalDistance || "",
//         upDurationHours: estimatedDuration.hours || "",
//         upDurationMinutes: estimatedDuration.minutes || "",
//       }));

//       let upManualFinalLeg = "";
//       const upTotalDist = parseFloat(routeDetails.totalDistance) || 0;

//       if (routeData.intermediateStops &&
//       routeData.intermediateStops.length > 0) {
//         const lastStop =
//           routeData.intermediateStops[routeData.intermediateStops.length - 1];
//         const lastStopDistance = lastStop.distanceFromOrigin || 0;
//         const distanceToDest = upTotalDist - lastStopDistance;
//         if (distanceToDest > 0) {
//           upManualFinalLeg = distanceToDest.toFixed(1);
//         }
//       } else if (upTotalDist > 0 && !hasDestCoords) {
//         upManualFinalLeg = upTotalDist.toFixed(1);
//       }

//       const transformedStops = (routeData.intermediateStops || []).map(
//         (stop, index, array) => ({
//           city: stop.city,
//           state: stop.state || "",
//           address:
//             stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
//           terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
//           stopType: stop.stopType || "none",
//           coordinates: stop.coordinates || { lat: 0, lng: 0 },
//           distanceFromOrigin: stop.distanceFromOrigin || 0,
//           manualDistFromPrev:
//             index === 0
//               ? stop.distanceFromOrigin - (origin.distanceFromOrigin || 0)
//               : stop.distanceFromOrigin -
//                 (array[index - 1].distanceFromOrigin || 0),
//           manualDistToNext: stop.manualDistToNext || null,
//           isManualStop:
//             !stop.coordinates ||
//             (stop.coordinates.lat === 0 && stop.coordinates.lng === 0),
//         }),
//       );

//       transformedStops.forEach((stop) => {
//         if (stop.manualDistFromPrev > 0) {
//           stop.manualDistFromPrev = parseFloat(
//             stop.manualDistFromPrev.toFixed(1),
//           );
//         }
//       });

//       setUpStops(transformedStops);

//       const upDistancesCalculated = transformedStops.every(
//         (stop) => stop.distanceFromOrigin > 0,
//       );
//       setIsDistanceCalculated((prev) => ({
//         ...prev,
//         up: upDistancesCalculated,
//       }));

//       const editFormData = {
//         masterRouteNumber: routeData.masterRouteNumber || "",
//         masterRouteName: routeData.masterRouteName || "",
//         description: routeData.description || "",
//         via: viaData,
//         originCity: origin.city || "",
//         originState: origin.state || "",
//         originAddress:
//           origin.address || `${origin.city || ""}, ${origin.state || "India"}`,
//         originTerminal: origin.terminal || `${origin.city || ""} Terminal`,
//         originCoords: origin.coordinates || { lat: 0, lng: 0 },
//         destCity: destination.city || "",
//         destState: destination.state || "",
//         destAddress:
//           destination.address ||
//           `${destination.city || ""}, ${destination.state || "India"}`,
//         destTerminal:
//           destination.terminal || `${destination.city || ""} Terminal`,
//         destCoords: destination.coordinates || { lat: 0, lng: 0 },
//         totalDistance: routeDetails.totalDistance || "",
//         durationHours: estimatedDuration.hours || "",
//         durationMinutes: estimatedDuration.minutes || "",
//         isActive: routeData.isActive,
//         isRoundTrip: routeData.isRoundTrip || false,
//         upManualFinalLeg: upManualFinalLeg,
//         returnManualFinalLeg: "",
//       };

//       if (routeData.isRoundTrip && routeData.returnJourney) {
//         const returnJourney = routeData.returnJourney;
//         const returnOrigin = returnJourney.origin || {};
//         const returnDestination = returnJourney.destination || {};
//         const returnRouteDetails = returnJourney.routeDetails || {};
//         const returnEstimatedDuration =
//           returnRouteDetails.estimatedDuration || {};

//         let returnManualFinalLeg = "";
//         const returnTotalDist =
//           parseFloat(returnRouteDetails.totalDistance) || 0;

//         const hasReturnDestCoords =
//           returnDestination.coordinates &&
//           (returnDestination.coordinates.lat !== 0 ||
//             returnDestination.coordinates.lng !== 0);

//         if (
//           returnJourney.intermediateStops &&
//           returnJourney.intermediateStops.length > 0
//         ) {
//           const returnLastStop =
//             returnJourney.intermediateStops[
//               returnJourney.intermediateStops.length - 1
//             ];
//           const returnLastStopDistance = returnLastStop.distanceFromOrigin || 0;
//           const returnDistanceToDest = returnTotalDist - returnLastStopDistance;
//           if (returnDistanceToDest > 0) {
//             returnManualFinalLeg = returnDistanceToDest.toFixed(1);
//           }
//         } else if (returnTotalDist > 0 && !hasReturnDestCoords) {
//           returnManualFinalLeg = returnTotalDist.toFixed(1);
//         }

//         const transformedReturnStops = (
//           returnJourney.intermediateStops || []
//         ).map((stop, index, array) => ({
//           city: stop.city,
//           state: stop.state || "",
//           address:
//             stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
//           terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
//           stopType: stop.stopType || "none",
//           coordinates: stop.coordinates || { lat: 0, lng: 0 },
//           distanceFromOrigin: stop.distanceFromOrigin || 0,
//           manualDistFromPrev:
//             index === 0
//               ? stop.distanceFromOrigin - (returnOrigin.distanceFromOrigin || 0)
//               : stop.distanceFromOrigin -
//                 (array[index - 1].distanceFromOrigin || 0),
//           manualDistToNext: stop.manualDistToNext || null,
//           isManualStop:
//             !stop.coordinates ||
//             (stop.coordinates.lat === 0 && stop.coordinates.lng === 0),
//         }));

//         transformedReturnStops.forEach((stop) => {
//           if (stop.manualDistFromPrev > 0) {
//             stop.manualDistFromPrev = parseFloat(
//               stop.manualDistFromPrev.toFixed(1),
//             );
//           }
//         });

//         setDownStops(transformedReturnStops);

//         const downDistancesCalculated = transformedReturnStops.every(
//           (stop) => stop.distanceFromOrigin > 0,
//         );
//         setIsDistanceCalculated((prev) => ({
//           ...prev,
//           down: downDistancesCalculated,
//         }));

//         editFormData.returnOriginCity = returnOrigin.city || "";
//         editFormData.returnOriginState = returnOrigin.state || "";
//         editFormData.returnOriginAddress =
//           returnOrigin.address ||
//           `${returnOrigin.city || ""}, ${returnOrigin.state || "India"}`;
//         editFormData.returnOriginTerminal =
//           returnOrigin.terminal || `${returnOrigin.city || ""} Terminal`;
//         editFormData.returnOriginCoords = returnOrigin.coordinates || {
//           lat: 0,
//           lng: 0,
//         };
//         editFormData.returnDestCity = returnDestination.city || "";
//         editFormData.returnDestState = returnDestination.state || "";
//         editFormData.returnDestAddress =
//           returnDestination.address ||
//           `${returnDestination.city || ""}, ${returnDestination.state || "India"}`;
//         editFormData.returnDestTerminal =
//           returnDestination.terminal ||
//           `${returnDestination.city || ""} Terminal`;
//         editFormData.returnDestCoords = returnDestination.coordinates || {
//           lat: 0,
//           lng: 0,
//         };
//         editFormData.returnTotalDistance =
//           returnRouteDetails.totalDistance || "";
//         editFormData.returnDurationHours = returnEstimatedDuration.hours || "";
//         editFormData.returnDurationMinutes =
//           returnEstimatedDuration.minutes || "";
//         editFormData.returnManualFinalLeg = returnManualFinalLeg;

//         setIsRoundTrip(true);
//       } else {
//         setIsRoundTrip(false);
//         setDownStops([]);
//       }

//       setEditForm(editFormData);
//       setShowEditModal(true);
//     } catch (err) {
//       console.error("Error fetching master route for edit:", err);
//       toast.error("Failed to load master route for editing");
//     }
//   };

//   if (loading && routes.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   const handleUpdateRoute = async () => {
//     setIsUpdatingRoute(true);

//     try {
//       if (!editForm.originCity || !editForm.destCity) {
//         toast.error("Origin and Destination are required");
//         setIsUpdatingRoute(false);
//         return;
//       }

//       const originData = {
//         city: editForm.originCity,
//         state: editForm.originState || "",
//         address: editForm.originAddress || `${editForm.originCity}, India`,
//         terminal: editForm.originTerminal || `${editForm.originCity} Terminal`,
//         coordinates: editForm.originCoords || { lat: 0, lng: 0 },
//         distanceFromOrigin: 0,
//       };

//       const destData = {
//         city: editForm.destCity,
//         state: editForm.destState || "",
//         address: editForm.destAddress || `${editForm.destCity}, India`,
//         terminal: editForm.destTerminal || `${editForm.destCity} Terminal`,
//         coordinates: editForm.destCoords || { lat: 0, lng: 0 },
//         distanceFromOrigin: parseFloat(editForm.totalDistance || 0),
//       };

//       const cleanStops = (list) =>
//         list.map((s, index) => {
//           const stopPayload = {
//             sequence: index + 1,
//             city: s.city,
//             state: s.state || "",
//             address: s.address || `${s.city}, India`,
//             terminal: s.terminal || `${s.city} Terminal`,
//             stopType: s.stopType || "none",
//             coordinates: s.coordinates || { lat: 0, lng: 0 },
//             distanceFromOrigin: parseFloat(s.distanceFromOrigin || 0),
//           };

//           if (s.manualDistFromPrev)
//             stopPayload.manualDistFromPrev = parseFloat(s.manualDistFromPrev);
//           if (s.manualDistToNext)
//             stopPayload.manualDistToNext = parseFloat(s.manualDistToNext);

//           return stopPayload;
//         });

//       const updatePayload = {
//         masterRouteName: editForm.masterRouteName.trim(),
//         description: editForm.description || "",
//         via: editForm.via || [],
//         origin: originData,
//         destination: destData,
//         intermediateStops: cleanStops(upStops),
//         routeDetails: {
//           totalDistance: parseFloat(editForm.totalDistance || 0),
//           estimatedDuration: {
//             hours: parseInt(editForm.durationHours || 0, 10),
//             minutes: parseInt(editForm.durationMinutes || 0, 10),
//           },
//         },
//         isActive: editForm.isActive,
//         isRoundTrip: editForm.isRoundTrip || false,
//       };
//       if (editForm.isRoundTrip) {
//         if (!editForm.returnOriginCity || !editForm.returnDestCity) {
//           toast.error(
//             "Return Origin and Destination are required for Round Trip",
//           );
//           setIsUpdatingRoute(false);
//           return;
//         }

//         const returnOriginData = {
//           city: editForm.returnOriginCity,
//           state: editForm.returnOriginState || "",
//           address:
//             editForm.returnOriginAddress ||
//             `${editForm.returnOriginCity}, India`,
//           terminal:
//             editForm.returnOriginTerminal ||
//             `${editForm.returnOriginCity} Terminal`,
//           coordinates: editForm.returnOriginCoords || { lat: 0, lng: 0 },
//           distanceFromOrigin: 0,
//         };

//         const returnDestData = {
//           city: editForm.returnDestCity,
//           state: editForm.returnDestState || "",
//           address:
//             editForm.returnDestAddress || `${editForm.returnDestCity}, India`,
//           terminal:
//             editForm.returnDestTerminal ||
//             `${editForm.returnDestCity} Terminal`,
//           coordinates: editForm.returnDestCoords || { lat: 0, lng: 0 },
//           distanceFromOrigin: parseFloat(
//             editForm.returnTotalDistance || editForm.totalDistance || 0,
//           ),
//         };

//         updatePayload.returnJourney = {
//           origin: returnOriginData,
//           destination: returnDestData,
//           intermediateStops: cleanStops(downStops),
//           routeDetails: {
//             totalDistance: parseFloat(
//               editForm.returnTotalDistance || editForm.totalDistance || 0,
//             ),
//             estimatedDuration: {
//               hours: parseInt(
//                 editForm.returnDurationHours || editForm.durationHours || 0,
//                 10,
//               ),
//               minutes: parseInt(
//                 editForm.returnDurationMinutes || editForm.durationMinutes || 0,
//                 10,
//               ),
//             },
//           },
//         };
//       }

//       console.log("Update Payload:", JSON.stringify(updatePayload, null, 2));

//       const response = await updateMasterRoute(
//         editingRoute._id,
//         updatePayload,
//         token,
//       );

//       if (response.success) {
//         toast.success(
//           editForm.isRoundTrip
//             ? "Master route updated to Round Trip successfully!"
//             : "Master route updated successfully!",
//         );
//         setShowEditModal(false);
//         setEditingRoute(null);
//         setEditForm({});
//         setUpStops([]);
//         setDownStops([]);
//         fetchRoutes();
//       } else {
//         throw new Error(response.message || "Failed to update master route");
//       }
//     } catch (err) {
//       console.error("Error updating master route:", err);
//       toast.error(err.message || "Failed to update master route");
//     } finally {
//       setIsUpdatingRoute(false);
//     }
//   };

//   const handleEditOriginSelect = (location) => {
//     setEditForm((prev) => ({
//       ...prev,
//       originCity: location.city || location.name || "",
//       originState: location.state || "",
//       originAddress: location.address || "",
//       originCoords: location.coordinates || { lat: 0, lng: 0 },
//     }));
//   };

//   const handleEditDestSelect = (location) => {
//     setEditForm((prev) => ({
//       ...prev,
//       destCity: location.city || location.name || "",
//       destState: location.state || "",
//       destAddress: location.address || "",
//       destCoords: location.coordinates || { lat: 0, lng: 0 },
//     }));
//   };

//   const handleToggleStatus = async (routeId, currentStatus) => {
//     const newStatus = !currentStatus;
//     const action = newStatus ? "activate" : "deactivate";

//     if (
//       window.confirm(`Are you sure you want to ${action} this master route?`)
//     ) {
//       try {
//         const response = await toggleMasterRouteStatus(
//           routeId,
//           newStatus,
//           token,
//         );

//         if (response.success) {
//           setRoutes((prevRoutes) =>
//             prevRoutes.map((route) =>
//               route.id === routeId
//                 ? {
//                     ...route,
//                     isActive: newStatus,
//                     status: newStatus ? "Active" : "Inactive",
//                   }
//                 : route,
//             ),
//           );
//           toast.success(`Master route ${action}d successfully!`);
//         } else {
//           throw new Error(
//             response.message || `Failed to ${action} master route`,
//           );
//         }
//       } catch (err) {
//         console.error(`Error ${action}ing master route:`, err);
//         toast.error(`Failed to ${action} master route`);
//       }
//     }
//   };

//   const handleDeleteRoute = async (routeId) => {
//     if (
//       window.confirm(
//         "Are you sure you want to delete this master route? This action cannot be undone.",
//       )
//     ) {
//       try {
//         const response = await deleteMasterRoute(routeId, token);

//         if (response.success) {
//           setRoutes((prevRoutes) =>
//             prevRoutes.filter((route) => route.id !== routeId),
//           );
//           setTotalRoutes((prev) => prev - 1);
//           toast.success("Master route deleted successfully!");
//         } else {
//           throw new Error(response.message || "Failed to delete master route");
//         }
//       } catch (err) {
//         console.error("Error deleting master route:", err);
//         toast.error("Failed to delete master route");
//       }
//     }
//   };

//   const renderInsertButton = (idx, type = "up") => {
//     const isOpen = inlineInsertIndex === idx;
//     const stops = getActiveStops();

//     return (
//       <div
//         key={`insert-wrap-${idx}`}
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//         }}
//       >

//         <div
//           style={{
//             width: 2,
//             height: 16,
//             background: "var(--color-border-tertiary, rgba(0,0,0,.12))",
//             flexShrink: 0,
//           }}
//         />


//         <button
//           onClick={() => {
//             if (isOpen) {
//               setInlineInsertIndex(null);
//               setInlineInsertCitySuggestions([]);
//               setShowInlineInsertDropdown(false);
//             } else {
//               let defaultState = "";
//               const currentStops = type === "up" ? upStops : downStops;
//               if (idx > 0 && currentStops[idx - 1]?.state)
//                 defaultState = currentStops[idx - 1].state;
//               else if (newRoute.upOriginState)
//                 defaultState = newRoute.upOriginState;

//               setInlineInsertForm({
//                 city: "",
//                 state: defaultState,
//                 address: "",
//                 terminal: "",
//                 stopType: "none",
//                 distFromPrev: "",
//                 distToNext: "",
//                 isManual: true,
//               });
//               setInlineInsertCitySuggestions([]);
//               setShowInlineInsertDropdown(false);
//               setInlineInsertIndex(idx);
//             }
//           }}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 6,
//             padding: "5px 14px",
//             borderRadius: 999,
//             border: `1.5px ${isOpen ? "solid" : "dashed"} ${isOpen ? "#378add" : "rgba(0,0,0,.25)"}`,
//             background: isOpen
//               ? "#e6f1fb"
//               : "var(--color-background-primary, #fff)",
//             fontSize: 12,
//             fontWeight: 500,
//             color: isOpen ? "#185fa5" : "var(--color-text-secondary, #666)",
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             transition: "all .15s",
//           }}
//         >
//           <span style={{ fontSize: 15 }}>{isOpen ? "✕" : "+"}</span>
//           {isOpen ? "Cancel insert" : "Insert stop here"}
//         </button>


//         <div
//           style={{
//             width: 2,
//             height: isOpen ? 0 : 16,
//             background: "var(--color-border-tertiary, rgba(0,0,0,.12))",
//             flexShrink: 0,
//           }}
//         />


//         {isOpen && renderInlineInsertPanel(idx)}
//       </div>
//     );
//   };
//   const activeRoutes = routes.filter((r) => r.isActive).length;
//   const totalDistance = routes.reduce(
//     (sum, route) => sum + (parseInt(route.distance) || 0),
//     0,
//   );
//   const totalStops = routes.reduce(
//     (sum, route) => sum + (parseInt(route.stops) || 0),
//     0,
//   );

//   if (loading && routes.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading master routes...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Master Route Management</h1>
//         <div className="header-actions">
//           <input
//             type="text"
//             placeholder="Search master routes by name, origin or destination..."
//             className="search-input"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <button className="refresh-btn" onClick={fetchRoutes}>
//             Refresh
//           </button>
//           <button
//             className="add-btn"
//             onClick={() => {
//               setSelectorKey((prev) => prev + 1);
//               setShowAddModal(true);
//             }}
//           >
//             + Add Master Route
//           </button>
//         </div>
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Routes</h3>
//           <p>{totalRoutes}</p>
//           <span>All registered master routes</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Routes</h3>
//           <p>{activeRoutes}</p>
//           <span>Currently active</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Stops</h3>
//           <p>{totalStops}</p>
//           <span>Across all routes</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Distance</h3>
//           <p>{totalDistance} km</p>
//           <span>Covered by all routes</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Route Name</th>
//               <th>Origin</th>
//               <th>Destination</th>
//               <th>Distance</th>
//               <th>Stops</th>
//               <th>Type</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {routes.map((route) => (
//               <tr key={route.id}>
//                 <td>{route.serialNo}</td>
//                 <td>{route.masterRouteName}</td>
//                 <td>
//                   <div>{route.originCity}</div>
//                   <div style={{ fontSize: "12px", color: "#666" }}>
//                     {route.originTerminal || "N/A"}
//                   </div>
//                   {route?.via?.length > 0 && (
//                     <div
//                       style={{
//                         fontSize: "10px",
//                         color: "#999",
//                         marginTop: "4px",
//                       }}
//                     >
//                       Via: {route.via.map((v) => v.city).join(", ")}
//                     </div>
//                   )}
//                 </td>
//                 <td>
//                   <div>{route.destinationCity}</div>
//                   <div style={{ fontSize: "12px", color: "#666" }}>
//                     {route.destTerminal || "N/A"}
//                   </div>
//                 </td>
//                 <td>{route.distance} km</td>
//                 <td>{route.stops}</td>
//                 <td>
//                   <span
//                     className={`route-type-badge ${route.isRoundTrip ? "roundtrip" : "oneway"}`}
//                   >
//                     {route.isRoundTrip ? "Round Trip" : "One Way"}
//                   </span>
//                 </td>
//                 <td>
//                   <span
//                     className={`status-badge ${route.status.toLowerCase()}`}
//                   >
//                     {route.status}
//                   </span>
//                 </td>
//                 <td>
//                   <div className="action-buttons">
//                     <button
//                       className="action-btn view"
//                       onClick={() => handleViewRoute(route)}
//                     >
//                       View
//                     </button>
//                     <button
//                       className="action-btn edit"
//                       onClick={() => handleEditRoute(route)}
//                       style={{
//                         backgroundColor: "#17a2b8",
//                         color: "white",
//                       }}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       className={`action-btn ${route.isActive ? "deactivate" : "activate"}`}
//                       onClick={() =>
//                         handleToggleStatus(route.id, route.isActive)
//                       }
//                       style={{
//                         backgroundColor: route.isActive ? "#ffc107" : "#28a745",
//                         color: route.isActive ? "#000" : "white",
//                       }}
//                     >
//                       {route.isActive ? "Deactivate" : "Activate"}
//                     </button>
//                     <button
//                       className="action-btn delete"
//                       onClick={() => handleDeleteRoute(route.id)}
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         {routes.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No master routes found matching your search.</p>
//           </div>
//         )}
//       </div>


//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {Math.min(pageSize, routes.length)} of {totalRoutes} routes
//           (Page {currentPage} of {totalPages})
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? "active" : ""}`}
//                   onClick={() => setCurrentPage(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={() =>
//               setCurrentPage((prev) => Math.min(totalPages, prev + 1))
//             }
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       </div>


//       {showAddModal && (
//         <div
//           className="modal-overlay add-route-modal"
//           onClick={() => setShowAddModal(false)}
//         >
//           <div
//             className="modal-content add-route-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3>Create New Master Route</h3>
//               <button
//                 className="modal-close-btn"
//                 onClick={() => setShowAddModal(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">

//               <div className="round-trip-toggle">
//                 <label className="checkbox-container">
//                   <input
//                     type="checkbox"
//                     checked={isRoundTrip}
//                     onChange={toggleRoundTrip}
//                     className="checkbox-input"
//                   />
//                   <span className="checkbox-label">
//                     Round Trip (Main + Return Routes)
//                   </span>
//                 </label>
//               </div>


//               {isRoundTrip && (
//                 <div className="route-tabs">
//                   <button
//                     className={`route-tab ${activeRouteTab === "UP" ? "active" : ""}`}
//                     onClick={() => handleTabSwitch("UP")}
//                   >
//                     UP (Main) Route
//                   </button>
//                   <button
//                     className={`route-tab ${activeRouteTab === "DOWN" ? "active" : ""}`}
//                     onClick={() => handleTabSwitch("DOWN")}
//                   >
//                     DOWN (Return) Route
//                   </button>
//                 </div>
//               )}

//               <div
//                 className="form-actions"
//                 style={{
//                   display: "flex",
//                   gap: "10px",
//                   justifyContent: "flex-end",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => {
//                     if (
//                       window.confirm(
//                         "Are you sure you want to clear all form data? This action cannot be undone.",
//                       )
//                     ) {
//                       resetNewRouteForm();
//                       setSelectedMasterRoute(null);
//                       setSelectorKey((prev) => prev + 1);
//                       toast.info("Form has been cleared");
//                     }
//                   }}
//                   style={{ padding: "10px 20px" }}
//                 >
//                   Clear All
//                 </button>
//               </div>

//               <div className="form-sections">

//                 <div className="form-section">
//                   <h4>Route Identity</h4>
//                   <div
//                     className="form-row"
//                     style={{
//                       display: "flex",
//                       gap: "20px",
//                       alignItems: "flex-start",
//                     }}
//                   >
//                     <div className="form-group" style={{ flex: 2 }}>
//                       <label>Select Master Route Name</label>
//                       <MasterRouteSelector
//                         key={selectorKey}
//                         token={token}
//                         value={selectedMasterRoute}
//                         onChange={(masterRoute) => {
//                           if (masterRoute) {
//                             autoFillFromMasterRoute(masterRoute);
//                           } else {
//                             setSelectedMasterRoute(null);
//                             resetNewRouteForm();
//                             setSelectorKey((prev) => prev + 1);
//                           }
//                         }}
//                         onRouteNameChange={(routeName) => {
//                           setNewRoute((prev) => ({
//                             ...prev,
//                             masterRouteName: routeName,
//                           }));
//                           if (selectedMasterRoute) {
//                             setSelectedMasterRoute({
//                               ...selectedMasterRoute,
//                               masterRouteName: routeName,
//                             });
//                           }
//                         }}
//                       />
//                     </div>
//                     <div className="form-group" style={{ flex: 1 }}>
//                       <label>Description</label>
//                       <textarea
//                         value={newRoute.description}
//                         onChange={(e) =>
//                           setNewRoute((prev) => ({
//                             ...prev,
//                             description: e.target.value,
//                           }))
//                         }
//                         placeholder="Route description (optional)"
//                         className="form-input"
//                         rows="3"
//                         style={{ resize: "vertical" }}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="form-section">
//                   <h4>Via Cities (Optional)</h4>
//                   <div className="via-cities-container">

//                     {newRoute.via.length > 0 && (
//                       <div className="via-list">
//                         {newRoute.via.map((viaCity, index) => (
//                           <div
//                             key={index}
//                             className="via-item"
//                             style={{
//                               display: "flex",
//                               gap: "10px",
//                               alignItems: "center",
//                               marginBottom: "10px",
//                               padding: "8px",
//                               backgroundColor: "#f8f9fa",
//                               borderRadius: "6px",
//                             }}
//                           >
//                             <div
//                               style={{ fontWeight: "bold", minWidth: "30px" }}
//                             >
//                               {index + 1}.
//                             </div>
//                             <div style={{ flex: 2 }}>
//                               <input
//                                 type="text"
//                                 value={viaCity.city}
//                                 onChange={(e) =>
//                                   updateViaCity(index, "city", e.target.value)
//                                 }
//                                 placeholder="City name"
//                                 className="form-input"
//                                 style={{ marginBottom: "0" }}
//                               />
//                             </div>
//                             <div style={{ flex: 2 }}>
//                               <input
//                                 type="text"
//                                 value={viaCity.state}
//                                 onChange={(e) =>
//                                   updateViaCity(index, "state", e.target.value)
//                                 }
//                                 placeholder="State (optional)"
//                                 className="form-input"
//                                 style={{ marginBottom: "0" }}
//                               />
//                             </div>
//                             <button
//                               type="button"
//                               onClick={() => removeViaCity(index)}
//                               className="btn btn-danger btn-sm"
//                               style={{
//                                 padding: "6px 12px",
//                                 backgroundColor: "#dc3545",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                               }}
//                             >
//                               ×
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     )}


//                     <div
//                       className="add-via-form"
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         marginTop: newRoute.via.length > 0 ? "10px" : "0",
//                       }}
//                     >
//                       <input
//                         type="text"
//                         value={viaInput}
//                         onChange={(e) => setViaInput(e.target.value)}
//                         onKeyPress={(e) => {
//                           if (e.key === "Enter") {
//                             addViaCity();
//                           }
//                         }}
//                         placeholder="Enter via city name..."
//                         className="form-input"
//                         style={{ flex: 3 }}
//                       />
//                       <button
//                         type="button"
//                         onClick={addViaCity}
//                         className="btn btn-secondary"
//                         style={{
//                           padding: "8px 16px",
//                           backgroundColor: "#6c757d",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "4px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         + Add Via City
//                       </button>
//                     </div>
//                     <small className="helper-text">
//                       Add major cities/towns the route passes through (for route
//                       identification)
//                     </small>
//                   </div>
//                 </div>


//                 <div className="form-section">
//                   <h4>
//                     {activeRouteTab === "UP"
//                       ? "Origin *"
//                       : "Return Origin (Locked to Main Dest)"}
//                   </h4>
                
//                   {activeRouteTab === "UP" ? (
//                     <>

//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>Search City *</label>
//                           <CitySearchInput
//                             token={token}
//                             value={newRoute.upOriginCity}
//                             onChange={(val) =>
//                               setNewRoute((prev) => ({ ...prev, upOriginCity: val }))
//                             }
//                             onCitySelect={handleOriginCitySelect}
//                             placeholder="Type origin city (min 2 chars)..."
//                             searchType="origin"
//                           />
//                           <small className="helper-text">
//                             Searches cities already registered in master routes
//                           </small>
//                         </div>
//                       </div>


//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>Address</label>
//                           <input
//                             type="text"
//                             value={newRoute.upOriginAddress}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 upOriginAddress: e.target.value,
//                               }))
//                             }
//                             placeholder="Auto-filled on city selection — edit if needed"
//                             className="form-input"
//                           />
//                         </div>
//                       </div>


//                       <div className="form-row">
//                         <div className="form-group">
//                           <label>State</label>
//                           <input
//                             type="text"
//                             value={newRoute.upOriginState}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 upOriginState: toProperCase(e.target.value),
//                               }))
//                             }
//                             placeholder="State"
//                             className="form-input"
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Terminal</label>
//                           <input
//                             type="text"
//                             value={newRoute.upOriginTerminal}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 upOriginTerminal: e.target.value,
//                               }))
//                             }
//                             placeholder="Terminal name"
//                             className="form-input"
//                           />
//                         </div>
//                       </div>


//                       {upStops.length > 0 &&
//                         checkOriginManual() !== isFirstStopManual() && (
//                           <div className="form-row">
//                             <div className="form-group full-width">
//                               <label>Distance from Origin to First Stop (km) *</label>
//                               <input
//                                 type="number"
//                                 value={newRoute.upManualFirstLeg}
//                                 onChange={(e) =>
//                                   setNewRoute((prev) => ({
//                                     ...prev,
//                                     upManualFirstLeg: e.target.value,
//                                   }))
//                                 }
//                                 placeholder="Distance from origin to first stop"
//                                 className="form-input"
//                                 min="0"
//                                 step="0.1"
//                                 style={{ borderColor: "#dc3545", backgroundColor: "#fff5f5" }}
//                               />
//                               <small className="helper-text" style={{ color: "#dc3545" }}>
//                                 ⚠️ Origin and first stop have different types. Please
//                                 provide the distance.
//                               </small>
//                             </div>
//                           </div>
//                         )}
//                     </>
//                   ) : (
//                     <div className="locked-fields">
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <input
//                             type="text"
//                             value={newRoute.upDestCity || "Auto-filled from Main Destination"}
//                             className="form-input locked"
//                             disabled
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>




//                 <div className="form-section">
//                   <h4>
//                     {activeRouteTab === "UP"
//                       ? "Destination *"
//                       : "Return Destination (Locked to Main Origin)"}
//                   </h4>
                
//                   {activeRouteTab === "UP" ? (
//                     <>

//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>Search City *</label>
//                           <CitySearchInput
//                             token={token}
//                             value={newRoute.upDestCity}
//                             onChange={(val) =>
//                               setNewRoute((prev) => ({ ...prev, upDestCity: val }))
//                             }
//                             onCitySelect={handleDestCitySelect}
//                             placeholder="Type destination city (min 2 chars)..."
//                             searchType="destination"
//                           />
//                           <small className="helper-text">
//                             Searches cities already registered in master routes
//                           </small>
//                         </div>
//                       </div>


//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>Address</label>
//                           <input
//                             type="text"
//                             value={newRoute.upDestAddress}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 upDestAddress: e.target.value,
//                               }))
//                             }
//                             placeholder="Auto-filled on city selection — edit if needed"
//                             className="form-input"
//                           />
//                         </div>
//                       </div>


//                       <div className="form-row">
//                         <div className="form-group">
//                           <label>State</label>
//                           <input
//                             type="text"
//                             value={newRoute.upDestState}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 upDestState: toProperCase(e.target.value),
//                               }))
//                             }
//                             placeholder="State"
//                             className="form-input"
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Terminal</label>
//                           <input
//                             type="text"
//                             value={newRoute.upDestTerminal}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 upDestTerminal: e.target.value,
//                               }))
//                             }
//                             placeholder="Terminal name"
//                             className="form-input"
//                           />
//                         </div>
//                       </div>


//                       {upStops.length > 0 && (
//                         <>
//                           {checkDestinationManual() && (
//                             <div className="form-row">
//                               <div className="form-group full-width">
//                                 <label>Distance from Last Stop to Destination (km) *</label>
//                                 <input
//                                   type="number"
//                                   value={newRoute.upManualFinalLeg}
//                                   onChange={(e) =>
//                                     syncDestinationDistance(e.target.value, "upManualFinalLeg")
//                                   }
//                                   placeholder="Distance from last stop to destination"
//                                   className="form-input"
//                                   min="0"
//                                   step="0.1"
//                                   style={{ borderColor: "#dc3545", backgroundColor: "#fff5f5" }}
//                                 />
//                                 <small className="helper-text" style={{ color: "#dc3545" }}>
//                                   ⚠️ Destination is manual — please provide distance from the
//                                   last stop
//                                 </small>
//                               </div>
//                             </div>
//                           )}
                
//                           {!checkDestinationManual() && isLastStopManual() && (
//                             <div className="form-row" style={{ marginTop: "10px" }}>
//                               <div className="form-group full-width">
//                                 <label>Distance from Last Stop to Destination (km) *</label>
//                                 <input
//                                   type="number"
//                                   value={newRoute.destManualDistFromLastStop}
//                                   onChange={(e) =>
//                                     syncDestinationDistance(
//                                       e.target.value,
//                                       "destManualDistFromLastStop"
//                                     )
//                                   }
//                                   placeholder="Distance from last manual stop to destination"
//                                   className="form-input"
//                                   min="0"
//                                   step="0.1"
//                                   style={{ borderColor: "#dc3545", backgroundColor: "#fff5f5" }}
//                                 />
//                                 <small className="helper-text" style={{ color: "#dc3545" }}>
//                                   ⚠️ Last stop is manual, destination has GPS — please provide
//                                   distance
//                                 </small>
//                               </div>
//                             </div>
//                           )}
//                         </>
//                       )}
//                     </>
//                   ) : (
//                     <div className="locked-fields">
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <input
//                             type="text"
//                             value={newRoute.upOriginCity || "Auto-filled from Main Origin"}
//                             className="form-input locked"
//                             disabled
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>




//                 <div className="form-section stops-section">
//                   <h4>Intermediate Stops ({activeRouteTab})</h4>

//                   {activeRouteTab === "DOWN" && (
//                     <button
//                       className="sync-btn"
//                       onClick={() => syncDownStopsWithUpStops(true)}
//                     >
//                       🔄 Auto-Fill / Sync Reversed Stops from UP Route
//                     </button>
//                   )}

//                   <div className="stops-list">

//                     {renderInsertButton(
//                       0,
//                       activeRouteTab === "UP" ? "up" : "down",
//                     )}


//                     {getActiveStops().map((stop, index) => (
//                       <React.Fragment key={index}>
//                         <div
//                           className="stop-list-item"
//                           style={{
//                             backgroundColor: "#fff",
//                             border: "1px solid #e0e0e0",
//                             borderRadius: "8px",
//                             padding: "12px 16px",
//                             marginBottom: "12px",
//                             transition: "all 0.2s ease",
//                           }}
//                         >
//                           <div className="stop-info">
//                             <div
//                               className="stop-name"
//                               style={{
//                                 fontSize: "16px",
//                                 fontWeight: "500",
//                                 marginBottom: "8px",
//                               }}
//                             >
//                               {index + 1}. {stop.city}
//                               <span
//                                 className="stop-distance"
//                                 style={{
//                                   fontSize: "13px",
//                                   color: "#6c757d",
//                                   marginLeft: "8px",
//                                   fontWeight: "normal",
//                                 }}
//                               >
//                                 ({formatDistance(stop.distanceFromOrigin)}km)
//                                                               </span>
//                             </div>

//                             <div
//                               className="stop-address-detail"
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#495057",
//                                 marginBottom: "8px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "4px",
//                               }}
//                             >
//                               📍{" "}
//                               {stop.address ||
//                                 `${stop.city}, ${stop.state || "India"}`}
//                             </div>


//                             <div
//                               style={{
//                                 display: "flex",
//                                 gap: "16px",
//                                 marginBottom: "8px",
//                                 fontSize: "13px",
//                               }}
//                             >
//                               {stop.state && (
//                                 <div>
//                                   <span style={{ color: "#6c757d" }}>
//                                     State:
//                                   </span>{" "}
//                                   {stop.state}
//                                 </div>
//                               )}
//                               {stop.terminal && (
//                                 <div>
//                                   <span style={{ color: "#6c757d" }}>
//                                     Terminal:
//                                   </span>{" "}
//                                   {stop.terminal}
//                                 </div>
//                               )}
//                             </div>



//                             {stop.manualDistToNext && (
//                               <div
//                                 className="stop-next-distance"
//                                 style={{
//                                   fontSize: "12px",
//                                   color: "#dc3545",
//                                   marginTop: "4px",
//                                 }}
//                               >
//                                 → Next: {stop.manualDistToNext} km
//                               </div>
//                             )}
//                           </div>
//                           <div
//                             className="stop-actions"
//                             style={{
//                               display: "flex",
//                               gap: "8px",
//                               marginTop: "10px",
//                               paddingTop: "8px",
//                               borderTop: "1px solid #f0f0f0",
//                             }}
//                           >
//                             <button
//                               className="stop-action-btn edit"
//                               onClick={() =>
//                                 handleEditStop(
//                                   index,
//                                   activeRouteTab === "UP" ? "up" : "down",
//                                 )
//                               }
//                               style={{
//                                 padding: "4px 12px",
//                                 fontSize: "12px",
//                                 backgroundColor: "#17a2b8",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                               }}
//                             >
//                               Edit
//                             </button>
//                             <button
//                               className="stop-action-btn delete"
//                               onClick={() => handleDeleteStop(index)}
//                               style={{
//                                 padding: "4px 12px",
//                                 fontSize: "12px",
//                                 backgroundColor: "#dc3545",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                               }}
//                             >
//                               Delete
//                             </button>
//                           </div>
//                         </div>


//                         {renderInsertButton(
//                           index + 1,
//                           activeRouteTab === "UP" ? "up" : "down",
//                         )}
//                       </React.Fragment>
//                     ))}
//                   </div>
//                   <div className="stop-form">
//                     <h5>
//                       {editingStopIndex !== null
//                         ? `Edit Stop #${editingStopIndex + 1}`
//                         : insertIndex !== null
//                           ? `Insert Stop at #${insertIndex + 1}`
//                           : "Add Stop at End"}
//                     </h5>

//                     {insertIndex !== null && (
//                       <button
//                         className="cancel-insert-btn"
//                         onClick={() => setInsertIndex(null)}
//                       >
//                         Cancel Insert
//                       </button>
//                     )}

//                     <div className="form-row">
//                       <Checkbox
//                         label="Manually Typed Stop (No Map Suggestions)"
//                         checked={isManualStop}
//                         onChange={() => {
//                           setIsManualStop(!isManualStop);
//                           if (!isManualStop) {
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopCity: "",
//                               stopCoords: null,
//                               stopDistFromPrev: "",
//                               stopDistToNext: "",
//                               stopAddress: "",
//                               stopState: "",
//                               stopTerminal: "",
//                             }));
//                             setCitySuggestions([]);
//                             setShowCityDropdown(false);
//                           } else {
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopCity: "",
//                               stopCoords: null,
//                               stopDistFromPrev: "",
//                               stopDistToNext: "",
//                               stopAddress: "",
//                               stopState: "",
//                               stopTerminal: "",
//                             }));
//                             setCitySuggestions([]);
//                             setShowCityDropdown(false);
//                           }
//                         }}
//                       />
//                     </div>

//                     {!isManualStop ? (
//                       <>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>Search Location</label>
//                             <LocationInput
//                               value={newRoute.stopCity}
//                               onChange={(value) =>
//                                 setNewRoute((prev) => ({
//                                   ...prev,
//                                   stopCity: value,
//                                 }))
//                               }
//                               onLocationSelect={handleSelectStop}
//                               placeholder="Search stop city or address..."
//                             />
//                           </div>
//                         </div>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>Address *</label>
//                             <input
//                               type="text"
//                               value={newRoute.stopAddress}
//                               onChange={(e) =>
//                                 setNewRoute((prev) => ({
//                                   ...prev,
//                                   stopAddress: e.target.value,
//                                 }))
//                               }
//                               placeholder="Full address (e.g., NH-19, Near Bus Stand)"
//                               className="form-input"
//                             />
//                             <small className="helper-text">
//                               Complete address of the stop location
//                             </small>
//                           </div>
//                         </div>
//                       </>
//                     ) : (
//                       <>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>Search City *</label>
//                             <div
//                               className="city-search-container"
//                               style={{ position: "relative" }}
//                             >
//                               <input
//                                 type="text"
//                                 value={newRoute.stopCity}
//                                 onChange={async (e) => {
//                                   const value = e.target.value;
//                                   setNewRoute((prev) => ({
//                                     ...prev,
//                                     stopCity: value,
//                                   }));

//                                   if (value !== newRoute.stopCity) {
//                                     setNewRoute((prev) => ({
//                                       ...prev,
//                                       stopAddress: "",
//                                       stopState: "",
//                                       stopTerminal: "",
//                                     }));
//                                   }

//                                   if (value.length >= 2) {
//                                     try {
//                                       console.log(
//                                         "Searching for city (manual mode):",
//                                         value,
//                                       );

//                                       const searchFn =
//                                         activeRouteTab === "UP"
//                                           ? searchRouteIntermediateStops
//                                           : searchRouteIntermediateStops;

//                                       const response = await searchFn(
//                                         token,
//                                         value,
//                                       );
//                                       console.log("API Response:", response);

//                                       if (
//                                         response.success &&
//                                         response.cities &&
//                                         response.cities.length > 0
//                                       ) {
//                                         setCitySuggestions(response.cities);
//                                         setShowCityDropdown(true);
//                                       } else {
//                                         setCitySuggestions([]);
//                                         setShowCityDropdown(false);
//                                       }
//                                     } catch (error) {
//                                       console.error(
//                                         "Error searching cities:",
//                                         error,
//                                       );
//                                       setCitySuggestions([]);
//                                       setShowCityDropdown(false);
//                                     }
//                                   } else {
//                                     setCitySuggestions([]);
//                                     setShowCityDropdown(false);
//                                   }
//                                 }}
//                                 onFocus={() => {
//                                   if (citySuggestions.length > 0) {
//                                     setShowCityDropdown(true);
//                                   }
//                                 }}
//                                 onBlur={() => {
//                                   setTimeout(
//                                     () => setShowCityDropdown(false),
//                                     200,
//                                   );
//                                 }}
//                                 placeholder="Type city name (min 2 characters)..."
//                                 className="form-input"
//                               />
//                               {showCityDropdown &&
//                                 citySuggestions.length > 0 && (
//                                   <div
//                                     className="city-suggestions-dropdown"
//                                     style={{
//                                       position: "absolute",
//                                       top: "100%",
//                                       left: 0,
//                                       right: 0,
//                                       backgroundColor: "white",
//                                       border: "1px solid #ddd",
//                                       borderRadius: "4px",
//                                       maxHeight: "200px",
//                                       overflowY: "auto",
//                                       zIndex: 10000,
//                                       boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                                     }}
//                                   >
//                                     {citySuggestions.map((city, idx) => (
//                                       <div
//                                         key={city.id || idx}
//                                         onClick={() => {
//                                           console.log("Selected city:", city);
//                                           setNewRoute((prev) => ({
//                                             ...prev,
//                                             stopCity: city.name,
//                                             stopAddress:
//                                               city.address || city.name,
//                                             stopState: city.state || "",
//                                             stopTerminal:
//                                               city.terminal ||
//                                               `${city.name} Bus Stand`,
//                                             stopCoords:
//                                               city.coordinates || null,
//                                           }));
//                                           setShowCityDropdown(false);
//                                           toast.success(
//                                             `Auto-filled details for ${city.name}`,
//                                           );
//                                         }}
//                                         style={{
//                                           padding: "10px 12px",
//                                           cursor: "pointer",
//                                           borderBottom: "1px solid #f0f0f0",
//                                           transition: "background-color 0.2s",
//                                         }}
//                                         onMouseEnter={(e) =>
//                                           (e.currentTarget.style.backgroundColor =
//                                             "#f0f7ff")
//                                         }
//                                         onMouseLeave={(e) =>
//                                           (e.currentTarget.style.backgroundColor =
//                                             "white")
//                                         }
//                                       >
//                                         <div style={{ fontWeight: "500" }}>
//                                           {city.name}
//                                         </div>
//                                         <div
//                                           style={{
//                                             fontSize: "12px",
//                                             color: "#6c757d",
//                                           }}
//                                         >
//                                           {city.state}
//                                           {city.terminal &&
//                                             ` • ${city.terminal}`}
//                                         </div>
//                                         <div
//                                           style={{
//                                             fontSize: "11px",
//                                             color: "#999",
//                                             marginTop: "2px",
//                                           }}
//                                         >
//                                           {city.address !== city.name
//                                             ? city.address
//                                             : ""}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                             </div>
//                             <small className="helper-text">
//                               Type at least 2 characters to search for cities
//                               from existing routes
//                             </small>
//                           </div>
//                         </div>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>Address *</label>
//                             <input
//                               type="text"
//                               value={newRoute.stopAddress}
//                               onChange={(e) =>
//                                 setNewRoute((prev) => ({
//                                   ...prev,
//                                   stopAddress: e.target.value,
//                                 }))
//                               }
//                               placeholder="Complete address of the stop location"
//                               className="form-input"
//                             />
//                             <small className="helper-text">
//                               Complete address of the stop location
//                             </small>
//                           </div>
//                         </div>
//                       </>
//                     )}


//                     {(isManualStop ||
//                       !newRoute.stopCoords ||
//                       (newRoute.stopCoords?.lat === 0 &&
//                         newRoute.stopCoords?.lng === 0)) && (
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>Distance from Previous Stop (km) *</label>
//                           <input
//                             type="number"
//                             value={newRoute.stopDistFromPrev}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 stopDistFromPrev: e.target.value,
//                               }))
//                             }
//                             placeholder="e.g., 50"
//                             className="form-input"
//                             min="0"
//                             step="0.1"
//                           />
//                           <small className="helper-text">
//                             Required for manual stops
//                           </small>
//                         </div>
//                       </div>
//                     )}


//                     {isManualStop &&
//                       (() => {
//                         const stops = getActiveStops();
//                         const currentIndex =
//                           editingStopIndex !== null
//                             ? editingStopIndex
//                             : insertIndex !== null
//                               ? insertIndex
//                               : stops.length;
//                         const nextStop = stops[currentIndex];
//                         const isNextAuto =
//                           nextStop &&
//                           nextStop.coordinates &&
//                           (nextStop.coordinates.lat !== 0 ||
//                             nextStop.coordinates.lng !== 0);

//                         if (isNextAuto) {
//                           return (
//                             <div className="form-row">
//                               <div className="form-group full-width">
//                                 <label>
//                                   Distance to Next Stop ({nextStop.city}) (km) *
//                                 </label>
//                                 <input
//                                   type="number"
//                                   value={newRoute.stopDistToNext}
//                                   onChange={(e) =>
//                                     setNewRoute((prev) => ({
//                                       ...prev,
//                                       stopDistToNext: e.target.value,
//                                     }))
//                                   }
//                                   placeholder={`Distance from ${newRoute.stopCity || "this stop"} to ${nextStop.city}`}
//                                   className="form-input"
//                                   min="0"
//                                   step="0.1"
//                                 />
//                                 <small
//                                   className="helper-text"
//                                   style={{ color: "#dc3545" }}
//                                 >
//                                   ⚠️ Required because next stop "{nextStop.city}
//                                   " has GPS coordinates
//                                 </small>
//                               </div>
//                             </div>
//                           );
//                         }
//                         return null;
//                       })()}

//                     <div className="form-row">
//                       <div className="form-group">
//                         <label>State</label>
//                         <input
//                           type="text"
//                           value={newRoute.stopState}
//                           onChange={(e) =>
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopState: toProperCase(e.target.value),
//                             }))
//                           }
//                           placeholder="State"
//                           className="form-input"
//                         />
//                       </div>
//                       <div className="form-group">
//                         <label>Terminal</label>
//                         <input
//                           type="text"
//                           value={newRoute.stopTerminal}
//                           onChange={(e) =>
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopTerminal: e.target.value,
//                             }))
//                           }
//                           placeholder="Terminal name"
//                           className="form-input"
//                         />
//                       </div>
//                     </div>

//                     <button
//                       className="btn btn-secondary add-stop-btn"
//                       onClick={() =>
//                         addIntermediateStop(
//                           activeRouteTab === "UP" ? "up" : "down",
//                         )
//                       }
//                       disabled={
//                         !newRoute.stopCity ||
//                         ((isManualStop || !newRoute.stopCoords) &&
//                           (!newRoute.stopDistFromPrev ||
//                             parseFloat(newRoute.stopDistFromPrev) <= 0))
//                       }
//                     >
//                       {editingStopIndex !== null
//                         ? "Save Changes"
//                         : insertIndex !== null
//                           ? "Confirm Insertion"
//                           : "+ Append Stop"}
//                     </button>
//                   </div>
//                 </div>



//                 <div className="form-section">
//                   <h4>{activeRouteTab} Summary</h4>

//                   <button
//                     className="btn btn-success calculate-btn"
//                     onClick={handleCalculateDistances}
//                     disabled={isCalculatingDistances}
//                   >
//                     {isCalculatingDistances
//                       ? "Calculating..."
//                       : `Auto-Calculate Distances (${activeRouteTab})`}
//                   </button>


//                   {isLastStopManual() && (
//                     <div className="form-row" style={{ marginTop: "10px" }}>
//                       <div className="form-group full-width">
//                         <label>
//                           Distance from Last Stop to Destination (KM) *
//                         </label>
//                         <input
//                           type="number"
//                           value={
//                             activeRouteTab === "UP"
//                               ? newRoute.upManualFinalLeg
//                               : newRoute.downManualFinalLeg
//                           }
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (activeRouteTab === "UP") {
//                               syncDestinationDistance(
//                                 value,
//                                 "upManualFinalLeg",
//                               );
//                             } else {
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 downManualFinalLeg: value,
//                               }));
//                             }
//                           }}
//                           placeholder="Required because last stop is manual"
//                           className="form-input"
//                           min="0"
//                           step="0.1"
//                           style={{
//                             borderColor: "#dc3545",
//                             backgroundColor: "#fff5f5",
//                           }}
//                         />
//                         <small
//                           className="helper-text"
//                           style={{ color: "#dc3545" }}
//                         >
//                           ⚠️ The last stop is manual, so you must provide the
//                           distance to destination
//                         </small>
//                       </div>
//                     </div>
//                   )}

//                   <div className="form-row summary-fields">
//                     <div className="form-group">
//                       <label>Total Distance (KM)</label>
//                       <input
//                         type="number"
//                         value={
//                           activeRouteTab === "UP"
//                             ? newRoute.upTotalDistance
//                             : newRoute.downTotalDistance
//                         }
//                         onChange={(e) =>
//                           setNewRoute((prev) => ({
//                             ...prev,
//                             [activeRouteTab === "UP"
//                               ? "upTotalDistance"
//                               : "downTotalDistance"]: e.target.value,
//                           }))
//                         }
//                         className="form-input"
//                         min="0"
//                         step="0.1"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="form-actions">
//                 <button
//                   className="btn btn-primary save-route-btn"
//                   onClick={handleSaveRoute}
//                   disabled={
//                     isCreatingRoute ||
//                     !isDistanceCalculated.up ||
//                     (isRoundTrip && !isDistanceCalculated.down)
//                   }
//                 >
//                   {isCreatingRoute
//                     ? "Creating Master Route..."
//                     : "Add Master Route"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingRoute && (
//         <div className="modal-overlay" onClick={() => setViewingRoute(null)}>
//           <div
//             className="modal-content1 view-route-modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3>Master Route Details: {viewingRoute.masterRouteName}</h3>
//               <button
//                 className="modal-close-btn"
//                 onClick={() => setViewingRoute(null)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body view-modal-body">
//               <div className="route-details">
//                 <div className="detail-row">
//                   <label>Route Name:</label>
//                   <span>{viewingRoute.masterRouteName}</span>
//                 </div>
//                 {viewingRoute.description && (
//                   <div className="detail-row">
//                     <label>Description:</label>
//                     <span>{viewingRoute.description}</span>
//                   </div>
//                 )}

//                 {viewingRoute?.via?.length > 0 && (
//                   <div className="detail-section">
//                     <h4>Via Cities</h4>
//                     <div
//                       className="via-cities-list"
//                       style={{
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: "8px",
//                       }}
//                     >
//                       {viewingRoute?.via?.map((via, index) => (
//                         <span
//                           key={index}
//                           style={{
//                             backgroundColor: "#e9ecef",
//                             padding: "4px 12px",
//                             borderRadius: "20px",
//                             fontSize: "13px",
//                           }}
//                         >
//                           {via?.city}
//                           {via?.state ? `, ${via?.state}` : ""}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Route Type:</label>
//                   <span
//                     className={`route-type-badge ${viewingRoute.isRoundTrip ? "roundtrip" : "oneway"}`}
//                   >
//                     {viewingRoute.isRoundTrip ? "Round Trip" : "One Way"}
//                   </span>
//                 </div>

//                 <div className="detail-section">
//                   <h4>Origin</h4>
//                   <div className="detail-row">
//                     <label>City:</label>
//                     <span>{viewingRoute.origin?.city}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>State:</label>
//                     <span>{viewingRoute.origin?.state}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Terminal:</label>
//                     <span>{viewingRoute.origin?.terminal}</span>
//                   </div>
//                   {viewingRoute.origin?.address && (
//                     <div className="detail-row">
//                       <label>Address:</label>
//                       <span className="address-text">
//                         {viewingRoute.origin.address}
//                       </span>
//                     </div>
//                   )}
//                 </div>

//                 <div className="detail-section">
//                   <h4>Destination</h4>
//                   <div className="detail-row">
//                     <label>City:</label>
//                     <span>{viewingRoute.destination?.city}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>State:</label>
//                     <span>{viewingRoute.destination?.state}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Terminal:</label>
//                     <span>{viewingRoute.destination?.terminal}</span>
//                   </div>
//                   {viewingRoute.destination?.address && (
//                     <div className="detail-row">
//                       <label>Address:</label>
//                       <span className="address-text">
//                         {viewingRoute.destination.address}
//                       </span>
//                     </div>
//                   )}
//                 </div>


//                 {viewingRoute.intermediateStops &&
//                   viewingRoute.intermediateStops.length > 0 && (
//                     <div className="detail-section">
//                       <h4>
//                         Intermediate Stops (
//                         {viewingRoute.intermediateStops.length})
//                       </h4>
//                       <div className="stops-list-container">
//                         {viewingRoute.intermediateStops.map((stop, index) => (
//                           <div key={index} className="stop-card">
//                             <div className="stop-header">
//                               <span className="stop-sequence">
//                                 #{stop.sequence}
//                               </span>
//                               <span className="stop-city">{stop.city}</span>
//                               <span
//                                 className={`stop-type-badge ${stop.stopType}`}
//                               >
//                                 {stop.stopType === "both"
//                                   ? "Boarding & Dropping"
//                                   : stop.stopType === "boarding"
//                                     ? "Boarding"
//                                     : stop.stopType === "dropping"
//                                       ? "Dropping"
//                                       : "Stop"}
//                               </span>
//                             </div>
//                             <div className="stop-details">
//                               <div className="stop-info">
//                                 <span className="info-label">Distance:</span>
//                                 <span>{stop.distanceFromOrigin} km</span>
//                               </div>
//                               <div className="stop-info">
//                                 <span className="info-label">Terminal:</span>
//                                 <span>{stop.terminal}</span>
//                               </div>
//                               <div className="stop-info">
//                                 <span className="info-label">State:</span>
//                                 <span>{stop.state}</span>
//                               </div>
//                               {stop.manualDistToNext && (
//                                 <div className="stop-info">
//                                   <span className="info-label">To Next:</span>
//                                   <span>{stop.manualDistToNext} km</span>
//                                 </div>
//                               )}
//                               {stop.address && (
//                                 <div className="stop-info full-width">
//                                   <span className="info-label">Address:</span>
//                                   <span className="address-text">
//                                     {stop.address}
//                                   </span>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}


//                 {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
//                   <div className="detail-section return-journey">
//                     <h4>Return Journey</h4>

//                     <div className="return-subsection">
//                       <h5>Return Origin</h5>
//                       <div className="detail-row">
//                         <label>City:</label>
//                         <span>{viewingRoute.returnJourney.origin?.city}</span>
//                       </div>
//                     </div>

//                     <div className="return-subsection">
//                       <h5>Return Destination</h5>
//                       <div className="detail-row">
//                         <label>City:</label>
//                         <span>
//                           {viewingRoute.returnJourney.destination?.city}
//                         </span>
//                       </div>
//                       <div className="detail-row">
//                         <label>Distance:</label>
//                         <span>
//                           {
//                             viewingRoute.returnJourney.routeDetails
//                               ?.totalDistance
//                           }{" "}
//                           km
//                         </span>
//                       </div>
//                     </div>

//                     {viewingRoute.returnJourney.intermediateStops?.length >
//                       0 && (
//                       <div className="return-subsection">
//                         <h5>
//                           Return Stops (
//                           {viewingRoute.returnJourney.intermediateStops.length})
//                         </h5>
//                         <div className="stops-list-container">
//                           {viewingRoute.returnJourney.intermediateStops.map(
//                             (stop, index) => (
//                               <div key={index} className="stop-card">
//                                 <div className="stop-header">
//                                   <span className="stop-sequence">
//                                     #{stop.sequence}
//                                   </span>
//                                   <span className="stop-city">{stop.city}</span>
//                                   <span
//                                     className={`stop-type-badge ${stop.stopType}`}
//                                   >
//                                     {stop.stopType}
//                                   </span>
//                                 </div>
//                                 <div className="stop-details">
//                                   <div className="stop-info">
//                                     <span className="info-label">
//                                       Distance:
//                                     </span>
//                                     <span>{stop.distanceFromOrigin} km</span>
//                                   </div>
//                                   {stop.manualDistToNext && (
//                                     <div className="stop-info">
//                                       <span className="info-label">
//                                         To Next:
//                                       </span>
//                                       <span>{stop.manualDistToNext} km</span>
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             ),
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}

//                 <div className="detail-section">
//                   <h4>Route Details</h4>
//                   <div className="detail-row">
//                     <label>Total Distance:</label>
//                     <span>{viewingRoute.routeDetails?.totalDistance} km</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Estimated Duration:</label>
//                     <span>
//                       {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}
//                       h
//                       {viewingRoute.routeDetails?.estimatedDuration?.minutes ||
//                         0}
//                       m
//                     </span>
//                   </div>
//                 </div>

//                 <div className="detail-section">
//                   <h4>Status Information</h4>
//                   <div className="detail-row">
//                     <label>Status:</label>
//                     <span
//                       className={`status-badge ${viewingRoute.isActive ? "active" : "inactive"}`}
//                     >
//                       {viewingRoute.isActive ? "Active" : "Inactive"}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Created By:</label>
//                     <span>
//                       {viewingRoute.creatorName} ({viewingRoute.creatorType})
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Created At:</label>
//                     <span>
//                       {new Date(viewingRoute.createdAt).toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Updated At:</label>
//                     <span>
//                       {new Date(viewingRoute.updatedAt).toLocaleString()}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="modal-close-btn secondary"
//                 onClick={() => setViewingRoute(null)}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showEditModal && editingRoute && (
//         <div
//           className="modal-overlay edit-route-modal"
//           onClick={() => setShowEditModal(false)}
//         >
//           <div
//             className="modal-content edit-route-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3>Edit Master Route: {editingRoute.masterRouteName}</h3>
//               <button
//                 className="modal-close-btn"
//                 onClick={() => setShowEditModal(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="round-trip-toggle">
//                 <label className="checkbox-container">
//                   <input
//                     type="checkbox"
//                     checked={editForm.isRoundTrip}
//                     onChange={(e) => {
//                       const newIsRoundTrip = e.target.checked;

//                       if (newIsRoundTrip && !editForm.isRoundTrip) {
//                         const upPointsWithDistances = [
//                           {
//                             city: editForm.originCity,
//                             distanceFromOrigin: 0,
//                             coordinates: editForm.originCoords,
//                             isManualStop: false,
//                           },
//                           ...upStops.map((stop, idx) => {
//                             const prevDistance =
//                               idx === 0
//                                 ? 0
//                                 : upStops[idx - 1]?.distanceFromOrigin || 0;
//                             return {
//                               ...stop,
//                               distanceFromPrev:
//                                 stop.distanceFromOrigin - prevDistance,
//                             };
//                           }),
//                           {
//                             city: editForm.destCity,
//                             distanceFromOrigin:
//                               parseFloat(editForm.totalDistance) || 0,
//                             coordinates: editForm.destCoords,
//                             isManualStop: false,
//                             distanceFromPrev:
//                               parseFloat(editForm.totalDistance) -
//                               (upStops[upStops.length - 1]
//                                 ?.distanceFromOrigin || 0),
//                           },
//                         ];

//                         const returnOriginData = {
//                           city: editForm.destCity,
//                           state: editForm.destState || "",
//                           address: editForm.destAddress || "",
//                           terminal:
//                             editForm.destTerminal ||
//                             editForm.destCity + " Terminal",
//                           coordinates: editForm.destCoords || {
//                             lat: 0,
//                             lng: 0,
//                           },
//                         };

//                         const returnDestData = {
//                           city: editForm.originCity,
//                           state: editForm.originState || "",
//                           address: editForm.originAddress || "",
//                           terminal:
//                             editForm.originTerminal ||
//                             editForm.originCity + " Terminal",
//                           coordinates: editForm.originCoords || {
//                             lat: 0,
//                             lng: 0,
//                           },
//                         };

//                         const downPoints = [...upPointsWithDistances].reverse();
//                         let cumulativeDist = 0;
//                         const reversedStops = [];

//                         for (let i = 1; i < downPoints.length - 1; i++) {
//                           const currentPoint = downPoints[i];

//                           let segmentDistance =
//                             currentPoint.distanceFromPrev || 0;

//                           cumulativeDist += segmentDistance;

//                           let newStopType = currentPoint.stopType;
//                           if (currentPoint.stopType === "boarding") {
//                             newStopType = "dropping";
//                           } else if (currentPoint.stopType === "dropping") {
//                             newStopType = "boarding";
//                           }

//                           reversedStops.push({
//                             sequence: i,
//                             city: currentPoint.city,
//                             state: currentPoint.state || "",
//                             address: currentPoint.address || "",
//                             terminal: currentPoint.terminal || "",
//                             stopType: newStopType,
//                             coordinates: currentPoint.coordinates || {
//                               lat: 0,
//                               lng: 0,
//                             },
//                             distanceFromOrigin: parseFloat(
//                               cumulativeDist.toFixed(1),
//                             ),
//                             manualDistFromPrev:
//                               segmentDistance > 0
//                                 ? parseFloat(segmentDistance.toFixed(1))
//                                 : null,
//                             manualDistToNext: null,
//                             isManualStop: currentPoint.isManualStop || false,
//                           });
//                         }

//                         const returnTotalDistance = cumulativeDist;

//                         setEditForm((prev) => ({
//                           ...prev,
//                           isRoundTrip: true,
//                           returnOriginCity: returnOriginData.city,
//                           returnOriginState: returnOriginData.state,
//                           returnOriginAddress: returnOriginData.address,
//                           returnOriginTerminal: returnOriginData.terminal,
//                           returnOriginCoords: returnOriginData.coordinates,
//                           returnDestCity: returnDestData.city,
//                           returnDestState: returnDestData.state,
//                           returnDestAddress: returnDestData.address,
//                           returnDestTerminal: returnDestData.terminal,
//                           returnDestCoords: returnDestData.coordinates,
//                           returnTotalDistance: returnTotalDistance.toFixed(1),
//                           returnDurationHours: editForm.durationHours,
//                           returnDurationMinutes: editForm.durationMinutes,
//                           returnManualFinalLeg: "",
//                         }));

//                         setDownStops(reversedStops);
//                         setIsDistanceCalculated((prev) => ({
//                           ...prev,
//                           down: false,
//                         }));

//                         toast.info(
//                           `Return route auto-populated from main route with ${reversedStops.length} stops. Each stop has the correct distance from previous stop. Please verify and calculate distances.`,
//                         );
//                       } else {
//                         setEditForm((prev) => ({
//                           ...prev,
//                           isRoundTrip: newIsRoundTrip,
//                         }));
//                         if (!newIsRoundTrip) {
//                           setDownStops([]);
//                         }
//                       }
//                     }}
//                     className="checkbox-input"
//                   />
//                   <span className="checkbox-label">
//                     Round Trip (Main + Return Routes)
//                   </span>
//                 </label>
//               </div>

//               {editForm.isRoundTrip && (
//                 <div className="route-tabs">
//                   <button
//                     className={`route-tab ${activeRouteTab === "UP" ? "active" : ""}`}
//                     onClick={() => setActiveRouteTab("UP")}
//                   >
//                     UP (Main) Route
//                   </button>
//                   <button
//                     className={`route-tab ${activeRouteTab === "DOWN" ? "active" : ""}`}
//                     onClick={() => setActiveRouteTab("DOWN")}
//                   >
//                     DOWN (Return) Route
//                   </button>
//                 </div>
//               )}

//               <div className="form-sections">
//                 <div className="form-section">
//                   <h4>Route Identity</h4>
//                   <div className="form-row">

//                     <div className="form-group">
//                       <label>Route Name *</label>
//                       <input
//                         type="text"
//                         value={editForm.masterRouteName}
//                         onChange={(e) =>
//                           setEditForm((prev) => ({
//                             ...prev,
//                             masterRouteName: e.target.value,
//                           }))
//                         }
//                         className="form-input"
//                       />
//                     </div>
//                     <div className="form-group full-width">
//                       <label>Description</label>
//                       <textarea
//                         value={editForm.description}
//                         onChange={(e) =>
//                           setEditForm((prev) => ({
//                             ...prev,
//                             description: e.target.value,
//                           }))
//                         }
//                         className="form-input"
//                         rows="2"
//                       />
//                     </div>
//                   </div>
//                 </div>


//                 <div className="form-section">
//                   <h4>Via Cities (Optional)</h4>
//                   <div className="via-cities-container">

//                     {editForm.via && editForm.via.length > 0 && (
//                       <div className="via-list">
//                         {editForm.via.map((viaCity, index) => (
//                           <div
//                             key={index}
//                             className="via-item"
//                             style={{
//                               display: "flex",
//                               gap: "10px",
//                               alignItems: "center",
//                               marginBottom: "10px",
//                               padding: "8px",
//                               backgroundColor: "#f8f9fa",
//                               borderRadius: "6px",
//                             }}
//                           >
//                             <div
//                               style={{ fontWeight: "bold", minWidth: "30px" }}
//                             >
//                               {index + 1}.
//                             </div>
//                             <div style={{ flex: 2 }}>
//                               <input
//                                 type="text"
//                                 value={viaCity.city}
//                                 onChange={(e) =>
//                                   updateEditViaCity(
//                                     index,
//                                     "city",
//                                     e.target.value,
//                                   )
//                                 }
//                                 placeholder="City name"
//                                 className="form-input"
//                                 style={{ marginBottom: "0" }}
//                               />
//                             </div>
//                             <div style={{ flex: 2 }}>
//                               <input
//                                 type="text"
//                                 value={viaCity.state || ""}
//                                 onChange={(e) =>
//                                   updateEditViaCity(
//                                     index,
//                                     "state",
//                                     e.target.value,
//                                   )
//                                 }
//                                 placeholder="State (optional)"
//                                 className="form-input"
//                                 style={{ marginBottom: "0" }}
//                               />
//                             </div>
//                             <button
//                               type="button"
//                               onClick={() => removeEditViaCity(index)}
//                               className="btn btn-danger btn-sm"
//                               style={{
//                                 padding: "6px 12px",
//                                 backgroundColor: "#dc3545",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                               }}
//                             >
//                               ×
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     )}


//                     <div
//                       className="add-via-form"
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         marginTop:
//                           editForm.via && editForm.via.length > 0
//                             ? "10px"
//                             : "0",
//                       }}
//                     >
//                       <input
//                         type="text"
//                         value={editViaInput}
//                         onChange={(e) => setEditViaInput(e.target.value)}
//                         onKeyPress={(e) => {
//                           if (e.key === "Enter") {
//                             addEditViaCity();
//                           }
//                         }}
//                         placeholder="Enter via city name..."
//                         className="form-input"
//                         style={{ flex: 3 }}
//                       />
//                       <button
//                         type="button"
//                         onClick={addEditViaCity}
//                         className="btn btn-secondary"
//                         style={{
//                           padding: "8px 16px",
//                           backgroundColor: "#6c757d",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "4px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         + Add Via City
//                       </button>
//                     </div>
//                     <small className="helper-text">
//                       Add major cities/towns the route passes through (for route
//                       identification)
//                     </small>
//                   </div>
//                 </div>


//                 <div className="form-section">
//                   <h4>
//                     {activeRouteTab === "UP" ? "Origin" : "Return Origin"}
//                   </h4>

//                   {activeRouteTab === "UP" ? (
//                     <>
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <LocationInput
//                             value={editForm.originCity}
//                             onChange={(value) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 originCity: value,
//                               }))
//                             }
//                             onLocationSelect={handleEditOriginSelect}
//                             placeholder="Search origin city..."
//                           />
//                         </div>
//                       </div>
//                       <div className="form-row">
//                         <div className="form-group">
//                           <label>Address</label>
//                           <input
//                             type="text"
//                             value={editForm.originAddress}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 originAddress: e.target.value,
//                               }))
//                             }
//                             className="form-input"
//                           />
//                         </div>
//                       </div>
//                       <div className="form-row">
//                         <div className="form-group">
//                           <label>State</label>
//                           <input
//                             type="text"
//                             value={editForm.originState}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 originState: e.target.value,
//                               }))
//                             }
//                             className="form-input"
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Terminal</label>
//                           <input
//                             type="text"
//                             value={editForm.originTerminal}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 originTerminal: e.target.value,
//                               }))
//                             }
//                             className="form-input"
//                           />
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <input
//                             type="text"
//                             value={editForm.returnOriginCity || ""}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 returnOriginCity: e.target.value,
//                               }))
//                             }
//                             placeholder="Return Origin City"
//                             className="form-input"
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>


//                 <div className="form-section">
//                   <h4>
//                     {activeRouteTab === "UP"
//                       ? "Destination"
//                       : "Return Destination"}
//                   </h4>

//                   {activeRouteTab === "UP" ? (
//                     <>
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <LocationInput
//                             value={editForm.destCity}
//                             onChange={(value) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 destCity: value,
//                               }))
//                             }
//                             onLocationSelect={handleEditDestSelect}
//                             placeholder="Search destination city..."
//                           />
//                         </div>
//                       </div>
//                       <div className="form-row">
//                         <div className="form-group">
//                           <label>Address</label>
//                           <input
//                             type="text"
//                             value={editForm.destAddress}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 destAddress: e.target.value,
//                               }))
//                             }
//                             className="form-input"
//                           />
//                         </div>
//                       </div>
//                       <div className="form-row">
//                         <div className="form-group">
//                           <label>State</label>
//                           <input
//                             type="text"
//                             value={editForm.destState}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 destState: e.target.value,
//                               }))
//                             }
//                             className="form-input"
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Terminal</label>
//                           <input
//                             type="text"
//                             value={editForm.destTerminal}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 destTerminal: e.target.value,
//                               }))
//                             }
//                             className="form-input"
//                           />
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <input
//                             type="text"
//                             value={editForm.returnDestCity || ""}
//                             onChange={(e) =>
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 returnDestCity: e.target.value,
//                               }))
//                             }
//                             placeholder="Return Destination City"
//                             className="form-input"
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>


//                 <div className="form-section stops-section">
//                   <h4>Intermediate Stops ({activeRouteTab})</h4>

//                   {activeRouteTab === "DOWN" && editForm.isRoundTrip && (
//                     <button
//                       className="sync-btn"
//                       onClick={() => {
//                         if (
//                           window.confirm(
//                             "This will update your Return Route stops based on your Main Route. Proceed?",
//                           )
//                         ) {
//                           const upTotalDist =
//                             parseFloat(editForm.totalDistance) || 0;

//                           const originPoint = {
//                             city: editForm.originCity,
//                             distanceFromOrigin: 0,
//                             coordinates: editForm.originCoords,
//                             isManualStop: false,
//                           };

//                           const destPoint = {
//                             city: editForm.destCity,
//                             distanceFromOrigin: upTotalDist,
//                             coordinates: editForm.destCoords,
//                             isManualStop: false,
//                             distanceFromPrev:
//                               upTotalDist -
//                               (upStops.length > 0
//                                 ? upStops[upStops.length - 1]
//                                     ?.distanceFromOrigin || 0
//                                 : 0),
//                           };

//                           const stopsWithPrev = upStops.map((stop, idx) => {
//                             const prevDistance =
//                               idx === 0
//                                 ? 0
//                                 : upStops[idx - 1]?.distanceFromOrigin || 0;
//                             return {
//                               ...stop,
//                               distanceFromPrev:
//                                 (stop.distanceFromOrigin || 0) - prevDistance,
//                             };
//                           });

//                           const upPoints = [
//                             originPoint,
//                             ...stopsWithPrev,
//                             destPoint,
//                           ];
//                           const downPoints = [...upPoints].reverse();

//                           let cumulativeDist = 0;
//                           const reversedStops = [];

//                           for (let i = 1; i < downPoints.length - 1; i++) {
//                             const currentPoint = downPoints[i];
//                             const segmentDistance =
//                               currentPoint.distanceFromPrev || 0;
//                             cumulativeDist += segmentDistance;

//                             let newStopType = currentPoint.stopType;
//                             if (currentPoint.stopType === "boarding")
//                               newStopType = "dropping";
//                             else if (currentPoint.stopType === "dropping")
//                               newStopType = "boarding";

//                             reversedStops.push({
//                               sequence: i,
//                               city: currentPoint.city,
//                               state: currentPoint.state || "",
//                               address:
//                                 currentPoint.address ||
//                                 `${currentPoint.city || ""}, ${currentPoint.state || "India"}`,
//                               terminal:
//                                 currentPoint.terminal ||
//                                 `${currentPoint.city || ""} Bus Stand`,
//                               stopType: newStopType,
//                               coordinates: currentPoint.coordinates || {
//                                 lat: 0,
//                                 lng: 0,
//                               },
//                               distanceFromOrigin: parseFloat(
//                                 cumulativeDist.toFixed(1),
//                               ),
//                               manualDistFromPrev:
//                                 segmentDistance > 0
//                                   ? parseFloat(segmentDistance.toFixed(1))
//                                   : null,
//                               manualDistToNext: null,
//                               isManualStop: currentPoint.isManualStop || false,
//                             });
//                           }

//                           setDownStops(reversedStops);
//                           setIsDistanceCalculated((prev) => ({
//                             ...prev,
//                             down: false,
//                           }));
//                           toast.info(
//                             `Return route synced with ${reversedStops.length} stops with correct distances.`,
//                           );
//                         }
//                       }}
//                     >
//                       🔄 Auto-Fill / Sync Reversed Stops from UP Route
//                     </button>
//                   )}

//                   <div className="stops-list">

//                     {renderInsertButton(
//                       0,
//                       activeRouteTab === "UP" ? "up" : "down",
//                     )}


//                     {getActiveStops().map((stop, index) => (
//                       <React.Fragment key={index}>
//                         <div
//                           className="stop-list-item"
//                           style={{
//                             backgroundColor: "#fff",
//                             border: "1px solid #e0e0e0",
//                             borderRadius: "8px",
//                             padding: "12px 16px",
//                             marginBottom: "12px",
//                             transition: "all 0.2s ease",
//                           }}
//                         >
//                           <div className="stop-info">
//                             <div
//                               className="stop-name"
//                               style={{
//                                 fontSize: "16px",
//                                 fontWeight: "500",
//                                 marginBottom: "8px",
//                               }}
//                             >
//                               {index + 1}. {stop.city}
//                               <span
//                                 className="stop-distance"
//                                 style={{
//                                   fontSize: "13px",
//                                   color: "#6c757d",
//                                   marginLeft: "8px",
//                                   fontWeight: "normal",
//                                 }}
//                               >
//                                 ({formatDistance(stop.distanceFromOrigin)}km)
//                                                               </span>
//                             </div>

//                             <div
//                               className="stop-address-detail"
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#495057",
//                                 marginBottom: "8px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "4px",
//                               }}
//                             >
//                               📍{" "}
//                               {stop.address ||
//                                 `${stop.city}, ${stop.state || "India"}`}
//                             </div>


//                             <div
//                               style={{
//                                 display: "flex",
//                                 gap: "16px",
//                                 marginBottom: "8px",
//                                 fontSize: "13px",
//                               }}
//                             >
//                               {stop.state && (
//                                 <div>
//                                   <span style={{ color: "#6c757d" }}>
//                                     State:
//                                   </span>{" "}
//                                   {stop.state}
//                                 </div>
//                               )}
//                               {stop.terminal && (
//                                 <div>
//                                   <span style={{ color: "#6c757d" }}>
//                                     Terminal:
//                                   </span>{" "}
//                                   {stop.terminal}
//                                 </div>
//                               )}
//                             </div>



//                             {stop.manualDistToNext && (
//                               <div
//                                 className="stop-next-distance"
//                                 style={{
//                                   fontSize: "12px",
//                                   color: "#dc3545",
//                                   marginTop: "4px",
//                                 }}
//                               >
//                                 → Next: {stop.manualDistToNext} km
//                               </div>
//                             )}
//                           </div>
//                           <div
//                             className="stop-actions"
//                             style={{
//                               display: "flex",
//                               gap: "8px",
//                               marginTop: "10px",
//                               paddingTop: "8px",
//                               borderTop: "1px solid #f0f0f0",
//                             }}
//                           >
//                             <button
//                               className="stop-action-btn edit"
//                               onClick={() =>
//                                 handleEditStop(
//                                   index,
//                                   activeRouteTab === "UP" ? "up" : "down",
//                                 )
//                               }
//                               style={{
//                                 padding: "4px 12px",
//                                 fontSize: "12px",
//                                 backgroundColor: "#17a2b8",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                               }}
//                             >
//                               Edit
//                             </button>
//                             <button
//                               className="stop-action-btn delete"
//                               onClick={() => handleDeleteStop(index)}
//                               style={{
//                                 padding: "4px 12px",
//                                 fontSize: "12px",
//                                 backgroundColor: "#dc3545",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                               }}
//                             >
//                               Delete
//                             </button>
//                           </div>
//                         </div>


//                         {renderInsertButton(
//                           index + 1,
//                           activeRouteTab === "UP" ? "up" : "down",
//                         )}
//                       </React.Fragment>
//                     ))}
//                   </div>

//                   <div className="stop-form">
//                     <h5>
//                       {editingStopIndex !== null
//                         ? `Edit Stop #${editingStopIndex + 1}`
//                         : insertIndex !== null
//                           ? `Insert Stop at #${insertIndex + 1}`
//                           : "Add Stop at End"}
//                     </h5>

//                     {insertIndex !== null && (
//                       <button
//                         className="cancel-insert-btn"
//                         onClick={() => setInsertIndex(null)}
//                       >
//                         Cancel Insert
//                       </button>
//                     )}

//                     <div className="form-row">
//                       <Checkbox
//                         label="Manually Typed Stop (No Map Suggestions)"
//                         checked={isManualStop}
//                         onChange={() => {
//                           setIsManualStop(!isManualStop);
//                           if (!isManualStop) {
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopCity: "",
//                               stopCoords: null,
//                               stopDistFromPrev: "",
//                               stopDistToNext: "",
//                             }));
//                           }
//                         }}
//                       />
//                     </div>

//                     {!isManualStop ? (
//                       <>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <LocationInput
//                               value={newRoute.stopCity}
//                               onChange={(value) =>
//                                 setNewRoute((prev) => ({
//                                   ...prev,
//                                   stopCity: value,
//                                 }))
//                               }
//                               onLocationSelect={handleSelectStop}
//                               placeholder="Search stop city..."
//                             />
//                           </div>
//                         </div>
//                         <div className="form-row">
//                           <div className="form-group">
//                             <label>Address</label>
//                             <input
//                               type="text"
//                               value={newRoute.stopAddress}
//                               onChange={(e) =>
//                                 setNewRoute((prev) => ({
//                                   ...prev,
//                                   stopAddress: e.target.value,
//                                 }))
//                               }
//                               className="form-input"
//                             />
//                           </div>
//                         </div>
//                       </>
//                     ) : (
//                       <>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>City Name *</label>
//                             <input
//                               type="text"
//                               value={tempStopForm.city}
//                               onChange={(e) =>
//                                 setTempStopForm((prev) => ({
//                                   ...prev,
//                                   city: e.target.value,
//                                 }))
//                               }
//                               placeholder="Enter city name manually"
//                               className="form-input"
//                             />
//                           </div>
//                         </div>
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>Address</label>
//                             <input
//                               type="text"
//                               value={tempStopForm.address}
//                               onChange={(e) =>
//                                 setTempStopForm((prev) => ({
//                                   ...prev,
//                                   address: e.target.value,
//                                 }))
//                               }
//                               placeholder="Full address (e.g., NH-19, Near Bus Stand)"
//                               className="form-input"
//                             />
//                             <small className="helper-text">
//                               Complete address of the stop location
//                             </small>
//                           </div>
//                         </div>
//                       </>
//                     )}

//                     {(isManualStop ||
//                       !newRoute.stopCoords ||
//                       (newRoute.stopCoords?.lat === 0 &&
//                         newRoute.stopCoords?.lng === 0)) && (
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>Distance from Previous Stop (km) *</label>
//                           <input
//                             type="number"
//                             value={newRoute.stopDistFromPrev}
//                             onChange={(e) =>
//                               setNewRoute((prev) => ({
//                                 ...prev,
//                                 stopDistFromPrev: e.target.value,
//                               }))
//                             }
//                             placeholder="e.g., 50"
//                             className="form-input"
//                             min="0"
//                             step="0.1"
//                           />
//                         </div>
//                       </div>
//                     )}

//                     {isManualStop &&
//                       (() => {
//                         const stops = getActiveStops();
//                         const currentIndex =
//                           editingStopIndex !== null
//                             ? editingStopIndex
//                             : insertIndex !== null
//                               ? insertIndex
//                               : stops.length;
//                         const nextStop = stops[currentIndex];
//                         const isNextAuto =
//                           nextStop &&
//                           nextStop.coordinates &&
//                           (nextStop.coordinates.lat !== 0 ||
//                             nextStop.coordinates.lng !== 0);

//                         if (isNextAuto) {
//                           return (
//                             <div className="form-row">
//                               <div className="form-group full-width">
//                                 <label>
//                                   Distance to Next Stop ({nextStop.city}) (km) *
//                                 </label>
//                                 <input
//                                   type="number"
//                                   value={newRoute.stopDistToNext}
//                                   onChange={(e) =>
//                                     setNewRoute((prev) => ({
//                                       ...prev,
//                                       stopDistToNext: e.target.value,
//                                     }))
//                                   }
//                                   placeholder={`Distance from ${newRoute.stopCity || "this stop"} to ${nextStop.city}`}
//                                   className="form-input"
//                                   min="0"
//                                   step="0.1"
//                                 />
//                                 <small
//                                   className="helper-text"
//                                   style={{ color: "#dc3545" }}
//                                 >
//                                   ⚠️ Required because next stop "{nextStop.city}
//                                   " has GPS coordinates
//                                 </small>
//                               </div>
//                             </div>
//                           );
//                         }
//                         return null;
//                       })()}

//                     <div className="form-row">
//                       <div className="form-group">
//                         <label>State</label>
//                         <input
//                           type="text"
//                           value={newRoute.stopState}
//                           onChange={(e) =>
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopState: toProperCase(e.target.value),
//                             }))
//                           }
//                           className="form-input"
//                         />
//                       </div>
//                       <div className="form-group">
//                         <label>Terminal</label>
//                         <input
//                           type="text"
//                           value={newRoute.stopTerminal}
//                           onChange={(e) =>
//                             setNewRoute((prev) => ({
//                               ...prev,
//                               stopTerminal: e.target.value,
//                             }))
//                           }
//                           className="form-input"
//                         />
//                       </div>
//                     </div>

//                     <button
//                       className="btn btn-secondary add-stop-btn"
//                       onClick={() =>
//                         addIntermediateStop(
//                           activeRouteTab === "UP" ? "up" : "down",
//                         )
//                       }
//                       disabled={
//                         !newRoute.stopCity ||
//                         ((isManualStop || !newRoute.stopCoords) &&
//                           (!newRoute.stopDistFromPrev ||
//                             parseFloat(newRoute.stopDistFromPrev) <= 0))
//                       }
//                     >
//                       {editingStopIndex !== null
//                         ? "Save Changes"
//                         : insertIndex !== null
//                           ? "Confirm Insertion"
//                           : "+ Append Stop"}
//                     </button>
//                   </div>
//                 </div>


//                 <div className="form-section">
//                   <h4>{activeRouteTab} Summary</h4>

//                   <button
//                     className="btn btn-success calculate-btn"
//                     onClick={() => {
//                       setNewRoute((prev) => ({
//                         ...prev,
//                         upOriginCity: editForm.originCity || prev.upOriginCity,
//                         upOriginState:
//                           editForm.originState || prev.upOriginState,
//                         upOriginAddress:
//                           editForm.originAddress || prev.upOriginAddress,
//                         upOriginCoords:
//                           editForm.originCoords || prev.upOriginCoords,
//                         upOriginTerminal:
//                           editForm.originTerminal || prev.upOriginTerminal,

//                         upDestCity: editForm.destCity || prev.upDestCity,
//                         upDestState: editForm.destState || prev.upDestState,
//                         upDestAddress:
//                           editForm.destAddress || prev.upDestAddress,
//                         upDestCoords: editForm.destCoords || prev.upDestCoords,
//                         upDestTerminal:
//                           editForm.destTerminal || prev.upDestTerminal,

//                         upTotalDistance: editForm.totalDistance || prev.upTotalDistance,
//                         downTotalDistance:
//                           editForm.returnTotalDistance ||
//                           prev.downTotalDistance,
//                         upManualFinalLeg:
//                           editForm.upManualFinalLeg || prev.upManualFinalLeg,
//                         downManualFinalLeg:
//                           editForm.returnManualFinalLeg ||
//                           prev.downManualFinalLeg,

//                         upDurationHours: editForm.durationHours || prev.upDurationHours,
//                         upDurationMinutes:
//                           editForm.durationMinutes || prev.upDurationMinutes,
//                         downDurationHours:
//                           editForm.returnDurationHours ||
//                           prev.downDurationHours,
//                         downDurationMinutes:
//                           editForm.returnDurationMinutes ||
//                           prev.downDurationMinutes,
//                       }));

//                       setTimeout(() => handleCalculateDistances(), 100);
//                     }}
//                     disabled={isCalculatingDistances}
//                   >
//                     {isCalculatingDistances
//                       ? "Calculating..."
//                       : `Auto-Calculate Distances (${activeRouteTab})`}
//                   </button>


//                   {isLastStopManual() && (
//                     <div className="form-row" style={{ marginTop: "10px" }}>
//                       <div className="form-group full-width">
//                         <label>
//                           Distance from Last Stop to Destination (KM) *
//                         </label>
//                         <input
//                           type="number"
//                           value={
//                             activeRouteTab === "UP"
//                               ? editForm.upManualFinalLeg
//                               : editForm.returnManualFinalLeg
//                           }
//                           onChange={(e) => {
//                             if (activeRouteTab === "UP") {
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 upManualFinalLeg: e.target.value,
//                               }));
//                             } else {
//                               setEditForm((prev) => ({
//                                 ...prev,
//                                 returnManualFinalLeg: e.target.value,
//                               }));
//                             }
//                           }}
//                           placeholder="Required because last stop is manual"
//                           className="form-input"
//                           min="0"
//                           step="0.1"
//                           style={{
//                             borderColor: "#dc3545",
//                             backgroundColor: "#fff5f5",
//                           }}
//                         />
//                         <small
//                           className="helper-text"
//                           style={{ color: "#dc3545" }}
//                         >
//                           ⚠️ The last stop is manual, so you must provide the
//                           distance to destination
//                         </small>
//                       </div>
//                     </div>
//                   )}

//                   <div className="form-row summary-fields">
//                     <div className="form-group">
//                       <label>Total Distance (KM)</label>
//                       <input
//                         type="number"
//                         value={
//                           activeRouteTab === "UP"
//                             ? editForm.totalDistance
//                             : editForm.returnTotalDistance
//                         }
//                         onChange={(e) => {
//                           if (activeRouteTab === "UP") {
//                             setEditForm((prev) => ({
//                               ...prev,
//                               totalDistance: e.target.value,
//                             }));
//                           } else {
//                             setEditForm((prev) => ({
//                               ...prev,
//                               returnTotalDistance: e.target.value,
//                             }));
//                           }
//                         }}
//                         className="form-input"
//                         min="0"
//                         step="0.1"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="form-section">
//                   <h4>Status</h4>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label className="checkbox-container">
//                         <input
//                           type="checkbox"
//                           checked={editForm.isActive}
//                           onChange={(e) =>
//                             setEditForm((prev) => ({
//                               ...prev,
//                               isActive: e.target.checked,
//                             }))
//                           }
//                         />
//                         <span>Route is Active</span>
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="form-actions">
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setShowEditModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn btn-primary save-route-btn"
//                   onClick={handleUpdateRoute}
//                   disabled={isUpdatingRoute}
//                 >
//                   {isUpdatingRoute ? "Updating..." : "Update Route Master"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}


//       {showStopEditModal && stopBeingEdited && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowStopEditModal(false)}
//         >
//           <div
//             className="modal-content edit-stop-modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3>
//                 Edit Stop #{stopBeingEdited.index + 1}
//                 <span className="stop-location-name">
//                   {" "}
//                   - {stopBeingEdited.originalStop.city}
//                 </span>
//               </h3>
//               <button
//                 className="modal-close-btn"
//                 onClick={() => setShowStopEditModal(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="edit-stop-form">

//                 <div className="form-row">
//                   <Checkbox
//                     label="Manually Typed Stop (No Map Suggestions)"
//                     checked={stopEditForm.isManualStop}
//                     onChange={() => {
//                       setStopEditForm((prev) => ({
//                         ...prev,
//                         isManualStop: !prev.isManualStop,
//                         manualDistFromPrev: !prev.isManualStop
//                           ? prev.manualDistFromPrev
//                           : "",
//                       }));
//                     }}
//                   />
//                 </div>


//                 <div className="form-row">
//                   <div className="form-group full-width">
//                     <label>City Name *</label>
//                     <input
//                       type="text"
//                       value={stopEditForm.city}
//                       onChange={(e) =>
//                         setStopEditForm((prev) => ({
//                           ...prev,
//                           city: e.target.value,
//                         }))
//                       }
//                       placeholder="Enter city name"
//                       className="form-input"
//                     />
//                   </div>
//                 </div>


//                 <div className="form-row">
//                   <div className="form-group full-width">
//                     <label>Address *</label>
//                     <input
//                       type="text"
//                       value={stopEditForm.address}
//                       onChange={(e) =>
//                         setStopEditForm((prev) => ({
//                           ...prev,
//                           address: e.target.value,
//                         }))
//                       }
//                       placeholder="Full address (e.g., NH-19, Near Bus Stand)"
//                       className="form-input"
//                     />
//                     <small className="helper-text">
//                       Complete address of the stop location
//                     </small>
//                   </div>
//                 </div>


//                 {(stopEditForm.isManualStop ||
//                   (!stopBeingEdited.originalStop.coordinates?.lat &&
//                     !stopBeingEdited.originalStop.coordinates?.lng)) && (
//                   <div className="form-row">
//                     <div className="form-group full-width">
//                       <label>Distance from Previous Stop (km) *</label>
//                       <input
//                         type="number"
//                         value={stopEditForm.manualDistFromPrev}
//                         onChange={(e) =>
//                           setStopEditForm((prev) => ({
//                             ...prev,
//                             manualDistFromPrev: e.target.value,
//                           }))
//                         }
//                         placeholder="e.g., 50"
//                         className="form-input"
//                         min="0"
//                         step="0.1"
//                       />
//                       <small className="helper-text">
//                         Required for manual stops
//                       </small>
//                     </div>
//                   </div>
//                 )}


//                 {stopEditForm.isManualStop &&
//                   (() => {
//                     const stops = activeRouteTab === "UP" ? upStops : downStops;
//                     const currentIndex = stopBeingEdited.index;
//                     const nextStop = stops[currentIndex + 1];
//                     const isNextAuto =
//                       nextStop &&
//                       nextStop.coordinates &&
//                       (nextStop.coordinates.lat !== 0 ||
//                         nextStop.coordinates.lng !== 0);

//                     if (isNextAuto) {
//                       return (
//                         <div className="form-row">
//                           <div className="form-group full-width">
//                             <label>
//                               Distance to Next Stop ({nextStop.city}) (km) *
//                             </label>
//                             <input
//                               type="number"
//                               value={stopEditForm.manualDistToNext}
//                               onChange={(e) =>
//                                 setStopEditForm((prev) => ({
//                                   ...prev,
//                                   manualDistToNext: e.target.value,
//                                 }))
//                               }
//                               placeholder={`Distance to ${nextStop.city}`}
//                               className="form-input"
//                               min="0"
//                               step="0.1"
//                             />
//                             <small
//                               className="helper-text"
//                               style={{ color: "#dc3545" }}
//                             >
//                               ⚠️ Required because next stop "{nextStop.city}"
//                               has GPS coordinates
//                             </small>
//                           </div>
//                         </div>
//                       );
//                     }
//                     return null;
//                   })()}


//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>State</label>
//                     <input
//                       type="text"
//                       value={stopEditForm.state}
//                       onChange={(e) =>
//                         setStopEditForm((prev) => ({
//                           ...prev,
//                           state: toProperCase(e.target.value),
//                         }))
//                       }
//                       placeholder="State"
//                       className="form-input"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Terminal</label>
//                     <input
//                       type="text"
//                       value={stopEditForm.terminal}
//                       onChange={(e) =>
//                         setStopEditForm((prev) => ({
//                           ...prev,
//                           terminal: e.target.value,
//                         }))
//                       }
//                       placeholder="Terminal name"
//                       className="form-input"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="modal-close-btn secondary"
//                 onClick={() => setShowStopEditModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn btn-primary"
//                 onClick={saveEditedStop}
//                 disabled={!stopEditForm.city || !stopEditForm.address}
//               >
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showStopModal && (
//         <div className="modal-overlay" onClick={() => setShowStopModal(false)}>
//           <div
//             className="modal-content stop-modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3>
//                 {stopModalMode === "add" && "Add New Stop"}
//                 {stopModalMode === "insert" &&
//                   `Insert Stop at Position ${tempInsertIndex + 1}`}
//                 {stopModalMode === "edit" &&
//                   `Edit Stop #${tempEditStopIndex?.index + 1}`}
//               </h3>
//               <button
//                 className="modal-close-btn"
//                 onClick={() => setShowStopModal(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="stop-form-modal">

//                 <div className="form-row">
//                   <Checkbox
//                     label="Manually Typed Stop (No Map Suggestions)"
//                     checked={tempStopForm.isManual}
//                     onChange={() => {
//                       setTempStopForm((prev) => ({
//                         ...prev,
//                         isManual: !prev.isManual,
//                         distFromPrev: !prev.isManual ? prev.distFromPrev : "",
//                       }));
//                     }}
//                   />
//                 </div>

//                 {!tempStopForm.isManual ? (
//                   <>
//                     <div className="form-row">
//                       <div className="form-group full-width">
//                         <label>Search Location *</label>
//                         <LocationInput
//                           value={tempStopForm.city}
//                           onChange={(value) =>
//                             setTempStopForm((prev) => ({
//                               ...prev,
//                               city: value,
//                             }))
//                           }
//                           onLocationSelect={(location) => {
//                             setTempStopForm((prev) => ({
//                               ...prev,
//                               city: location.city || location.name || "",
//                               state: location.state || prev.state,
//                               address: location.address || "",
//                             }));
//                           }}
//                           placeholder="Search stop city or address..."
//                         />
//                       </div>
//                     </div>
//                     <div className="form-row">
//                       <div className="form-group full-width">
//                         <label>Address</label>
//                         <input
//                           type="text"
//                           value={tempStopForm.address}
//                           onChange={(e) =>
//                             setTempStopForm((prev) => ({
//                               ...prev,
//                               address: e.target.value,
//                             }))
//                           }
//                           placeholder="Full address"
//                           className="form-input"
//                         />
//                       </div>
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="form-row">
//                       <div className="form-group full-width">
//                         <label>City Name *</label>
//                         <div style={{ position: "relative" }}>
//                           <input
//                             type="text"
//                             value={tempStopForm.city}
//                             onChange={async (e) => {
//                               const value = e.target.value;
//                               setTempStopForm((prev) => ({
//                                 ...prev,
//                                 city: value,
//                                 address: "",
//                                 state: "",
//                                 terminal: "",
//                               }));

//                               if (value.length >= 2) {
//                                 try {
//                                   const searchFn =
//                                     activeRouteTab === "UP"
//                                       ? searchRouteIntermediateStops
//                                       : searchRouteIntermediateStops;
//                                   const response = await searchFn(token, value);
//                                   if (
//                                     response.success &&
//                                     response.cities?.length > 0
//                                   ) {
//                                     setModalCitySuggestions(response.cities);
//                                     setShowModalCityDropdown(true);
//                                   } else {
//                                     setModalCitySuggestions([]);
//                                     setShowModalCityDropdown(false);
//                                   }
//                                 } catch (error) {
//                                   setModalCitySuggestions([]);
//                                   setShowModalCityDropdown(false);
//                                 }
//                               } else {
//                                 setModalCitySuggestions([]);
//                                 setShowModalCityDropdown(false);
//                               }
//                             }}
//                             onFocus={() => {
//                               if (modalCitySuggestions.length > 0)
//                                 setShowModalCityDropdown(true);
//                             }}
//                             onBlur={() =>
//                               setTimeout(
//                                 () => setShowModalCityDropdown(false),
//                                 200,
//                               )
//                             }
//                             placeholder="Type city name (min 2 characters)..."
//                             className="form-input"
//                           />
//                           {showModalCityDropdown &&
//                             modalCitySuggestions.length > 0 && (
//                               <div
//                                 style={{
//                                   position: "absolute",
//                                   top: "100%",
//                                   left: 0,
//                                   right: 0,
//                                   backgroundColor: "white",
//                                   border: "1px solid #ddd",
//                                   borderRadius: "4px",
//                                   maxHeight: "200px",
//                                   overflowY: "auto",
//                                   zIndex: 10000,
//                                   boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                                 }}
//                               >
//                                 {modalCitySuggestions.map((city, idx) => (
//                                   <div
//                                     key={city.id || idx}
//                                     onMouseDown={() => {
//                                       setTempStopForm((prev) => ({
//                                         ...prev,
//                                         city: city.name,
//                                         address: city.address || city.name,
//                                         state: city.state || "",
//                                         terminal:
//                                           city.terminal ||
//                                           `${city.name} Bus Stand`,
//                                       }));
//                                       setShowModalCityDropdown(false);
//                                       setModalCitySuggestions([]);
//                                       toast.success(
//                                         `Auto-filled details for ${city.name}`,
//                                       );
//                                     }}
//                                     style={{
//                                       padding: "10px 12px",
//                                       cursor: "pointer",
//                                       borderBottom: "1px solid #f0f0f0",
//                                     }}
//                                     onMouseEnter={(e) =>
//                                       (e.currentTarget.style.backgroundColor =
//                                         "#f0f7ff")
//                                     }
//                                     onMouseLeave={(e) =>
//                                       (e.currentTarget.style.backgroundColor =
//                                         "white")
//                                     }
//                                   >
//                                     <div style={{ fontWeight: "500" }}>
//                                       {city.name}
//                                     </div>
//                                     <div
//                                       style={{
//                                         fontSize: "12px",
//                                         color: "#6c757d",
//                                       }}
//                                     >
//                                       {city.state}
//                                       {city.terminal
//                                         ? ` • ${city.terminal}`
//                                         : ""}
//                                     </div>
//                                     {city.address &&
//                                       city.address !== city.name && (
//                                         <div
//                                           style={{
//                                             fontSize: "11px",
//                                             color: "#999",
//                                             marginTop: "2px",
//                                           }}
//                                         >
//                                           {city.address}
//                                         </div>
//                                       )}
//                                   </div>
//                                 ))}
//                               </div>
//                             )}
//                         </div>
//                         <small className="helper-text">
//                           Type at least 2 characters to search cities from
//                           existing routes
//                         </small>
//                       </div>
//                     </div>
//                     <div className="form-row">
//                       <div className="form-group full-width">
//                         <label>Address</label>
//                         <input
//                           type="text"
//                           value={tempStopForm.address}
//                           onChange={(e) =>
//                             setTempStopForm((prev) => ({
//                               ...prev,
//                               address: e.target.value,
//                             }))
//                           }
//                           placeholder="Full address (e.g., NH-19, Near Bus Stand)"
//                           className="form-input"
//                         />
//                         <small className="helper-text">
//                           Complete address of the stop location
//                         </small>
//                       </div>
//                     </div>
//                   </>
//                 )}


//                 {(tempStopForm.isManual || stopModalMode === "edit") && (
//                   <div className="form-row">
//                     <div className="form-group full-width">
//                       <label>Distance from Previous Stop (km) *</label>
//                       <input
//                         type="number"
//                         value={tempStopForm.distFromPrev}
//                         onChange={(e) =>
//                           setTempStopForm((prev) => ({
//                             ...prev,
//                             distFromPrev: e.target.value,
//                           }))
//                         }
//                         placeholder="e.g., 50"
//                         className="form-input"
//                         min="0"
//                         step="0.1"
//                       />
//                       <small className="helper-text">
//                         {tempStopForm.isManual
//                           ? "Required for manual stops"
//                           : "Optional - helps with distance calculation"}
//                       </small>
//                     </div>
//                   </div>
//                 )}


//                 {(() => {
//                   const nextStop = getNextStopInfo();
//                   if (
//                     nextStop &&
//                     (tempStopForm.isManual || tempStopForm.distToNext)
//                   ) {
//                     return (
//                       <div className="form-row">
//                         <div className="form-group full-width">
//                           <label>
//                             Distance to Next Stop ({nextStop.city}) (km)
//                           </label>
//                           <input
//                             type="number"
//                             value={tempStopForm.distToNext}
//                             onChange={(e) =>
//                               setTempStopForm((prev) => ({
//                                 ...prev,
//                                 distToNext: e.target.value,
//                               }))
//                             }
//                             placeholder={`Distance to ${nextStop.city}`}
//                             className="form-input"
//                             min="0"
//                             step="0.1"
//                           />
//                           {nextStop && (
//                             <small
//                               className="helper-text"
//                               style={{ color: "#dc3545" }}
//                             >
//                               ⚠️ Next stop "{nextStop.city}" has GPS
//                               coordinates. Providing distance helps with
//                               accuracy.
//                             </small>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   }
//                   return null;
//                 })()}


//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>State</label>
//                     <input
//                       type="text"
//                       value={tempStopForm.state}
//                       onChange={(e) =>
//                         setTempStopForm((prev) => ({
//                           ...prev,
//                           state: toProperCase(e.target.value),
//                         }))
//                       }
//                       placeholder="State"
//                       className="form-input"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Terminal</label>
//                     <input
//                       type="text"
//                       value={tempStopForm.terminal}
//                       onChange={(e) =>
//                         setTempStopForm((prev) => ({
//                           ...prev,
//                           terminal: e.target.value,
//                         }))
//                       }
//                       placeholder="Terminal name"
//                       className="form-input"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="modal-close-btn secondary"
//                 onClick={() => setShowStopModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn btn-primary"
//                 onClick={saveStopFromModal}
//                 disabled={!tempStopForm.city}
//               >
//                 {stopModalMode === "edit" ? "Save Changes" : "Add Stop"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MasterRouteManage;


import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import "../../Styles/ManagementPages.css";
import {
  getAllMasterRoutes,
  getMasterRouteById,
  createMasterRoute,
  updateMasterRoute,
  deleteMasterRoute,
  toggleMasterRouteStatus,
  searchMasterRoutesByCities,
  searchMasterRouteIntermediateStops,
  searchRouteIntermediateStops,
} from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import "../../Styles/RouteManage.css";
import {
  getPlacePredictions,
  getPlaceDetails,
  getDistanceMatrix,
} from "../../utilis/mapUtils";
import CityAutocomplete from "./CityAutocomplete";
import CitySearchInput from "./CitySearchInput";

/* ============================================================
 * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
 * ============================================================ */
const ICON_PATHS = {
    route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
    check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
    calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
    stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
    search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
    eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
    list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
    tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
    plus: 'M12 5v14 M5 12h14',
    map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
    bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
    edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
    refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
    x: 'M18 6 6 18 M6 6l12 12'
};

const Icon = ({ name, size = 18 }) => (
    <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICON_PATHS[name]} />
    </svg>
);

const BusSvg = ({ size = 34 }) => (
    <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
        <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
        <rect x="2" y="19" width="58" height="4" fill="#d97706" />
        <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
        <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
        <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
        <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
    </svg>
);

const useCountUp = (target, duration = 900) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let raf, start;
        const step = (t) => {
            if (!start) start = t;
            const p = Math.min((t - start) / duration, 1);
            setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, duration]);
    return value;
};

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
    const shown = useCountUp(value);
    return (
        <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
            <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
            <div className="prm-stat-body">
                <div className="prm-stat-label">{label}</div>
                <div className="prm-stat-value">{shown}</div>
                <div className="prm-stat-hint">{hint}</div>
            </div>
        </div>
    );
};

const Switch = ({ checked, onChange, title }) => (
    <label className="prm-switch" title={title}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span />
    </label>
);

const FormSection = ({ n, title, hint, children, delay = 0 }) => (
    <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
        <header className="prm-fsec-head">
            <span className="prm-fsec-num">{n}</span>
            <div>
                <h4>{title}</h4>
                {hint && <p>{hint}</p>}
            </div>
        </header>
        <div className="prm-fsec-body">{children}</div>
    </section>
);

const Field = ({ label, required, children, full, note }) => (
    <div className={`prm-field ${full ? 'full' : ''}`}>
        {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
        {children}
        {note && <small className="prm-note">{note}</small>}
    </div>
);

const PrmCheckbox = ({ label, checked, onChange }) => (
    <label className={`prm-check ${checked ? 'on' : ''}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="box"><Icon name="check" size={12} /></span>
        <span className="txt">{label}</span>
    </label>
);

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td>
      <div className="skeleton-cell"></div>
    </td>
    <td>
      <div className="skeleton-cell"></div>
    </td>
    <td>
      <div className="skeleton-cell"></div>
    </td>
    <td>
      <div className="skeleton-cell"></div>
    </td>
    <td>
      <div className="skeleton-cell"></div>
    </td>
    <td>
      <div className="skeleton-cell"></div>
    </td>
    <td>
      <div className="skeleton-badge"></div>
    </td>
    <td>
      <div className="skeleton-badge"></div>
    </td>
    <td>
      <div className="skeleton-actions"></div>
    </td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Route Name</th>
          <th>Origin</th>
          <th>Destination</th>
          <th>Distance</th>
          <th>Stops</th>
          <th>Type</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const LocationInput = ({
  value,
  onChange,
  placeholder,
  onLocationSelect,
  isManual,
}) => {
  const [searchQuery, setSearchQuery] = useState(value || "");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setSearchQuery(value || "");
  }, [value]);

  useEffect(() => {
    if (isManual) {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [isManual]);

  

  const searchLocations = async (query) => {
    if (isManual)
      return;
    if (!query || query.trim().length < 2) {
      setSuggestions([]);
      return;
    }
    setIsLoading(true);
    try {
      const predictions = await getPlacePredictions(query);
      setSuggestions(predictions);
      setShowSuggestions(predictions.length > 0);
    } catch (error) {
      console.error("Search error:", error);
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelect = async (prediction) => {
    if (isManual)
      return;
    setIsLoading(true);
    try {
      const placeDetails = await getPlaceDetails(prediction.place_id);
      if (placeDetails) {
        setSearchQuery(placeDetails.name || placeDetails.address);
        setShowSuggestions(false);
        if (onLocationSelect) {
          onLocationSelect({
            name: placeDetails.name,
            address: placeDetails.address,
            city:
              placeDetails.city ||
              prediction.structured_formatting?.secondary_text?.split(",")[0] ||
              "",
            state:
              placeDetails.state ||
              prediction.structured_formatting?.secondary_text
                ?.split(",")[1]
                ?.trim() ||
              "",
            coordinates: placeDetails.coordinates || { lat: 0, lng: 0 },
            placeId: prediction.place_id,
          });
        }
      }
    } catch (error) {
      console.error("Error getting place details:", error);
      toast.error("Failed to get location details");
    } finally {
      setIsLoading(false);
    }
  };

  const handleTextChange = (e) => {
    const newValue = e.target.value;
    setSearchQuery(newValue);
    onChange(newValue);

    if (isManual)
      return;

    if (timeoutRef.current)
      clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      searchLocations(newValue);
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className="location-input-container">
      <div className="location-input-wrapper">
        <input
          type="text"
          value={searchQuery}
          onChange={handleTextChange}
          onFocus={() => {
            if (!isManual && suggestions.length > 0) {
              setShowSuggestions(true);
            }
          }}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          className="edit-input"
          placeholder={placeholder}
        />
        {isLoading && !isManual && (
          <div className="location-loading">
            <div className="spinner"></div>
          </div>
        )}
      </div>

      {!isManual && showSuggestions && suggestions.length > 0 && (
        <div className="location-suggestions">
          <div className="suggestions-header">
            <span>Search Results</span>
          </div>
          {suggestions.map((prediction, index) => (
            <div
              key={prediction.place_id || index}
              className="suggestion-item"
              onClick={() => handleSelect(prediction)}
            >
              <div className="suggestion-main">
                {prediction.structured_formatting?.main_text ||
                  prediction.description}
              </div>
              <div className="suggestion-secondary">
                {prediction.structured_formatting?.secondary_text}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

  const CitySearchDropdown = ({
  value,
  onChange,
  onSelect,
  token,
  activeRouteTab,
  placeholder = "Type city name (min 2 characters)...",
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const timeoutRef = useRef(null);

  const search = async (q) => {
    if (q.length < 2) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }
    setIsLoading(true);
    try {
      const res = await searchRouteIntermediateStops(token, q);
      if (res.success && res.cities) {
        setSuggestions(res.cities);
        setShowDropdown(res.cities.length > 0);
      } else {
        setSuggestions([]);
        setShowDropdown(false);
      }
    } catch (e) {
      console.error("City search error:", e);
      setSuggestions([]);
      setShowDropdown(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    onChange(val);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => search(val), 500);
  };

  const handleSelect = (city) => {
    onSelect(city);
    setSuggestions([]);
    setShowDropdown(false);
  };

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        onFocus={() => suggestions.length > 0 && setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        placeholder={placeholder}
        className="prm-input"
      />
      {isLoading && (
        <div style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)" }}>
          <div className="spinner-small"></div>
        </div>
      )}
      {showDropdown && suggestions.length > 0 && (
        <div
          style={{
            position: "absolute", top: "100%", left: 0, right: 0,
            backgroundColor: "white", border: "1px solid #ddd", borderRadius: "4px",
            maxHeight: "200px", overflowY: "auto", zIndex: 2000,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          {suggestions.map((city, idx) => (
            <div
              key={city.id || idx}
              onMouseDown={() => handleSelect(city)}
              style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid #f0f0f0" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f7ff")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
            >
              <div style={{ fontWeight: "500" }}>{city.name}</div>
              <div style={{ fontSize: "12px", color: "#6c757d" }}>
                {city.state}
                {city.terminal ? ` • ${city.terminal}` : ""}
              </div>
              {city.address && city.address !== city.name && (
                <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>
                  {city.address}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Checkbox = ({ label, checked, onChange }) => (
  <label className="checkbox-container">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="checkbox-input"
    />
    <span className="checkbox-label">{label}</span>
  </label>
);

const MasterRouteSelector = ({
  value,
  onChange,
  onRouteNameChange,
  token,
  disabled,
}) => {
  const [masterRoutes, setMasterRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [source, setSource] = useState("");
  const [destination, setDestination] = useState("");
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [routeNameValue, setRouteNameValue] = useState("");
  const [selectedRouteValue, setSelectedRouteValue] = useState(null);
  const [selectedRouteDetails, setSelectedRouteDetails] = useState(null);

  const [sourceSuggestions, setSourceSuggestions] = useState([]);
  const [destSuggestions, setDestSuggestions] = useState([]);
  const [isLoadingSource, setIsLoadingSource] = useState(false);
  const [isLoadingDest, setIsLoadingDest] = useState(false);

  const sourceTimeoutRef = useRef(null);
  const destTimeoutRef = useRef(null);

  useEffect(() => {
    if (value && value.masterRouteName) {
      setRouteNameValue(value.masterRouteName);
      setSelectedRouteValue(value);
      if (value.origin?.city) setSource(value.origin.city);
      if (value.destination?.city) setDestination(value.destination.city);
    } else {
      setRouteNameValue("");
      setSelectedRouteValue(null);
      setSource("");
      setDestination("");
      setMasterRoutes([]);
      setShowDropdown(false);
      setIsManualEntry(false);
    }
  }, [value]);

  const fetchMasterRoutesByCities = async (
    sourceCity,
    destCity,
    isSourceSearch = true,
  ) => {
    if (!sourceCity && !destCity) {
      setMasterRoutes([]);
      setShowDropdown(false);
      setSourceSuggestions([]);
      setDestSuggestions([]);
      return;
    }

    if (isSourceSearch) {
      setIsLoadingSource(true);
    } else {
      setIsLoadingDest(true);
    }

    try {
      console.log("Fetching routes with:", { sourceCity, destCity });
      const response = await searchMasterRoutesByCities(
        token,
        sourceCity,
        destCity,
      );
      console.log("API Response:", response);

      if (response.success && response.data) {
        const routesData =
          response.data.routes ||
          (Array.isArray(response.data) ? response.data : []);

        if (routesData.length > 0) {
          const mappedRoutes = routesData.map((route) => ({
            _id: route._id,
            masterRouteName: route.masterRouteName,
            description: route.description || "",
            originCity: route.origin?.city || "",
            originState: route.origin?.state || "",
            originAddress: route.origin?.address || "",
            originTerminal: route.origin?.terminal || "",
            originCoords: route.origin?.coordinates || null,
            destinationCity: route.destination?.city || "",
            destinationState: route.destination?.state || "",
            destinationAddress: route.destination?.address || "",
            destinationTerminal: route.destination?.terminal || "",
            destinationCoords: route.destination?.coordinates || null,
            totalDistance: route.routeDetails?.totalDistance || 0,
            durationHours: route.routeDetails?.estimatedDuration?.hours || 0,
            durationMinutes:
              route.routeDetails?.estimatedDuration?.minutes || 0,
            intermediateStops: route.intermediateStops || [],
            isRoundTrip: route.isRoundTrip || false,
            returnJourney: route.returnJourney || null,
          }));

          console.log("Mapped routes:", mappedRoutes);
          setMasterRoutes(mappedRoutes);
          setShowDropdown(true);
        } else {
          setMasterRoutes([]);
          setShowDropdown(true);
        }

        if (response.data.sourceSuggestions) {
          setSourceSuggestions(response.data.sourceSuggestions);
        }
        if (response.data.destinationSuggestions) {
          setDestSuggestions(response.data.destinationSuggestions);
        }
      } else {
        setMasterRoutes([]);
        setShowDropdown(true);
      }
    } catch (error) {
      console.error("Error fetching routes:", error);
      setMasterRoutes([]);
      setShowDropdown(true);
    } finally {
      setIsLoadingSource(false);
      setIsLoadingDest(false);
    }
  };
  const handleSourceSelect = (selectedCity) => {
    if (!selectedCity) return;

    const cityName =
      typeof selectedCity === "object" ? selectedCity.city : selectedCity;
    setSource(cityName);
    setShowDropdown(false);

    if (selectedRouteValue) {
      setSelectedRouteValue(null);
      onChange(null);
    }

    if (sourceTimeoutRef.current)
      clearTimeout(sourceTimeoutRef.current);
    sourceTimeoutRef.current = setTimeout(() => {
      fetchMasterRoutesByCities(cityName, destination);
    }, 500);
  };

  const handleDestinationSelect = (selectedCity) => {
    if (!selectedCity) return;

    const cityName =
      typeof selectedCity === "object" ? selectedCity.city : selectedCity;
    setDestination(cityName);
    setShowDropdown(false);

    if (selectedRouteValue) {
      setSelectedRouteValue(null);
      onChange(null);
    }

    if (destTimeoutRef.current)
      clearTimeout(destTimeoutRef.current);
    destTimeoutRef.current = setTimeout(() => {
      fetchMasterRoutesByCities(source, cityName);
    }, 500);
  };

  const handleSourceInputChange = (value) => {
    setSource(value);
    setShowDropdown(false);

    if (selectedRouteValue) {
      setSelectedRouteValue(null);
      onChange(null);
    }

    if (sourceTimeoutRef.current)
      clearTimeout(sourceTimeoutRef.current);
    sourceTimeoutRef.current = setTimeout(() => {
      if (value.length >= 2 || destination.length >= 2) {
        fetchMasterRoutesByCities(value, destination, true);
      } else {
        setMasterRoutes([]);
        setSourceSuggestions([]);
      }
    }, 500);
  };

  const handleDestinationInputChange = (value) => {
    setDestination(value);
    setShowDropdown(false);

    if (selectedRouteValue) {
      setSelectedRouteValue(null);
      onChange(null);
    }

    if (destTimeoutRef.current)
      clearTimeout(destTimeoutRef.current);
    destTimeoutRef.current = setTimeout(() => {
      if (source.length >= 2 || value.length >= 2) {
        fetchMasterRoutesByCities(source, value, false);
      } else {
        setMasterRoutes([]);
        setDestSuggestions([]);
      }
    }, 500);
  };
  const handleRouteSelect = async (route) => {
    console.log("Route selected:", route);
    setSelectedRouteDetails(route);
    setShowDropdown(false);

    try {
      setIsLoading(true);

      const response = await getMasterRouteById(route._id, token);
      console.log("Complete route details:", response);

      if (response.success && response.data) {
        const fullRoute = response.data;

        setSource(fullRoute.origin?.city || "");
        setDestination(fullRoute.destination?.city || "");
        setRouteNameValue(fullRoute.masterRouteName);

        const selectedRouteObj = {
          _id: fullRoute._id,
          masterRouteName: fullRoute.masterRouteName,
          description: fullRoute.description || "",
          isManual: false,
          origin: {
            city: fullRoute.origin?.city || "",
            state: fullRoute.origin?.state || "",
            address: fullRoute.origin?.address || "",
            terminal: fullRoute.origin?.terminal || "",
            coordinates: fullRoute.origin?.coordinates || null,
          },
          destination: {
            city: fullRoute.destination?.city || "",
            state: fullRoute.destination?.state || "",
            address: fullRoute.destination?.address || "",
            terminal: fullRoute.destination?.terminal || "",
            coordinates: fullRoute.destination?.coordinates || null,
          },
          intermediateStops: fullRoute.intermediateStops || [],
          routeDetails: {
            totalDistance: fullRoute.routeDetails?.totalDistance || 0,
            estimatedDuration: {
              hours: fullRoute.routeDetails?.estimatedDuration?.hours || 0,
              minutes: fullRoute.routeDetails?.estimatedDuration?.minutes || 0,
            },
          },
          isRoundTrip: fullRoute.isRoundTrip || false,
          returnJourney: fullRoute.returnJourney || null,
        };

        console.log(
          "Calling onChange with full route object:",
          selectedRouteObj,
        );
        onChange(selectedRouteObj);
        if (onRouteNameChange) onRouteNameChange(fullRoute.masterRouteName);
      } else {
        toast.error("Failed to load complete route details");
      }
    } catch (error) {
      console.error("Error fetching full route details:", error);
      toast.error("Failed to load route details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRouteNameChange = (e) => {
    const newName = e.target.value;
    setRouteNameValue(newName);
    if (onRouteNameChange) onRouteNameChange(newName);
    if (selectedRouteValue)
      onChange({ ...selectedRouteValue, masterRouteName: newName });
  };

  const handleClearSelection = () => {
    setSelectedRouteValue(null);
    setSelectedRouteDetails(null);
    setRouteNameValue("");
    setSource("");
    setDestination("");
    setMasterRoutes([]);
    setShowDropdown(false);
    setIsManualEntry(false);
    onChange(null);
    if (onRouteNameChange) onRouteNameChange("");
  };

  const handleOpenManualEntry = () => {
    setIsManualEntry(true);
    setShowDropdown(false);
  };

  const handleManualEntrySubmit = () => {
    if (!routeNameValue.trim()) {
      toast.error("Please enter a route name");
      return;
    }

    const emptyRoute = {
      _id: null,
      masterRouteName: routeNameValue.trim(),
      isManual: true,
      origin: { city: source || "", state: "" },
      destination: { city: destination || "", state: "" },
      routeDetails: { totalDistance: 0 },
      isRoundTrip: false,
    };

    setIsManualEntry(false);
    setSelectedRouteValue(emptyRoute);
    onChange(emptyRoute);
  };

  const handleCancelManualEntry = () => {
    setIsManualEntry(false);
    setRouteNameValue("");
  };

  const showSearchFields = !selectedRouteValue && !isManualEntry;

  useEffect(() => {
    return () => {
      if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
      if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
    };
  }, []);

  return (
    <div
      className="master-route-selector"
      style={{ position: "relative", width: "100%" }}
    >
      {showSearchFields && (
        <>
          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Source City</label>
              <CityAutocomplete
                type="source"
                value={source}
                onChange={handleSourceInputChange}
                onSelect={handleSourceSelect}
                placeholder="Enter source city..."
                suggestions={sourceSuggestions}
                isLoading={isLoadingSource}
                disabled={disabled}
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Destination City</label>
              <CityAutocomplete
                type="destination"
                value={destination}
                onChange={handleDestinationInputChange}
                onSelect={handleDestinationSelect}
                placeholder="Enter destination city..."
                suggestions={destSuggestions}
                isLoading={isLoadingDest}
                disabled={disabled}
              />
            </div>
          </div>


          {(showDropdown || isLoading) && (
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "4px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                backgroundColor: "white",
                maxHeight: "300px",
                overflowY: "auto",
                marginBottom: "10px",
                zIndex: 1000,
                position: "relative",
              }}
            >
              {isLoading ? (
                <div
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    color: "#666",
                  }}
                >
                  <div className="spinner-small"></div> Searching...
                </div>
              ) : masterRoutes.length > 0 ? (
                <>
                  <div
                    style={{
                      padding: "8px 12px",
                      backgroundColor: "#f8f9fa",
                      borderBottom: "1px solid #eee",
                      fontSize: "12px",
                      color: "#666",
                    }}
                  >
                    Found {masterRoutes.length} matching route(s)
                  </div>
                  {masterRoutes.map((route) => (
                    <div
                      key={route._id}
                      onClick={() => handleRouteSelect(route)}
                      style={{
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #f0f0f0",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f0f7ff")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "white")
                      }
                    >
                      <div style={{ fontWeight: "500", marginBottom: "3px" }}>
                        {route.masterRouteName}
                      </div>
                      <div style={{ fontSize: "12px", color: "#6c757d" }}>
                        {route.originCity || route.origin?.city || "N/A"} →{" "}
                        {route.destinationCity ||
                          route.destination?.city ||
                          "N/A"}{" "}
                        &nbsp;•&nbsp;
                        {route.isRoundTrip ? "Round Trip" : "One Way"}{" "}
                        &nbsp;•&nbsp;
                        {route.totalDistance ||
                          route.routeDetails?.totalDistance ||
                          0}{" "}
                        km
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    color: "#666",
                  }}
                >
                  No routes found for this route.
                  <button
                    type="button"
                    onClick={handleOpenManualEntry}
                    style={{
                      color: "#007bff",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "0 0 0 5px",
                    }}
                  >
                    Create new route instead
                  </button>
                </div>
              )}
            </div>
          )}

          <div style={{ textAlign: "right" }}>
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={handleOpenManualEntry}
              style={{ padding: "5px 12px", fontSize: "12px" }}
            >
              + Create New Route (skip search)
            </button>
          </div>
        </>
      )}

      {isManualEntry && (
        <div
          className="selector-input-group"
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <input
                type="text"
                value={routeNameValue}
                onChange={handleRouteNameChange}
                placeholder="Enter new master route name..."
                className="form-input"
                style={{ flex: 1 }}
                disabled={disabled}
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleManualEntrySubmit}
                style={{ padding: "8px 16px", whiteSpace: "nowrap" }}
              >
                Save Manual
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancelManualEntry}
                style={{ padding: "8px 16px" }}
              >
                Cancel
              </button>
            </div>
          </div>
          <small className="helper-text" style={{ color: "#666" }}>
            You're creating a new master route. Fill in the details below.
          </small>
        </div>
      )}

      {selectedRouteValue &&
        selectedRouteValue.masterRouteName &&
        !isManualEntry && (
          <div style={{ marginBottom: "5px" }}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <input
                type="text"
                value={routeNameValue}
                onChange={handleRouteNameChange}
                placeholder="Enter master route name..."
                className="form-input"
                style={{ flex: 1 }}
                disabled={disabled}
              />
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={handleClearSelection}
                style={{ padding: "8px 14px", whiteSpace: "nowrap" }}
                title="Clear and search again"
              >
                ✕ Change
              </button>
            </div>
            <small
              style={{
                color: selectedRouteValue.isManual ? "#007bff" : "#28a745",
                display: "block",
                marginTop: "4px",
              }}
            >
              {selectedRouteValue.isManual
                ? "ℹ️ New route — fill in details below"
                : `✓ Auto-filled from "${selectedRouteValue.masterRouteName}" — edit name above if needed`}
            </small>
          </div>
        )}
    </div>
  );
};

const MasterRouteManage = () => {
  const { token } = useSelector((state) => state.user);
  const [selectorKey, setSelectorKey] = useState(0);
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingRoute, setEditingRoute] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingRoute, setViewingRoute] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isRoundTrip, setIsRoundTrip] = useState(true);
  const [activeRouteTab, setActiveRouteTab] = useState("UP");
  const [showEditModal, setShowEditModal] = useState(false);
  const [isUpdatingRoute, setIsUpdatingRoute] = useState(false);
  const [editUpIndex, setEditUpIndex] = useState(null);
  const [editDownIndex, setEditDownIndex] = useState(null);
  const [isManualStop, setIsManualStop] = useState(true);
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [editCitySuggestions, setEditCitySuggestions] = useState([]);
  const [showEditCityDropdown, setShowEditCityDropdown] = useState(false);
  const [modalCitySuggestions, setModalCitySuggestions] = useState([]);
  const [showModalCityDropdown, setShowModalCityDropdown] = useState(false);
  const [editViaInput, setEditViaInput] = useState("");

  const [isOriginManual, setIsOriginManual] = useState(true);
  const [isDestinationManual, setIsDestinationManual] = useState(true);

  const [originManualDistance, setOriginManualDistance] = useState("");
  const [destinationManualDistance, setDestinationManualDistance] =
    useState("");

  const [inlineInsertIndex, setInlineInsertIndex] = useState(null);
  const [inlineInsertForm, setInlineInsertForm] = useState({
    city: "",
    state: "",
    address: "",
    terminal: "",
    stopType: "none",
    distFromPrev: "",
    distToNext: "",
    isManual: true,
  });
  const [inlineInsertCitySuggestions, setInlineInsertCitySuggestions] =
    useState([]);
  const [showInlineInsertDropdown, setShowInlineInsertDropdown] =
    useState(false);

  const [showStopEditModal, setShowStopEditModal] = useState(false);
  const [stopBeingEdited, setStopBeingEdited] = useState(null);
  const [stopEditForm, setStopEditForm] = useState({
    city: "",
    state: "",
    address: "",
    terminal: "",
    stopType: "none",
    manualDistFromPrev: "",
    manualDistToNext: "",
    isManualStop: true,
  });

  const [showStopModal, setShowStopModal] = useState(false);
  const [stopModalMode, setStopModalMode] = useState("add");
  const [tempStopForm, setTempStopForm] = useState({
    city: "",
    state: "",
    address: "",
    terminal: "",
    stopType: "none",
    distFromPrev: "",
    distToNext: "",
    isManual: true,
  });
  const [tempInsertIndex, setTempInsertIndex] = useState(null);
  const [tempEditStopIndex, setTempEditStopIndex] = useState(null);

  const [newRoute, setNewRoute] = useState({
    masterRouteName: "",
    description: "",
    via: [],

    upOriginCity: "",
    upOriginState: "",
    upOriginAddress: "",
    upOriginTerminal: "",
    upOriginCoords: null,
    upDestCity: "",
    upDestState: "",
    upDestAddress: "",
    upDestTerminal: "",
    upDestCoords: null,
    upTotalDistance: "",
    upDurationHours: "",
    upDurationMinutes: "",

    upManualFirstLeg: "",
    downManualFirstLeg: "",

    upManualFinalLeg: "",
    downManualFinalLeg: "",

    destManualDistFromLastStop: "",

    downTotalDistance: "",
    downDurationHours: "",
    downDurationMinutes: "",

    stopCity: "",
    stopState: "",
    stopAddress: "",
    stopTerminal: "",
    stopCoords: null,
    stopDistFromPrev: "",
    stopDistToNext: "",
  });

  const [viaInput, setViaInput] = useState("");

  const addEditViaCity = () => {
    if (!editViaInput.trim()) {
      toast.error("Please enter a via city name");
      return;
    }

    const newVia = {
      city: editViaInput.trim(),
      state: "",
      sequence: (editForm.via?.length || 0) + 1,
    };

    setEditForm((prev) => ({
      ...prev,
      via: [...(prev.via || []), newVia],
    }));
    setEditViaInput("");
  };

  const removeEditViaCity = (index) => {
    const updatedVia = (editForm.via || []).filter((_, i) => i !== index);
    const resequencedVia = updatedVia.map((item, idx) => ({
      ...item,
      sequence: idx + 1,
    }));

    setEditForm((prev) => ({
      ...prev,
      via: resequencedVia,
    }));
  };

  const updateEditViaCity = (index, field, value) => {
    const updatedVia = [...(editForm.via || [])];
    updatedVia[index] = { ...updatedVia[index], [field]: value };
    setEditForm((prev) => ({
      ...prev,
      via: updatedVia,
    }));
  };

  const addViaCity = () => {
    if (!viaInput.trim()) {
      toast.error("Please enter a via city name");
      return;
    }

    const newVia = {
      city: viaInput.trim(),
      state: "",
      sequence: newRoute.via.length + 1,
    };

    setNewRoute((prev) => ({
      ...prev,
      via: [...prev.via, newVia],
    }));
    setViaInput("");
  };

  const removeViaCity = (index) => {
    const updatedVia = newRoute.via.filter((_, i) => i !== index);
    const resequencedVia = updatedVia.map((item, idx) => ({
      ...item,
      sequence: idx + 1,
    }));

    setNewRoute((prev) => ({
      ...prev,
      via: resequencedVia,
    }));
  };

  const updateViaCity = (index, field, value) => {
    const updatedVia = [...newRoute.via];
    updatedVia[index] = { ...updatedVia[index], [field]: value };
    setNewRoute((prev) => ({
      ...prev,
      via: updatedVia,
    }));
  };
const formatDistance = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return '';
  return parseFloat(num.toFixed(2));
};

  const upTotalDistance = parseFloat(newRoute.upTotalDistance);
  const checkOriginManual = () => {
    return (
      isOriginManual ||
      !newRoute.upOriginCoords ||
      (newRoute.upOriginCoords.lat === 0 && newRoute.upOriginCoords.lng === 0)
    );
  };

  const checkDestinationManual = () => {
    return (
      isDestinationManual ||
      !newRoute.upDestCoords ||
      (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0)
    );
  };

  const toProperCase = (str) => {
    if (!str || typeof str !== "string") return str;
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const [upStops, setUpStops] = useState([]);
  const [downStops, setDownStops] = useState([]);
  const [editingStopIndex, setEditingStopIndex] = useState(null);
  const [insertIndex, setInsertIndex] = useState(null);
  const [isCreatingRoute, setIsCreatingRoute] = useState(false);
  const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
  const [isDistanceCalculated, setIsDistanceCalculated] = useState({
    up: false,
    down: false,
  });
  const [activeTab, setActiveTab] = useState("basic");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRoutes, setTotalRoutes] = useState(0);
  const [pageSize] = useState(10);

  const [selectedMasterRoute, setSelectedMasterRoute] = useState(null);

  // const CitySearchDropdown = ({
  //   value,
  //   onChange,
  //   onSelect,
  //   token,
  //   activeRouteTab,
  //   placeholder = "Type city name (min 2 characters)...",
  // }) => {
  //   const [suggestions, setSuggestions] = useState([]);
  //   const [showDropdown, setShowDropdown] = useState(false);
  //   const [isLoading, setIsLoading] = useState(false);
  //   const timeoutRef = useRef(null);

  //   const search = async (q) => {
  //     if (q.length < 2) {
  //       setSuggestions([]);
  //       setShowDropdown(false);
  //       return;
  //     }
  //     setIsLoading(true);
  //     try {
  //       const fn =
  //         activeRouteTab === "UP"
  //           ? searchRouteIntermediateStops
  //           : searchRouteIntermediateStops;
  //       const res = await fn(token, q);
  //       if (res.success && res.cities) {
  //         setSuggestions(res.cities);
  //         setShowDropdown(res.cities.length > 0);
  //       } else {
  //         setSuggestions([]);
  //         setShowDropdown(false);
  //       }
  //     } catch (e) {
  //       console.error("City search error:", e);
  //       setSuggestions([]);
  //       setShowDropdown(false);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   const handleChange = (e) => {
  //     const val = e.target.value;
  //     onChange(val);
  //     if (timeoutRef.current) clearTimeout(timeoutRef.current);
  //     timeoutRef.current = setTimeout(() => search(val), 500);
  //   };

  //   const handleSelect = (city) => {
  //     onSelect(city);
  //     setSuggestions([]);
  //     setShowDropdown(false);
  //   };

  //   useEffect(
  //     () => () => {
  //       if (timeoutRef.current) clearTimeout(timeoutRef.current);
  //     },
  //     [],
  //   );

  //   return (
  //     <div style={{ position: "relative" }}>
  //       <input
  //         type="text"
  //         value={value}
  //         onChange={handleChange}
  //         onFocus={() => suggestions.length > 0 && setShowDropdown(true)}
  //         onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
  //         placeholder={placeholder}
  //         className="form-input"
  //       />
  //       {isLoading && (
  //         <div
  //           style={{
  //             position: "absolute",
  //             right: 10,
  //             top: "50%",
  //             transform: "translateY(-50%)",
  //           }}
  //         >
  //           <div className="spinner-small"></div>
  //         </div>
  //       )}
  //       {showDropdown && suggestions.length > 0 && (
  //         <div
  //           style={{
  //             position: "absolute",
  //             top: "100%",
  //             left: 0,
  //             right: 0,
  //             backgroundColor: "white",
  //             border: "1px solid #ddd",
  //             borderRadius: "4px",
  //             maxHeight: "200px",
  //             overflowY: "auto",
  //             zIndex: 2000,
  //             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  //           }}
  //         >
  //           {suggestions.map((city, idx) => (
  //             <div
  //               key={city.id || idx}
  //               onMouseDown={() => handleSelect(city)}
  //               style={{
  //                 padding: "10px 12px",
  //                 cursor: "pointer",
  //                 borderBottom: "1px solid #f0f0f0",
  //               }}
  //               onMouseEnter={(e) =>
  //                 (e.currentTarget.style.backgroundColor = "#f0f7ff")
  //               }
  //               onMouseLeave={(e) =>
  //                 (e.currentTarget.style.backgroundColor = "white")
  //               }
  //             >
  //               <div style={{ fontWeight: "500" }}>{city.name}</div>
  //               <div style={{ fontSize: "12px", color: "#6c757d" }}>
  //                 {city.state}
  //                 {city.terminal ? ` • ${city.terminal}` : ""}
  //               </div>
  //               {city.address && city.address !== city.name && (
  //                 <div
  //                   style={{
  //                     fontSize: "11px",
  //                     color: "#999",
  //                     marginTop: "2px",
  //                   }}
  //                 >
  //                   {city.address}
  //                 </div>
  //               )}
  //             </div>
  //           ))}
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const isNextStopAuto = (currentIndex) => {
    const stops = getActiveStops();
    const nextStop = stops[currentIndex + 1];
    return (
      nextStop &&
      nextStop.coordinates &&
      (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0)
    );
  };

  const getDefaultStateForStop = (upStops, newRoute, activeRouteTab) => {
    if (activeRouteTab === "UP") {
      if (upStops.length > 0) {
        const lastStop = upStops[upStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          return lastStop.state;
        }
      }
      if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
        return newRoute.upOriginState;
      }
      if (newRoute.upDestState && newRoute.upDestState.trim()) {
        return newRoute.upDestState;
      }
    } else if (activeRouteTab === "DOWN") {
      const downStops = getActiveStops();
      if (downStops.length > 0) {
        const lastStop = downStops[downStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          return lastStop.state;
        }
      }
      if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
        return newRoute.upOriginState;
      }
      if (newRoute.upDestState && newRoute.upDestState.trim()) {
        return newRoute.upDestState;
      }
    }
    return "";
  };

  const handleCitySearch = async (value) => {
    console.log("Searching for:", value);
    console.log("Active route tab:", activeRouteTab);

    try {
      const searchFn =
        activeRouteTab === "UP"
          ? searchRouteIntermediateStops
          : searchRouteIntermediateStops;

      console.log("Using search function:", searchFn.name);
      const response = await searchFn(token, value);
      console.log("API Response:", response);

      if (response.success && response.cities) {
        console.log("Found cities:", response.cities);
        setCitySuggestions(response.cities);
        setShowCityDropdown(true);
      }
    } catch (error) {
      console.error("Search error details:", error);
      console.error("Error response:", error.response);
    }
  };

  const isFirstStopManual = () => {
    const stops = getActiveStops();
    if (stops.length === 0) return false;
    const firstStop = stops[0];
    return (
      !firstStop.coordinates ||
      (firstStop.coordinates.lat === 0 && firstStop.coordinates.lng === 0) ||
      firstStop.isManualStop === true
    );
  };
const handleOriginCitySelect = (cityObj) => {
  setNewRoute((prev) => ({
    ...prev,
    upOriginCity: cityObj.city,
    upOriginState: cityObj.state,
    upOriginAddress: cityObj.address,
    upOriginTerminal: cityObj.terminal,
    upOriginCoords: cityObj.coordinates || null,
  }));
  const hasGPS =
    cityObj.coordinates &&
    (cityObj.coordinates.lat !== 0 || cityObj.coordinates.lng !== 0);
  setIsOriginManual(!hasGPS);
  setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
};

const handleDestCitySelect = (cityObj) => {
  setNewRoute((prev) => ({
    ...prev,
    upDestCity: cityObj.city,
    upDestState: cityObj.state,
    upDestAddress: cityObj.address,
    upDestTerminal: cityObj.terminal,
    upDestCoords: cityObj.coordinates || null,
  }));
  const hasGPS =
    cityObj.coordinates &&
    (cityObj.coordinates.lat !== 0 || cityObj.coordinates.lng !== 0);
  setIsDestinationManual(!hasGPS);
  setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
};

const handleEditOriginCitySelect = (cityObj) => {
  setEditForm((prev) => ({
    ...prev,
    originCity: cityObj.city,
    originState: cityObj.state,
    originAddress: cityObj.address,
    originTerminal: cityObj.terminal,
    originCoords: cityObj.coordinates || { lat: 0, lng: 0 },
  }));
};

const handleEditDestCitySelect = (cityObj) => {
  setEditForm((prev) => ({
    ...prev,
    destCity: cityObj.city,
    destState: cityObj.state,
    destAddress: cityObj.address,
    destTerminal: cityObj.terminal,
    destCoords: cityObj.coordinates || { lat: 0, lng: 0 },
  }));
};

  const isLastStopManual = () => {
    const stops = getActiveStops();
    if (stops.length === 0) return false;
    const lastStop = stops[stops.length - 1];
    return (
      !lastStop.coordinates ||
      (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0) ||
      lastStop.isManualStop === true
    );
  };
  const syncDestinationDistance = (value, source) => {
    if (source === "upManualFinalLeg") {
      setNewRoute((prev) => ({
        ...prev,
        upManualFinalLeg: value,
        destManualDistFromLastStop: !checkDestinationManual()
          ? value
          : prev.destManualDistFromLastStop,
      }));
    } else if (source === "destManualDistFromLastStop") {
      setNewRoute((prev) => ({
        ...prev,
        destManualDistFromLastStop: value,
        upManualFinalLeg: checkDestinationManual()
          ? value
          : prev.upManualFinalLeg,
      }));
    }
  };

  const autoFillFromMasterRoute = (masterRoute) => {
    if (!masterRoute) return;

    console.log("Auto-filling from master route:", masterRoute);

    setSelectedMasterRoute(masterRoute);

    if (masterRoute.isManual) {
      setNewRoute((prev) => ({
        ...prev,
        masterRouteName: masterRoute.masterRouteName,
        via: masterRoute.via || [],
      }));
      return;
    }

    setNewRoute((prev) => ({
      ...prev,
      masterRouteName: masterRoute.masterRouteName,
      description: masterRoute.description || "",
      via: masterRoute.via || [],
    }));
    if (masterRoute.origin) {
      setNewRoute((prev) => ({
        ...prev,
        upOriginCity: masterRoute.origin.city || "",
        upOriginState: masterRoute.origin.state || "",
        upOriginAddress:
          masterRoute.origin.address ||
          `${masterRoute.origin.city || ""}, ${masterRoute.origin.state || "India"}`,
        upOriginTerminal:
          masterRoute.origin.terminal ||
          `${masterRoute.origin.city || ""} Bus Stand`,
        upOriginCoords: masterRoute.origin.coordinates || null,
      }));

      const hasValidCoords =
        masterRoute.origin.coordinates &&
        (masterRoute.origin.coordinates.lat !== 0 ||
          masterRoute.origin.coordinates.lng !== 0);
      setIsOriginManual(!hasValidCoords);
    }

    if (masterRoute.destination) {
      setNewRoute((prev) => ({
        ...prev,
        upDestCity: masterRoute.destination.city || "",
        upDestState: masterRoute.destination.state || "",
        upDestAddress:
          masterRoute.destination.address ||
          `${masterRoute.destination.city || ""}, ${masterRoute.destination.state || "India"}`,
        upDestTerminal:
          masterRoute.destination.terminal ||
          `${masterRoute.destination.city || ""} Bus Stand`,
        upDestCoords: masterRoute.destination.coordinates || null,
        upTotalDistance: masterRoute.routeDetails?.totalDistance || "",
        upDurationHours:
          masterRoute.routeDetails?.estimatedDuration?.hours || "",
        upDurationMinutes:
          masterRoute.routeDetails?.estimatedDuration?.minutes || "",
      }));

      const hasValidCoords =
        masterRoute.destination.coordinates &&
        (masterRoute.destination.coordinates.lat !== 0 ||
          masterRoute.destination.coordinates.lng !== 0);
      setIsDestinationManual(!hasValidCoords);
    }

    let lastStopToDestinationDistance = 0;
    const upTotalDist =
      parseFloat(masterRoute.routeDetails?.totalDistance) || 0;

    if (masterRoute.intermediateStops &&
    masterRoute.intermediateStops.length > 0) {
      const lastStopDistance =
        masterRoute.intermediateStops[masterRoute.intermediateStops.length - 1]
          .distanceFromOrigin || 0;
      lastStopToDestinationDistance = formatDistance(upTotalDist - lastStopDistance);
      if (lastStopToDestinationDistance < 0) lastStopToDestinationDistance = 0;
    } else if (upTotalDist > 0) {
      lastStopToDestinationDistance = upTotalDist;
    }

    const isDestManualLocal =
      isDestinationManual ||
      !masterRoute.destination?.coordinates ||
      (masterRoute.destination.coordinates.lat === 0 &&
        masterRoute.destination.coordinates.lng === 0);

    if (isDestManualLocal) {
      setNewRoute((prev) => ({
        ...prev,
        upManualFinalLeg:
          lastStopToDestinationDistance > 0
            ? lastStopToDestinationDistance.toFixed(1)
            : "",
      }));
    } else if (
      masterRoute.intermediateStops &&
      masterRoute.intermediateStops.length > 0
    ) {
      const lastStop =
        masterRoute.intermediateStops[masterRoute.intermediateStops.length - 1];
      const isLastStopManual =
        !lastStop.coordinates ||
        (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0);

      if (isLastStopManual) {
        setNewRoute((prev) => ({
          ...prev,
          destManualDistFromLastStop:
            lastStopToDestinationDistance > 0
              ? lastStopToDestinationDistance.toFixed(1)
              : "",
        }));
      }
    }

    if (masterRoute.intermediateStops &&
    masterRoute.intermediateStops.length > 0) {
      const transformedUpStops = masterRoute.intermediateStops.map(
        (stop, index, array) => {
          const isManualStop =
            !stop.coordinates ||
            (stop.coordinates.lat === 0 && stop.coordinates.lng === 0) ||
            stop.isManualStop === true;

          let distanceFromPrev = null;
          const currentDistance = stop.distanceFromOrigin || 0;

          if (index === 0) {
            const originDistance = masterRoute.origin?.distanceFromOrigin || 0;
            distanceFromPrev = currentDistance - originDistance;
          } else {
            const prevDistance = array[index - 1].distanceFromOrigin || 0;
            distanceFromPrev = currentDistance - prevDistance;
          }

          if (distanceFromPrev > 0) {
            distanceFromPrev = parseFloat(distanceFromPrev.toFixed(1));
          }

          return {
            sequence: index + 1,
            city: stop.city || "",
            state: stop.state || "",
            address:
              stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
            terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
            stopType: stop.stopType || "none",
            coordinates: stop.coordinates || { lat: 0, lng: 0 },
            distanceFromOrigin: currentDistance,
            manualDistFromPrev: formatDistance(distanceFromPrev),
            manualDistToNext: stop.manualDistToNext || null,
            isManualStop: isManualStop,
          };
        },
      );
      setUpStops(transformedUpStops);

      console.log(
        "Calculated segment distances:",
        transformedUpStops.map((s) => ({
          city: s.city,
          distanceFromOrigin: s.distanceFromOrigin,
          distanceFromPrev: s.manualDistFromPrev,
        })),
      );
      console.log(
        "Last stop to destination distance:",
        lastStopToDestinationDistance,
      );

      const allHaveDistances = transformedUpStops.every(
        (stop) => stop.distanceFromOrigin > 0,
      );
      setIsDistanceCalculated((prev) => ({ ...prev, up: allHaveDistances }));
    } else {
      setUpStops([]);
      setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
    }

    if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
      setIsRoundTrip(true);
      setActiveRouteTab("UP");

      const returnJourney = masterRoute.returnJourney;

      if (returnJourney.routeDetails) {
        const returnTotalDist = returnJourney.routeDetails.totalDistance || 0;

        setNewRoute((prev) => ({
          ...prev,
          downTotalDistance: returnTotalDist,
          downDurationHours:
            returnJourney.routeDetails.estimatedDuration?.hours || "",
          downDurationMinutes:
            returnJourney.routeDetails.estimatedDuration?.minutes || "",
        }));

        let returnLastStopToDestDistance = 0;
        if (
          returnJourney.intermediateStops &&
          returnJourney.intermediateStops.length > 0
        ) {
          const returnLastStopDistance =
            returnJourney.intermediateStops[
              returnJourney.intermediateStops.length - 1
            ].distanceFromOrigin || 0;
          returnLastStopToDestDistance =
            parseFloat(returnTotalDist) - returnLastStopDistance;
          if (returnLastStopToDestDistance < 0)
            returnLastStopToDestDistance = 0;

          setNewRoute((prev) => ({
            ...prev,
            downManualFinalLeg:
              returnLastStopToDestDistance > 0
                ? returnLastStopToDestDistance.toFixed(1)
                : "",
          }));
        }
      }

      if (returnJourney.intermediateStops &&
      returnJourney.intermediateStops.length > 0) {
        const transformedDownStops = returnJourney.intermediateStops.map(
          (stop, index, array) => {
            const isManualStop =
              !stop.coordinates ||
              (stop.coordinates.lat === 0 && stop.coordinates.lng === 0) ||
              stop.isManualStop === true;

            let distanceFromPrev = null;
            const currentDistance = stop.distanceFromOrigin || 0;

            if (index === 0) {
              const returnOriginDistance =
                returnJourney.origin?.distanceFromOrigin || 0;
              distanceFromPrev = currentDistance - returnOriginDistance;
            } else {
              const prevDistance = array[index - 1].distanceFromOrigin || 0;
              distanceFromPrev = currentDistance - prevDistance;
            }

            if (distanceFromPrev > 0) {
              distanceFromPrev = parseFloat(distanceFromPrev.toFixed(1));
            }

            return {
              sequence: index + 1,
              city: stop.city || "",
              state: stop.state || "",
              address:
                stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
              terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
              stopType: stop.stopType || "none",
              coordinates: stop.coordinates || { lat: 0, lng: 0 },
              distanceFromOrigin: currentDistance,
              manualDistFromPrev: distanceFromPrev,
              manualDistToNext: stop.manualDistToNext || null,
              isManualStop: isManualStop,
            };
          },
        );
        setDownStops(transformedDownStops);

        const allHaveDistances = transformedDownStops.every(
          (stop) => stop.distanceFromOrigin > 0,
        );
        setIsDistanceCalculated((prev) => ({
          ...prev,
          down: allHaveDistances,
        }));
      } else {
        setDownStops([]);
        setIsDistanceCalculated((prev) => ({ ...prev, down: false }));
      }
    } else {
      setIsRoundTrip(false);
      setDownStops([]);
      setIsDistanceCalculated((prev) => ({ ...prev, down: false }));
    }

    toast.success(
      `Master route "${masterRoute.masterRouteName}" loaded successfully! Segment distances calculated from cumulative distances.`,
    );
  };

  const formatDuration = (hours, minutes) => {
    if (!hours && !minutes) return "N/A";
    const parts = [];
    if (hours) parts.push(`${hours}h`);
    if (minutes) parts.push(`${minutes}m`);
    return parts.join(" ");
  };

  const handleSelectOrigin = (location) => {
    setNewRoute((prev) => ({
      ...prev,
      upOriginCity: location.city || location.name || "",
      upOriginState: location.state || "",
      upOriginAddress: location.address || "",
      upOriginCoords: location.coordinates || { lat: 0, lng: 0 },
    }));
    setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
  };

  const handleSelectDest = (location) => {
    setNewRoute((prev) => ({
      ...prev,
      upDestCity: location.city || location.name || "",
      upDestState: location.state || "",
      upDestAddress: location.address || "",
      upDestCoords: location.coordinates || { lat: 0, lng: 0 },
    }));
    setIsDistanceCalculated((prev) => ({ ...prev, up: false }));
  };

  const handleSelectStop = (location) => {
    let autoState = location.state || "";

    if (!autoState && activeRouteTab === "UP") {
      if (upStops.length > 0) {
        const lastStop = upStops[upStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          autoState = lastStop.state;
        }
      }
      if (
        !autoState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        autoState = newRoute.upOriginState;
      }
    } else if (!autoState && activeRouteTab === "DOWN") {
      if (downStops.length > 0) {
        const lastStop = downStops[downStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          autoState = lastStop.state;
        }
      }
      if (
        !autoState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        autoState = newRoute.upOriginState;
      }
    }

    setNewRoute((prev) => ({
      ...prev,
      stopCity: location.city || location.name || "",
      stopState: autoState,
      stopAddress: location.address || "",
      stopCoords: location.coordinates || { lat: 0, lng: 0 },
    }));
    setIsManualStop(true);
  };

  const handleStopEditLocationSelect = (location) => {
    setStopEditForm((prev) => ({
      ...prev,
      city: location.city || location.name || "",
      state: location.state || "",
      address: location.address || "",
      isManualStop: false,
    }));
  };

  const saveEditedStop = () => {
    if (!stopEditForm.city) {
      toast.error("City is required");
      return;
    }

    const isManualLocation = stopEditForm.isManualStop;

    if (isManualLocation &&
    (!stopEditForm.manualDistFromPrev ||
      parseFloat(stopEditForm.manualDistFromPrev) <= 0)) {
      toast.error(
        "For manual stops, please provide distance from previous stop",
      );
      return;
    }

    const stopAddress =
      stopEditForm.address ||
      `${stopEditForm.city}, ${stopEditForm.state || "India"}`;

    const updatedStop = {
      city: stopEditForm.city,
      state: stopEditForm.state || "",
      address: stopAddress,
      terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
      stopType: stopEditForm.stopType,
      coordinates: isManualLocation
        ? { lat: 0, lng: 0 }
        : stopBeingEdited.originalStop.coordinates,
      manualDistFromPrev: isManualLocation
        ? formatDistance(stopEditForm.manualDistFromPrev)
        : null,
      manualDistToNext: stopEditForm.manualDistToNext
        ? formatDistance(stopEditForm.manualDistToNext)
        : null,
      distanceFromOrigin: formatDistance(stopBeingEdited.originalStop.distanceFromOrigin || 0),
      isManualStop: isManualLocation,
    };

    const { index, type } = stopBeingEdited;
    setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

    if (type === "up") {
      const updatedStops = [...upStops];
      updatedStops[index] = updatedStop;
      setUpStops(updatedStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    } else {
      const updatedStops = [...downStops];
      updatedStops[index] = updatedStop;
      setDownStops(updatedStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    }

    setShowStopEditModal(false);
    setStopBeingEdited(null);
    setStopEditForm({
      city: "",
      state: "",
      address: "",
      terminal: "",
      stopType: "none",
      manualDistFromPrev: "",
      manualDistToNext: "",
      isManualStop: false,
    });

    toast.success("Stop updated successfully");
  };

  const validateRouteDistances = (stops, totalDistance, routeName = "") => {
    if (!stops.length) return true;

    let lastDistance = 0;

    for (let i = 0; i < stops.length; i++) {
      const stop = stops[i];
      const stopDistance = parseFloat(stop.distanceFromOrigin);

      if (isNaN(stopDistance)) {
        toast.error(
          `${routeName} Stop "${stop.city}" has invalid distance value`,
        );
        return false;
      }

      if (stopDistance < 0) {
        toast.error(
          `${routeName} Stop "${stop.city}" distance cannot be negative`,
        );
        return false;
      }

      if (stopDistance <= lastDistance && i > 0) {
        toast.error(
          `${routeName} Stop distances must be in increasing order. Check "${stop.city}"`,
        );
        return false;
      }

      lastDistance = stopDistance;
    }

    return true;
  };

  const syncDownStopsWithUpStops = (forcePrompt = false) => {
    const hasManualStops = upStops.some(
      (s) =>
        !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
    );

    if (forcePrompt && !isDistanceCalculated.up && hasManualStops) {
      toast.warning(
        "Please calculate distances for UP route before syncing the return route.",
      );
      return;
    }

    const doSync = () => {
      const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;

      const upPoints = [];

      upPoints.push({
        city: newRoute.upOriginCity,
        state: newRoute.upOriginState,
        address: newRoute.upOriginAddress,
        terminal: newRoute.upOriginTerminal,
        cumulativeDistance: 0,
        coordinates: newRoute.upOriginCoords,
        stopType: "origin",
        isManualStop: checkOriginManual(),
      });

      upStops.forEach((stop, idx) => {
        upPoints.push({
          city: stop.city,
          state: stop.state,
          address: stop.address,
          terminal: stop.terminal,
          cumulativeDistance: stop.distanceFromOrigin || 0,
          coordinates: stop.coordinates,
          stopType: stop.stopType,
          isManualStop: stop.isManualStop,
        });
      });

      upPoints.push({
        city: newRoute.upDestCity,
        state: newRoute.upDestState,
        address: newRoute.upDestAddress,
        terminal: newRoute.upDestTerminal,
        cumulativeDistance: upTotalDist,
        coordinates: newRoute.upDestCoords,
        stopType: "destination",
        isManualStop: checkDestinationManual(),
      });

      const downPoints = [...upPoints].reverse();

      const reversedStopsWithDistances = [];

      for (let i = 0; i < downPoints.length; i++) {
        const point = downPoints[i];

        const downCumulativeDistance = upTotalDist - point.cumulativeDistance;

        point.downCumulativeDistance = downCumulativeDistance;
      }

      for (let i = 1; i < downPoints.length - 1; i++) {
        const point = downPoints[i];

        const prevPoint = downPoints[i - 1];
        const segmentDistance =
          point.downCumulativeDistance - prevPoint.downCumulativeDistance;

        let newStopType = point.stopType;
        if (point.stopType === "boarding") {
          newStopType = "dropping";
        } else if (point.stopType === "dropping") {
          newStopType = "boarding";
        } else if (point.stopType === "both") {
          newStopType = "both";
        } else if (
          point.stopType === "origin" ||
          point.stopType === "destination"
        ) {
          newStopType = "none";
        }

        reversedStopsWithDistances.push({
          city: point.city,
          state: point.state || "",
          address:
            point.address || `${point.city || ""}, ${point.state || "India"}`,
          terminal: point.terminal || `${point.city || ""} Bus Stand`,
          stopType: newStopType,
          coordinates: point.coordinates || { lat: 0, lng: 0 },
          sequence: i,
          distanceFromOrigin: parseFloat(
            point.downCumulativeDistance.toFixed(1),
          ),
          manualDistFromPrev:
            segmentDistance > 0 ? formatDistance(segmentDistance) : null,
          manualDistToNext: null,
          isManualStop: point.isManualStop,
        });
      }

      const downTotalDistance = upTotalDist;

      console.log("DOWN stops created:", reversedStopsWithDistances);
      console.log("DOWN total distance:", downTotalDistance);

      setDownStops(reversedStopsWithDistances);
      setNewRoute((prev) => ({
        ...prev,
        downTotalDistance: downTotalDistance.toFixed(1),
      }));

      if (editingRoute) {
        setEditForm((prev) => ({
          ...prev,
          returnTotalDistance: downTotalDistance.toFixed(1),
        }));
      }

      setIsDistanceCalculated((prev) => ({ ...prev, down: false }));

      toast.success(
        `DOWN route populated with ${reversedStopsWithDistances.length} stops. Cumulative distances: ${reversedStopsWithDistances.map((s) => `${s.city}(${s.distanceFromOrigin}km)`).join(", ")}`,
      );
    };

    if (forcePrompt && downStops.length > 0) {
      if (
        window.confirm(
          "This will update your Return Route stops based on your Main Route. Proceed?",
        )
      ) {
        doSync();
      }
    } else {
      doSync();
    }
  };

  const toggleRoundTrip = () => {
    const newVal = !isRoundTrip;
    setIsRoundTrip(newVal);

    if (newVal) {
      if (downStops.length === 0 && upStops.length > 0) {
        const reversed = [...upStops].reverse().map((s, idx) => {
          let newStopType = s.stopType;
          if (s.stopType === "boarding") {
            newStopType = "dropping";
          } else if (s.stopType === "dropping") {
            newStopType = "boarding";
          }

          return {
            city: s.city,
            state: s.state || "",
            address: s.address || "",
            terminal: s.terminal || "",
            stopType: newStopType,
            coordinates: s.coordinates || { lat: 0, lng: 0 },
            sequence: idx + 1,
            manualDistFromPrev: s.manualDistToNext || null,
            manualDistToNext: s.manualDistFromPrev || null,
            distanceFromOrigin: 0,
          };
        });
        setDownStops(reversed);
      }
      setActiveRouteTab("DOWN");
    } else {
      setActiveRouteTab("UP");
    }
    clearStopForm();
  };

  const handleTabSwitch = (tab) => {
    if (tab === "DOWN" && downStops.length === 0 && upStops.length > 0) {
      syncDownStopsWithUpStops(false);
    }
    setActiveRouteTab(tab);
    clearStopForm();
  };

  const getActiveStops = () => {
    if (activeRouteTab === "UP") return upStops;
    return downStops;
  };
  const setActiveStops = (stops) => {
    if (activeRouteTab === "UP") {
      setUpStops(stops);
    } else {
      setDownStops(stops);
    }
  };

  const clearStopForm = () => {
    let defaultState = "";

    if (activeRouteTab === "UP") {
      if (upStops.length > 0) {
        const lastStop = upStops[upStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          defaultState = lastStop.state;
        }
      }
      if (
        !defaultState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        defaultState = newRoute.upOriginState;
      }
      if (
        !defaultState &&
        newRoute.upDestState &&
        newRoute.upDestState.trim()
      ) {
        defaultState = newRoute.upDestState;
      }
    } else if (activeRouteTab === "DOWN") {
      if (downStops.length > 0) {
        const lastStop = downStops[downStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          defaultState = lastStop.state;
        }
      }
      if (
        !defaultState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        defaultState = newRoute.upOriginState;
      }
      if (
        !defaultState &&
        newRoute.upDestState &&
        newRoute.upDestState.trim()
      ) {
        defaultState = newRoute.upDestState;
      }
    }

    setNewRoute((prev) => ({
      ...prev,
      stopCity: "",
      stopState: defaultState,
      stopAddress: "",
      stopTerminal: "",
      stopCoords: null,
      stopDistFromPrev: "",
      stopDistToNext: "",
      stopType: "none",
    }));
    setEditingStopIndex(null);
    setInsertIndex(null);
    setIsManualStop(true);

    setTempStopForm({
      city: "",
      state: defaultState,
      address: "",
      terminal: "",
      stopType: "none",
      distFromPrev: "",
      distToNext: "",
      isManual: false,
    });
  };
  const openAddStopModal = () => {
    let defaultState = "";

    if (activeRouteTab === "UP") {
      if (upStops.length > 0) {
        const lastStop = upStops[upStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          defaultState = lastStop.state;
        }
      }
      if (
        !defaultState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        defaultState = newRoute.upOriginState;
      }
    } else {
      if (downStops.length > 0) {
        const lastStop = downStops[downStops.length - 1];
        if (lastStop.state && lastStop.state.trim()) {
          defaultState = lastStop.state;
        }
      }
      if (
        !defaultState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        defaultState = newRoute.upOriginState;
      }
    }

    setTempStopForm({
      city: "",
      state: defaultState,
      address: "",
      terminal: "",
      stopType: "none",
      distFromPrev: "",
      distToNext: "",
      isManual: true,
    });
    setStopModalMode("add");
    setTempInsertIndex(null);
    setTempEditStopIndex(null);
    setShowStopModal(true);
  };

  const saveInlineInsert = () => {
    if (!inlineInsertForm.city) {
      toast.error("City is required");
      return;
    }
    if (
      inlineInsertForm.isManual &&
      (!inlineInsertForm.distFromPrev ||
        parseFloat(inlineInsertForm.distFromPrev) <= 0)
    ) {
      toast.error("Distance from previous stop is required");
      return;
    }

    const type = activeRouteTab === "UP" ? "up" : "down";
    const currentStops = type === "up" ? [...upStops] : [...downStops];

    const manualDistFromPrev = inlineInsertForm.isManual
      ? formatDistance(parseFloat(inlineInsertForm.distFromPrev))
      : null;
    const manualDistToNext = inlineInsertForm.distToNext
      ? formatDistance(parseFloat(inlineInsertForm.distToNext))
      : null;

    let distanceFromOrigin = 0;
    if (inlineInsertIndex > 0 && currentStops[inlineInsertIndex - 1]) {
      distanceFromOrigin =
        (currentStops[inlineInsertIndex - 1].distanceFromOrigin || 0) +
        (manualDistFromPrev || 0);
    } else {
      distanceFromOrigin = manualDistFromPrev || 0;
    }

    const newStop = {
      city: inlineInsertForm.city,
      state: inlineInsertForm.state || "",
      address:
        inlineInsertForm.address ||
        `${inlineInsertForm.city}, ${inlineInsertForm.state || "India"}`,
      terminal:
        inlineInsertForm.terminal || `${inlineInsertForm.city} Bus Stand`,
      stopType: inlineInsertForm.stopType,
      coordinates: inlineInsertForm.isManual ? { lat: 0, lng: 0 } : null,
      manualDistFromPrev,
      manualDistToNext,
    distanceFromOrigin: formatDistance(distanceFromOrigin),
      isManualStop: inlineInsertForm.isManual,
    };

    currentStops.splice(inlineInsertIndex, 0, newStop);
    setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

    if (type === "up")
      setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    else setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));

    toast.success(
      `Stop "${inlineInsertForm.city}" inserted at position ${inlineInsertIndex + 1}`,
    );
    setInlineInsertIndex(null);
    setInlineInsertCitySuggestions([]);
    setShowInlineInsertDropdown(false);
  };

  const openInsertStopModal = (index) => {
    let defaultState = "";

    if (activeRouteTab === "UP") {
      if (upStops.length > 0 && index > 0) {
        const prevStop = upStops[index - 1];
        if (prevStop.state && prevStop.state.trim()) {
          defaultState = prevStop.state;
        }
      }
      if (
        !defaultState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        defaultState = newRoute.upOriginState;
      }
    } else {
      if (downStops.length > 0 && index > 0) {
        const prevStop = downStops[index - 1];
        if (prevStop.state && prevStop.state.trim()) {
          defaultState = prevStop.state;
        }
      }
      if (
        !defaultState &&
        newRoute.upOriginState &&
        newRoute.upOriginState.trim()
      ) {
        defaultState = newRoute.upOriginState;
      }
    }

    setTempStopForm({
      city: "",
      state: defaultState,
      address: "",
      terminal: "",
      stopType: "none",
      distFromPrev: "",
      distToNext: "",
      isManual: false,
    });
    setStopModalMode("insert");
    setTempInsertIndex(index);
    setTempEditStopIndex(null);
    setShowStopModal(true);
  };

  const openEditStopModal = (index, type = "up") => {
    const stop = type === "up" ? upStops[index] : downStops[index];
    const isManual =
      !stop.coordinates ||
      (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

    setTempStopForm({
      city: stop.city || "",
      state: stop.state || "",
      address: stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
      terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
      stopType: stop.stopType || "none",
      distFromPrev: stop.manualDistFromPrev
        ? String(stop.manualDistFromPrev)
        : "",
      distToNext: stop.manualDistToNext ? String(stop.manualDistToNext) : "",
      isManual:
        isManual ||
        (stop.manualDistFromPrev !== null &&
          stop.manualDistFromPrev !== undefined),
    });
    setStopModalMode("edit");
    setTempInsertIndex(null);
    setTempEditStopIndex({ index, type });
    setShowStopModal(true);
  };
  const saveStopFromModal = () => {
    if (!tempStopForm.city) {
      toast.error("City is required");
      return;
    }

    const isManualLocation = tempStopForm.isManual;

    if (
      isManualLocation &&
      (!tempStopForm.distFromPrev || parseFloat(tempStopForm.distFromPrev) <= 0)
    ) {
      toast.error(
        "For manual stops, please provide distance from previous stop",
      );
      return;
    }

    const type = activeRouteTab === "UP" ? "up" : "down";
    let currentStops = type === "up" ? [...upStops] : [...downStops];

    const stopAddress =
      tempStopForm.address ||
      `${tempStopForm.city}, ${tempStopForm.state || "India"}`;

    let coordinates = null;
    let manualDistFromPrev = null;
    let manualDistToNext = null;
    let distanceFromOrigin = 0;

    if (isManualLocation) {
      coordinates = { lat: 0, lng: 0 };
      manualDistFromPrev = parseFloat(tempStopForm.distFromPrev);
      if (tempStopForm.distToNext && parseFloat(tempStopForm.distToNext) > 0) {
        manualDistToNext = parseFloat(tempStopForm.distToNext);
      }
    }

    if (stopModalMode === "edit" && tempEditStopIndex) {
      const editIndex = tempEditStopIndex.index;

      if (editIndex === 0) {
        distanceFromOrigin =
          manualDistFromPrev || currentStops[editIndex].distanceFromOrigin;
      } else {
        const prevStop = currentStops[editIndex - 1];
        const prevDistance = prevStop.distanceFromOrigin || 0;
        distanceFromOrigin = prevDistance + (manualDistFromPrev || 0);
      }

      const updatedStop = {
        ...currentStops[editIndex],
        city: tempStopForm.city,
        state: tempStopForm.state || "",
        address: stopAddress,
        terminal: tempStopForm.terminal || `${tempStopForm.city} Bus Stand`,
        stopType: tempStopForm.stopType,
        coordinates: coordinates,
        manualDistFromPrev: manualDistFromPrev,
        manualDistToNext: manualDistToNext,
distanceFromOrigin: parseFloat(formatDistance(distanceFromOrigin).toFixed(2)),
        isManualStop: isManualLocation,
      };

      currentStops[editIndex] = updatedStop;

      for (let i = editIndex + 1; i < currentStops.length; i++) {
        const prevStop = currentStops[i - 1];
        const prevDistance = prevStop.distanceFromOrigin || 0;

        if (currentStops[i].manualDistFromPrev &&
        currentStops[i].manualDistFromPrev > 0) {
          currentStops[i].distanceFromOrigin =
            prevDistance + currentStops[i].manualDistFromPrev;
        }
      }

      toast.success(`Stop "${tempStopForm.city}" updated successfully`);
    } else {
      const insertAtPosition =
        stopModalMode === "insert" && tempInsertIndex !== null
          ? tempInsertIndex
          : currentStops.length;

      if (insertAtPosition === 0) {
        distanceFromOrigin = manualDistFromPrev || 0;
      } else {
        const prevStop = currentStops[insertAtPosition - 1];
        const prevDistance = prevStop.distanceFromOrigin || 0;
        distanceFromOrigin = prevDistance + (manualDistFromPrev || 0);
      }

      const newStop = {
        city: tempStopForm.city,
        state: tempStopForm.state || "",
        address: stopAddress,
        terminal: tempStopForm.terminal || `${tempStopForm.city} Bus Stand`,
        stopType: tempStopForm.stopType,
        coordinates: coordinates,
        manualDistFromPrev: manualDistFromPrev,
        manualDistToNext: manualDistToNext,
distanceFromOrigin: parseFloat(formatDistance(distanceFromOrigin).toFixed(2)),
        isManualStop: isManualLocation,
      };

      currentStops.splice(insertAtPosition, 0, newStop);

      for (let i = insertAtPosition + 1; i < currentStops.length; i++) {
        const prevStop = currentStops[i - 1];
        const prevDistance = prevStop.distanceFromOrigin || 0;

        if (
          currentStops[i].manualDistFromPrev &&
          currentStops[i].manualDistFromPrev > 0
        ) {
          currentStops[i].distanceFromOrigin =
            prevDistance + currentStops[i].manualDistFromPrev;
        } else if (currentStops[i].distanceFromOrigin > 0) {
          currentStops[i].distanceFromOrigin =
            prevDistance +
            (currentStops[i].distanceFromOrigin -
              (currentStops[insertAtPosition - 1]?.distanceFromOrigin || 0));
        }
      }

      if (insertAtPosition + 1 < currentStops.length &&
      currentStops[insertAtPosition + 1].manualDistFromPrev) {
        const newPrevStop = currentStops[insertAtPosition];
        currentStops[insertAtPosition + 1].distanceFromOrigin =
          newPrevStop.distanceFromOrigin +
          currentStops[insertAtPosition + 1].manualDistFromPrev;
      }

      toast.success(
        stopModalMode === "insert"
          ? `Stop "${tempStopForm.city}" inserted at position ${insertAtPosition + 1}`
          : `Stop "${tempStopForm.city}" added successfully`,
      );
    }

    setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

    if (type === "up") {
      setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    } else {
      setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    }

    setShowStopModal(false);
    setTempInsertIndex(null);
    setTempEditStopIndex(null);
  };

  const addIntermediateStop = (type = "up") => {
    if (!newRoute.stopCity) {
      toast.error("City is required.");
      return;
    }

    let coordinates = newRoute.stopCoords;
    let manualDistFromPrev = null;
    let manualDistToNext = null;

    const isManualLocation =
      isManualStop ||
      !newRoute.stopCoords ||
      (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

    if (isManualLocation) {
      if (
        !newRoute.stopDistFromPrev ||
        parseFloat(newRoute.stopDistFromPrev) <= 0
      ) {
        toast.error(
          "For manual stops, please provide distance from previous stop",
        );
        return;
      }
      coordinates = { lat: 0, lng: 0 };
      manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);

      const stops = getActiveStops();
      const currentIndex =
        editingStopIndex !== null
          ? editingStopIndex
          : insertIndex !== null
            ? insertIndex
            : stops.length;
      const nextStop = stops[currentIndex];
      const isNextAuto =
        nextStop &&
        nextStop.coordinates &&
        (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);

      if (
        isNextAuto &&
        newRoute.stopDistToNext &&
        parseFloat(newRoute.stopDistToNext) > 0
      ) {
        manualDistToNext = parseFloat(newRoute.stopDistToNext);
      }
    }

    const stopType = newRoute.stopType || "none";

    const stopAddress =
      newRoute.stopAddress ||
      `${newRoute.stopCity}, ${newRoute.stopState || "India"}`;

    let distanceFromOrigin = 0;
    const stops = getActiveStops();

    if (stops.length > 0) {
      const lastStop = stops[stops.length - 1];
      if (lastStop.distanceFromOrigin > 0) {
        distanceFromOrigin = lastStop.distanceFromOrigin + manualDistFromPrev;
      } else if (lastStop.manualDistFromPrev) {
        distanceFromOrigin =
          (lastStop.distanceFromOrigin || 0) + manualDistFromPrev;
      } else {
        distanceFromOrigin = manualDistFromPrev;
      }
    } else {
      distanceFromOrigin = manualDistFromPrev;
    }

    const newStop = {
      city: newRoute.stopCity,
      state: newRoute.stopState || "",
      address: stopAddress,
      terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
      stopType: stopType,
      coordinates: coordinates,
    manualDistFromPrev: manualDistFromPrev ? formatDistance(manualDistFromPrev) : null,
manualDistToNext: manualDistToNext ? formatDistance(manualDistToNext) : null,
      distanceFromOrigin: formatDistance(distanceFromOrigin),
      isManualStop: isManualLocation,
    };

    setIsDistanceCalculated((prev) => ({ ...prev, [type]: false }));

    let currentStops = type === "up" ? [...upStops] : [...downStops];
    let editingIndex = null;

    if (type === "up" && editUpIndex !== null) {
      editingIndex = editUpIndex;
    } else if (type === "down" && editDownIndex !== null) {
      editingIndex = editDownIndex;
    }

    if (editingIndex !== null) {
      currentStops[editingIndex] = {
        ...currentStops[editingIndex],
        ...newStop,
        sequence: editingIndex + 1,
      };
      if (type === "up") {
        setEditUpIndex(null);
      } else {
        setEditDownIndex(null);
      }
      setEditingStopIndex(null);
      toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
    } else if (insertIndex !== null) {
      currentStops.splice(insertIndex, 0, newStop);
      setInsertIndex(null);
      toast.success(
        `Stop "${newRoute.stopCity}" inserted at position ${insertIndex + 1}`,
      );
    } else {
      currentStops.push(newStop);
      toast.success(`Stop "${newRoute.stopCity}" added successfully`);
    }

    if (type === "up") {
      setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    } else {
      setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    }

    clearStopForm();
  };

  const getNextStopInfo = () => {
    const stops = getActiveStops();
    let nextStop = null;

    if (stopModalMode === "insert" && tempInsertIndex !== null) {
      nextStop = stops[tempInsertIndex];
    } else if (stopModalMode === "edit" && tempEditStopIndex) {
      nextStop = stops[tempEditStopIndex.index + 1];
    } else {
      nextStop = stops[stops.length];
    }

    if (
      nextStop &&
      nextStop.coordinates &&
      (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0)
    ) {
      return nextStop;
    }
    return null;
  };

  const renderInlineInsertPanel = (idx) => {
    const stops = getActiveStops();
    const prevStop = idx > 0 ? stops[idx - 1] : null;
    const nextStop = stops[idx] || null;
    const nextHasGPS =
      nextStop?.coordinates?.lat && nextStop.coordinates.lat !== 0;
    const cityOk = inlineInsertForm.city.trim().length > 0;
    const distOk = parseFloat(inlineInsertForm.distFromPrev) > 0;
    const canInsert = cityOk && (!inlineInsertForm.isManual || distOk);

    const fieldStyle = {
      display: "flex",
      flexDirection: "column",
      gap: 5,
    };
    const labelStyle = {
      fontSize: 11,
      fontWeight: 500,
      color: "var(--color-text-secondary, #777)",
      letterSpacing: ".2px",
    };
    const inputStyle = (hasErr = false) => ({
      width: "100%",
      height: 38,
      padding: "0 12px",
      border: `1px solid ${hasErr ? "#e24b4a" : "var(--color-border-secondary, rgba(0,0,0,.2))"}`,
      borderRadius: 8,
      fontSize: 13,
      background: hasErr
        ? "rgba(252,235,235,.05)"
        : "var(--color-background-primary, #fff)",
      color: "var(--color-text-primary, #333)",
      outline: "none",
      boxSizing: "border-box",
    });
    const selectStyle = {
      ...inputStyle(),
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: 32,
    };
    const sectionHead = (label) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          margin: "18px 0 12px",
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 500,
            color: "var(--color-text-secondary, #888)",
            letterSpacing: ".4px",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
        <div
          style={{
            flex: 1,
            height: 1,
            background: "var(--color-border-tertiary, rgba(0,0,0,.1))",
          }}
        />
      </div>
    );

    return (
      <div
        style={{
          width: "100%",
          background: "var(--color-background-primary, #fff)",
          border: "1.5px solid #378add",
          borderRadius: 14,
          overflow: "hidden",
          margin: "6px 0",
          alignSelf: "stretch",
        }}
      >

        <div
          style={{
            background: "linear-gradient(135deg, #185fa5 0%, #378add 100%)",
            padding: "14px 18px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 8,
                background: "rgba(255,255,255,.18)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                flexShrink: 0,
              }}
            >
              📍
            </div>
            <div>

              <div
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,.7)",
                  marginTop: 3,
                }}
              >
                New stop will be placed at position {idx + 1}
              </div>
            </div>
          </div>
          <button
            onClick={() => {
              setInlineInsertIndex(null);
              setInlineInsertCitySuggestions([]);
              setShowInlineInsertDropdown(false);
            }}
            style={{
              width: 26,
              height: 26,
              borderRadius: 6,
              border: "1px solid rgba(255,255,255,.3)",
              background: "transparent",
              color: "#fff",
              cursor: "pointer",
              fontSize: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            ×
          </button>
        </div>


        <div style={{ padding: 18 }}>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "10px 12px",
              background: "var(--color-background-secondary, #f7f7f5)",
              border:
                "0.5px solid var(--color-border-tertiary, rgba(0,0,0,.1))",
              borderRadius: 8,
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <input
              type="checkbox"
              checked={inlineInsertForm.isManual}
              onChange={() =>
                setInlineInsertForm((prev) => ({
                  ...prev,
                  isManual: !prev.isManual,
                  city: "",
                  address: "",
                  state: "",
                  terminal: "",
                  distFromPrev: "",
                  distToNext: "",
                }))
              }
              style={{
                width: 16,
                height: 16,
                accentColor: "#378add",
                cursor: "pointer",
              }}
            />
            <span
              style={{ fontSize: 13, color: "var(--color-text-primary, #333)" }}
            >
              Manually typed stop (no map suggestions)
            </span>
          </label>


          {sectionHead("Stop details")}


          <div style={{ marginBottom: 12 }}>
            <div style={fieldStyle}>
              <label style={labelStyle}>
                City / stop name <span style={{ color: "#e24b4a" }}>*</span>
              </label>
              {!inlineInsertForm.isManual ? (
                <LocationInput
                  value={inlineInsertForm.city}
                  onChange={(v) =>
                    setInlineInsertForm((prev) => ({ ...prev, city: v }))
                  }
                  onLocationSelect={(loc) =>
                    setInlineInsertForm((prev) => ({
                      ...prev,
                      city: loc.city || loc.name || "",
                      state: loc.state || prev.state,
                      address: loc.address || "",
                    }))
                  }
                  placeholder="Search stop city or address…"
                />
              ) : (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={inlineInsertForm.city}
                    onChange={async (e) => {
                      const value = e.target.value;
                      setInlineInsertForm((prev) => ({
                        ...prev,
                        city: value,
                        address: "",
                        state: "",
                        terminal: "",
                      }));
                      if (value.length >= 2) {
                        try {
                          const searchFn =
                            activeRouteTab === "UP"
                              ? searchRouteIntermediateStops
                              : searchRouteIntermediateStops;
                          const res = await searchFn(token, value);
                          if (res.success && res.cities?.length > 0) {
                            setInlineInsertCitySuggestions(res.cities);
                            setShowInlineInsertDropdown(true);
                          } else {
                            setInlineInsertCitySuggestions([]);
                            setShowInlineInsertDropdown(false);
                          }
                        } catch {
                          setInlineInsertCitySuggestions([]);
                          setShowInlineInsertDropdown(false);
                        }
                      } else {
                        setInlineInsertCitySuggestions([]);
                        setShowInlineInsertDropdown(false);
                      }
                    }}
                    onFocus={() =>
                      inlineInsertCitySuggestions.length > 0 &&
                      setShowInlineInsertDropdown(true)
                    }
                    onBlur={() =>
                      setTimeout(() => setShowInlineInsertDropdown(false), 200)
                    }
                    placeholder="Type city name (min 2 chars)…"
                    style={inputStyle()}
                  />
                  {showInlineInsertDropdown &&
                    inlineInsertCitySuggestions.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "white",
                          border: "1px solid #ddd",
                          borderRadius: 8,
                          maxHeight: 200,
                          overflowY: "auto",
                          zIndex: 10000,
                          boxShadow: "0 4px 12px rgba(0,0,0,.12)",
                        }}
                      >
                        {inlineInsertCitySuggestions.map((city, i) => (
                          <div
                            key={city.id || i}
                            onMouseDown={() => {
                              setInlineInsertForm((prev) => ({
                                ...prev,
                                city: city.name,
                                address: city.address || city.name,
                                state: city.state || "",
                                terminal:
                                  city.terminal || `${city.name} Bus Stand`,
                              }));
                              setShowInlineInsertDropdown(false);
                              setInlineInsertCitySuggestions([]);
                            }}
                            style={{
                              padding: "9px 12px",
                              cursor: "pointer",
                              borderBottom: "0.5px solid #f0f0f0",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#f0f7ff")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = "white")
                            }
                          >
                            <div style={{ fontWeight: 500, fontSize: 13 }}>
                              {city.name}
                            </div>
                            <div style={{ fontSize: 11, color: "#888" }}>
                              {city.state}
                              {city.terminal ? ` · ${city.terminal}` : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              )}
            </div>
          </div>


          <div style={{ marginBottom: 12 }}>
            <div style={fieldStyle}>
              <label style={labelStyle}>Address</label>
              <input
                type="text"
                value={inlineInsertForm.address}
                onChange={(e) =>
                  setInlineInsertForm((prev) => ({
                    ...prev,
                    address: e.target.value,
                  }))
                }
                placeholder="e.g. NH-19, Near Bus Stand"
                style={inputStyle()}
              />
            </div>
          </div>


          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
              marginBottom: 4,
            }}
          >
            <div style={fieldStyle}>
              <label style={labelStyle}>State</label>
              <input
                type="text"
                value={inlineInsertForm.state}
                onChange={(e) =>
                  setInlineInsertForm((prev) => ({
                    ...prev,
                    state: e.target.value,
                  }))
                }
                placeholder="State"
                style={inputStyle()}
              />
            </div>
            <div style={fieldStyle}>
              <label style={labelStyle}>Terminal</label>
              <input
                type="text"
                value={inlineInsertForm.terminal}
                onChange={(e) =>
                  setInlineInsertForm((prev) => ({
                    ...prev,
                    terminal: e.target.value,
                  }))
                }
                placeholder="Terminal name"
                style={inputStyle()}
              />
            </div>
          </div>


          {sectionHead("Distance")}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: nextHasGPS ? "1fr 1fr" : "1fr",
              gap: 12,
              marginBottom: 4,
            }}
          >

            <div
              style={{
                border: "1px solid rgba(226,75,74,.4)",
                borderRadius: 10,
                padding: 14,
                background: "rgba(252,235,235,.04)",
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 500,
                  color: "#a32d2d",
                  marginBottom: 6,
                }}
              >
                From previous stop <span style={{ color: "#e24b4a" }}>*</span>
              </div>
              <input
                type="number"
                value={inlineInsertForm.distFromPrev}
                onChange={(e) =>
                  setInlineInsertForm((prev) => ({
                    ...prev,
                    distFromPrev: e.target.value,
                  }))
                }
                placeholder="0"
                min="0"
                step="0.1"
                style={{ ...inputStyle(true), border: "1px solid #e24b4a" }}
              />
              <div
                style={{
                  fontSize: 11,
                  color: "#a32d2d",
                  marginTop: 5,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                ⚠ Required for manual stops
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "var(--color-text-secondary, #888)",
                  marginTop: 2,
                }}
              >
                km
              </div>
            </div>


            {nextHasGPS && (
              <div
                style={{
                  border: "1px solid rgba(55,138,221,.3)",
                  borderRadius: 10,
                  padding: 14,
                  background: "rgba(230,241,251,.04)",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 500,
                    color: "#185fa5",
                    marginBottom: 6,
                  }}
                >
                  To next stop — {nextStop.city}
                </div>
                <input
                  type="number"
                  value={inlineInsertForm.distToNext}
                  onChange={(e) =>
                    setInlineInsertForm((prev) => ({
                      ...prev,
                      distToNext: e.target.value,
                    }))
                  }
                  placeholder="0"
                  min="0"
                  step="0.1"
                  style={{
                    ...inputStyle(),
                    border: "1px solid rgba(55,138,221,.5)",
                  }}
                />
                <div
                  style={{
                    fontSize: 11,
                    color: "#185fa5",
                    marginTop: 5,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  ℹ Next stop has GPS — helps accuracy
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--color-text-secondary, #888)",
                    marginTop: 2,
                  }}
                >
                  km
                </div>
              </div>
            )}
          </div>


          {sectionHead("Stop type")}


        </div>


        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 8,
            padding: "12px 18px",
            borderTop:
              "1px solid var(--color-border-tertiary, rgba(0,0,0,.08))",
            background: "var(--color-background-secondary, #fafafa)",
          }}
        >
          <button
            type="button"
            onClick={() => {
              setInlineInsertIndex(null);
              setInlineInsertCitySuggestions([]);
              setShowInlineInsertDropdown(false);
            }}
            style={{
              padding: "8px 18px",
              fontSize: 13,
              borderRadius: 8,
              border: "1px solid var(--color-border-secondary, rgba(0,0,0,.2))",
              background: "transparent",
              cursor: "pointer",
              color: "var(--color-text-secondary, #666)",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={saveInlineInsert}
            disabled={!canInsert}
            style={{
              padding: "8px 22px",
              fontSize: 13,
              borderRadius: 8,
              border: "none",
              background: "#378add",
              color: "#fff",
              fontWeight: 500,
              cursor: canInsert ? "pointer" : "not-allowed",
              opacity: canInsert ? 1 : 0.45,
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            ✓ Insert stop
          </button>
        </div>
      </div>
    );
  };

  const handleEditStop = (index, type = "up") => {
    openEditStopModal(index, type);
  };
  const handleDeleteStop = (index) => {
    const isUp = activeRouteTab === "UP";
    setIsDistanceCalculated((prev) => ({
      ...prev,
      [isUp ? "up" : "down"]: false,
    }));

    if (isUp) {
      const updated = upStops.filter((_, i) => i !== index);
      setUpStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
      if (editingStopIndex === index && editUpIndex === index) clearStopForm();
    } else {
      const updated = downStops.filter((_, i) => i !== index);
      setDownStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
      if (editingStopIndex === index && editDownIndex === index)
        clearStopForm();
    }
    toast.success("Stop deleted successfully");
  };

  const handleCalculateDistances = async () => {
    const isUp = activeRouteTab === "UP";
    const stops = isUp ? upStops : downStops;

    if (!newRoute.upOriginCity || !newRoute.upDestCity) {
      toast.error("Main Route Origin and Destination required.");
      return;
    }

    const isOriginManualLocal = checkOriginManual();
    const isDestManualLocal = checkDestinationManual();

    if (stops.length > 0 && stops[0]) {
      const isFirstStopManual = stops[0].isManualStop;
      if (isFirstStopManual &&
      stops[0].manualDistFromPrev &&
      parseFloat(stops[0].manualDistFromPrev) > 0) {
        console.log(
          "First stop already has distance from origin:",
          stops[0].manualDistFromPrev,
        );
      } else if (
        (isOriginManualLocal && !isFirstStopManual) ||
        (!isOriginManualLocal && isFirstStopManual)
      ) {
        const firstLeg = isUp
          ? newRoute.upManualFirstLeg
          : newRoute.downManualFirstLeg;
        if (!firstLeg || parseFloat(firstLeg) <= 0) {
          toast.error("Please provide distance from origin to first stop.");
          setIsCalculatingDistances(false);
          return;
        }
      }
    }

    if (stops.length > 0 && stops[stops.length - 1]) {
      const isLastStopManual = stops[stops.length - 1].isManualStop;
      if (isDestManualLocal) {
        const finalLeg = isUp
          ? newRoute.upManualFinalLeg
          : newRoute.downManualFinalLeg;
        if (!finalLeg || parseFloat(finalLeg) <= 0) {
          toast.error(
            "Destination is manual. Please provide distance from last stop to destination.",
          );
          setIsCalculatingDistances(false);
          return;
        }
      } else if (!isDestManualLocal && isLastStopManual) {
        const finalLeg = isUp
          ? newRoute.destManualDistFromLastStop
          : newRoute.downManualFinalLeg;
        if (!finalLeg || parseFloat(finalLeg) <= 0) {
          toast.error(
            "Last stop is manual, destination has GPS. Please provide distance to destination.",
          );
          setIsCalculatingDistances(false);
          return;
        }
      }
    }

    let originNode, destNode;

    if (isUp) {
      originNode = {
        id: "origin",
        name: newRoute.upOriginCity,
        lat: newRoute.upOriginCoords?.lat || 0,
        lng: newRoute.upOriginCoords?.lng || 0,
        isManual: isOriginManualLocal,
      };
      destNode = {
        id: "destination",
        name: newRoute.upDestCity,
        lat: newRoute.upDestCoords?.lat || 0,
        lng: newRoute.upDestCoords?.lng || 0,
        isManual: isDestManualLocal,
      };
    } else {
      originNode = {
        id: "origin",
        name: newRoute.upDestCity,
        lat: newRoute.upDestCoords?.lat || 0,
        lng: newRoute.upDestCoords?.lng || 0,
        isManual: isDestManualLocal,
      };
      destNode = {
        id: "destination",
        name: newRoute.upOriginCity,
        lat: newRoute.upOriginCoords?.lat || 0,
        lng: newRoute.upOriginCoords?.lng || 0,
        isManual: isOriginManualLocal,
      };
    }

    setIsCalculatingDistances(true);
    toast.info(`Calculating ${activeRouteTab} route distances...`);

    try {
      const stopNodes = stops.map((s, i) => ({
        id: `stop_${i}`,
        name: s.city,
        lat: s.coordinates?.lat,
        lng: s.coordinates?.lng,
        manualFromPrev: s.manualDistFromPrev,
        manualToNext: s.manualDistToNext,
        isManual:
          s.isManualStop ||
          !s.coordinates ||
          (s.coordinates.lat === 0 && s.coordinates.lng === 0),
        originalStop: s,
      }));

      const fullPath = [originNode, ...stopNodes, destNode];
      const validNodes = fullPath.filter(
        (s) => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual,
      );

      let matrixResponse = null;
      if (validNodes.length >= 2) {
        matrixResponse = await getDistanceMatrix(validNodes, validNodes);
      }

      let cumulativeDist = 0;
      let lastAutoNodeIndex = -1;
      let sumManualSinceLastAuto = 0;
      const updatedStops = [];
      let validNodeCounter = -1;
      let prevStopCumulativeDist = 0;

      const segmentDistances = [];

      if (stops.length > 0 && stops[0]) {
        const isFirstStopManual = stops[0].isManualStop;

        if (isFirstStopManual &&
        stops[0].manualDistFromPrev &&
        parseFloat(stops[0].manualDistFromPrev) > 0) {
          const firstLeg = parseFloat(stops[0].manualDistFromPrev);
          cumulativeDist = firstLeg;
          sumManualSinceLastAuto = firstLeg;
          prevStopCumulativeDist = cumulativeDist;
          segmentDistances.push(firstLeg);
          if (!isFirstStopManual) {
            sumManualSinceLastAuto = 0;
          }
        } else if (
          (isOriginManualLocal && !isFirstStopManual) ||
          (!isOriginManualLocal && isFirstStopManual)
        ) {
          const firstLeg =
            parseFloat(
              isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg,
            ) || 0;
          cumulativeDist = firstLeg;
          sumManualSinceLastAuto = firstLeg;
          prevStopCumulativeDist = cumulativeDist;
          segmentDistances.push(firstLeg);
          if (!isFirstStopManual) {
            sumManualSinceLastAuto = 0;
          }
        } else if (!isOriginManualLocal && !isFirstStopManual) {
          lastAutoNodeIndex = 0;
          validNodeCounter = 0;
        } else if (isOriginManualLocal && isFirstStopManual) {
          cumulativeDist = 0;
          prevStopCumulativeDist = 0;
        }
      }

      for (let i = 0; i < stopNodes.length; i++) {
        const currNode = stopNodes[i];
        const isManual = currNode.isManual;

        if (isManual) {
          if (i === 0 &&
          stops[0].manualDistFromPrev &&
          parseFloat(stops[0].manualDistFromPrev) > 0) {
            const segment = parseFloat(stops[0].manualDistFromPrev) || 0;
            cumulativeDist = segment;
            sumManualSinceLastAuto = segment;
            prevStopCumulativeDist = cumulativeDist;
            segmentDistances.push(segment);

            updatedStops.push({
              ...stops[i],
              distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
              manualDistFromPrev: segment,
              manualDistToNext: currNode.manualToNext
                ? parseFloat(currNode.manualToNext)
                : null,
            });
          } else if (
            currNode.manualFromPrev !== null &&
            currNode.manualFromPrev !== undefined &&
            currNode.manualFromPrev !== ""
          ) {
            const segment = parseFloat(currNode.manualFromPrev) || 0;
            cumulativeDist += segment;
            sumManualSinceLastAuto += segment;
            segmentDistances.push(segment);

            updatedStops.push({
              ...stops[i],
              distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
              manualDistFromPrev: segment,
              manualDistToNext: currNode.manualToNext
                ? parseFloat(currNode.manualToNext)
                : null,
            });

            prevStopCumulativeDist = cumulativeDist;

            if (currNode.manualToNext && currNode.manualToNext > 0) {
              sumManualSinceLastAuto = currNode.manualToNext;
            }
          } else {
            toast.error(
              `Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`,
            );
            setIsCalculatingDistances(false);
            return;
          }
        } else {
          validNodeCounter++;
          let apiDistance = 0;

          let matrixOriginIndex = lastAutoNodeIndex;
          let matrixDestIndex = validNodeCounter;

          if (isOriginManualLocal && lastAutoNodeIndex === -1) {
            matrixOriginIndex = 0;
            matrixDestIndex = validNodeCounter;
          } else if (isOriginManualLocal && lastAutoNodeIndex !== -1) {
            matrixOriginIndex = lastAutoNodeIndex;
            matrixDestIndex = validNodeCounter;
          }

          if (
            matrixResponse &&
            matrixOriginIndex >= 0 &&
            matrixDestIndex >= 0
          ) {
            const element =
              matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
            if (element?.status === "OK") {
              apiDistance = element.distance.value / 1000;
            }
          }

          let segment = apiDistance - sumManualSinceLastAuto;
          if (segment < 0) segment = 0;

          if (cumulativeDist > 0 || i > 0) {
            cumulativeDist += segment;
          } else if (apiDistance > 0) {
            cumulativeDist = segment;
          }

          if (lastAutoNodeIndex === -1) {
            lastAutoNodeIndex = validNodeCounter;
          }

          if (matrixOriginIndex >= 0) {
            lastAutoNodeIndex = validNodeCounter;
          }

          sumManualSinceLastAuto = 0;

          const distanceFromPrev = cumulativeDist - prevStopCumulativeDist;
          prevStopCumulativeDist = cumulativeDist;
          segmentDistances.push(distanceFromPrev);

          updatedStops.push({
            ...stops[i],
            distanceFromOrigin: parseFloat(cumulativeDist.toFixed(2)),
            manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(2)),
            manualDistToNext: currNode.manualToNext
              ? parseFloat(currNode.manualToNext)
              : null,
          });
        }
      }

      let finalSegment = 0;
      const lastStop =
        stopNodes.length > 0 ? stopNodes[stopNodes.length - 1] : null;
      const isLastStopManualFlag = lastStop && lastStop.isManual;

      if (isDestManualLocal) {
        const finalLeg = parseFloat(
          isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg,
        );
        if (isNaN(finalLeg) || finalLeg <= 0) {
          toast.error(
            `Destination is manual. Please provide distance from last stop to destination.`,
          );
          setIsCalculatingDistances(false);
          return;
        }
        finalSegment = finalLeg;
      } else if (!isDestManualLocal && isLastStopManualFlag) {
        const finalLeg = parseFloat(
          isUp
            ? newRoute.destManualDistFromLastStop
            : newRoute.downManualFinalLeg,
        );
        if (isNaN(finalLeg) || finalLeg <= 0) {
          toast.error(
            `Last stop is manual, destination has GPS. Please provide distance to destination.`,
          );
          setIsCalculatingDistances(false);
          return;
        }
        finalSegment = finalLeg;
      } else if (
        !isDestManualLocal &&
        !isLastStopManualFlag &&
        stopNodes.length > 0
      ) {
        validNodeCounter++;
        let apiDistance = 0;

        let matrixOriginIndex = lastAutoNodeIndex;
        let matrixDestIndex = validNodeCounter;

        if (isOriginManualLocal && lastAutoNodeIndex === -1) {
          matrixOriginIndex = 0;
          matrixDestIndex = validNodeCounter;
        } else if (isOriginManualLocal && lastAutoNodeIndex !== -1) {
          matrixOriginIndex = lastAutoNodeIndex;
          matrixDestIndex = validNodeCounter;
        }

        if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
          const element =
            matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
          if (element?.status === "OK") {
            apiDistance = element.distance.value / 1000;
          }
        }
        finalSegment = apiDistance - sumManualSinceLastAuto;
        if (finalSegment < 0) finalSegment = 0;
      } else if (stopNodes.length === 0) {
        if (isOriginManualLocal && isDestManualLocal) {
          const totalDistance = parseFloat(newRoute.upTotalDistance);
          if (isNaN(totalDistance) || totalDistance <= 0) {
            toast.error(
              "Both origin and destination are manual. Please provide total distance.",
            );
            setIsCalculatingDistances(false);
            return;
          }
          finalSegment = totalDistance;
        } else if (
          !isOriginManualLocal &&
          !isDestManualLocal &&
          matrixResponse
        ) {
          const element = matrixResponse.rows[0]?.elements[1];
          if (element?.status === "OK") {
            finalSegment = element.distance.value / 1000;
          } else {
            toast.error(
              "Could not calculate distance between origin and destination. Please check addresses or enter manually.",
            );
            setIsCalculatingDistances(false);
            return;
          }
        } else if (isOriginManualLocal && !isDestManualLocal) {
          toast.error(
            "Origin is manual, destination has GPS. Please add stops or provide total distance.",
          );
          setIsCalculatingDistances(false);
          return;
        } else if (!isOriginManualLocal && isDestManualLocal) {
          toast.error(
            "Destination is manual, origin has GPS. Please add stops or provide total distance.",
          );
          setIsCalculatingDistances(false);
          return;
        }
      }

      cumulativeDist += finalSegment;

      if (updatedStops.length > 0 && finalSegment > 0) {
        const lastStopIndex = updatedStops.length - 1;
        updatedStops[lastStopIndex] = {
          ...updatedStops[lastStopIndex],
          manualDistToNext: parseFloat(finalSegment.toFixed(1)),
        };
      }

      setActiveStops(updatedStops);
      setNewRoute((prev) => ({
        ...prev,
        [isUp ? "upTotalDistance" : "downTotalDistance"]:
          cumulativeDist.toFixed(1),
      }));

      if (editingRoute) {
        if (isUp) {
          setEditForm((prev) => ({
            ...prev,
            totalDistance: cumulativeDist.toFixed(1),
          }));
        } else {
          setEditForm((prev) => ({
            ...prev,
            returnTotalDistance: cumulativeDist.toFixed(1),
          }));
        }
      }

      setIsDistanceCalculated((prev) => ({
        ...prev,
        [activeRouteTab.toLowerCase()]: true,
      }));
      console.log(
        `${activeRouteTab} route distances calculated - Segment distances:`,
        segmentDistances,
      );

      toast.success(
        `${activeRouteTab} route distances calculated! Each stop now has distance from previous stop stored.`,
      );
    } catch (error) {
      console.error("Distance calculation error:", error);
      toast.error("Calculation failed. Please enter distances manually.");
    } finally {
      setIsCalculatingDistances(false);
    }
  };

  const fetchRoutes = async () => {
    try {
      setLoading(true);
      const response = await getAllMasterRoutes(
        token,
        currentPage,
        pageSize,
        searchTerm,
      );

      if (response && response.success) {
        const routesData = response.data?.routes || [];

        const transformedRoutes = routesData.map((route, index) => ({
          id: route._id || route.id,
          serialNo: (currentPage - 1) * pageSize + index + 1,
          masterRouteNumber: route.masterRouteNumber || "N/A",
          masterRouteName: route.masterRouteName || "N/A",
          originCity: route.origin?.city || "N/A",
          destinationCity: route.destination?.city || "N/A",
          distance: route.routeDetails?.totalDistance || 0,
          duration: formatDuration(
            route.routeDetails?.estimatedDuration?.hours,
            route.routeDetails?.estimatedDuration?.minutes,
          ),
          stops: route.intermediateStops?.length || 0,
          status: route.isActive ? "Active" : "Inactive",
          isActive: route.isActive,
          createdAt: route.createdAt,
          updatedAt: route.updatedAt,
          creatorType: route.creatorType || "Admin",
          creatorName: route.creatorName || "Admin",
          isRoundTrip: route.isRoundTrip || false,
          description: route.description || "",
          fullData: route,
        }));

        setRoutes(transformedRoutes);

        if (response.data?.pagination) {
          setTotalPages(response.data.pagination.totalPages || 1);
          setTotalRoutes(response.data.pagination.total || 0);
        }
      }
    } catch (err) {
      console.error("Error fetching master routes:", err);
      toast.error("Failed to fetch master routes");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
    const timer = setTimeout(() => {
        fetchRoutes();
    }, 500);
    
    return () => clearTimeout(timer);
}, [searchTerm, currentPage]);

  const handleSaveRoute = async () => {
    const isOriginManualLocal = checkOriginManual();
    const isDestManualLocal = checkDestinationManual();

    if (!isOriginManualLocal &&
    (!newRoute.upOriginCoords ||
      (newRoute.upOriginCoords.lat === 0 &&
        newRoute.upOriginCoords.lng === 0))) {
      toast.error(
        'Please select Origin from suggestions to get valid coordinates, or check "Manual Origin"',
      );
      return;
    }

    if (!isDestManualLocal &&
    (!newRoute.upDestCoords ||
      (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0))) {
      toast.error(
        'Please select Destination from suggestions to get valid coordinates, or check "Manual Destination"',
      );
      return;
    }

    const invalidStops = upStops.filter((stop) => {
      if (!stop.city?.trim()) return true;
      if (
        !stop.isManualStop &&
        (!stop.coordinates ||
          (stop.coordinates.lat === 0 && stop.coordinates.lng === 0))
      ) {
        return true;
      }
      return false;
    });

    if (invalidStops.length > 0) {
      toast.error(
        `Stop(s) missing required fields: ${invalidStops.map((s) => s.city || "Unknown").join(", ")}`,
      );
      return;
    }

    if (!isDistanceCalculated.up) {
      toast.error("Please calculate UP route distances first");
      return;
    }

    const upTotalDistance = parseFloat(newRoute.upTotalDistance);
    if (isNaN(upTotalDistance) || upTotalDistance <= 0) {
      toast.error("UP route total distance must be greater than 0");
      return;
    }

    if (upStops.length > 0 && upStops[0]) {
      const isFirstStopManual = upStops[0].isManualStop;
      if (isFirstStopManual &&
      upStops[0].manualDistFromPrev &&
      parseFloat(upStops[0].manualDistFromPrev) > 0) {
        console.log(
          "First stop already has distance from origin:",
          upStops[0].manualDistFromPrev,
        );
      } else if (
        (isOriginManualLocal && !isFirstStopManual) ||
        (!isOriginManualLocal && isFirstStopManual)
      ) {
        if (
          !newRoute.upManualFirstLeg ||
          parseFloat(newRoute.upManualFirstLeg) <= 0
        ) {
          toast.error("Please provide distance from origin to first stop.");
          return;
        }
      }
    }

    if (upStops.length > 0 && upStops[upStops.length - 1]) {
      const isLastStopManual = upStops[upStops.length - 1].isManualStop;

      if (isDestManualLocal) {
        if (!newRoute.upManualFinalLeg ||
        parseFloat(newRoute.upManualFinalLeg) <= 0) {
          toast.error(
            "Destination is manual. Please provide distance from last stop to destination.",
          );
          return;
        }
      } else if (!isDestManualLocal && isLastStopManual) {
        if (!newRoute.destManualDistFromLastStop ||
        parseFloat(newRoute.destManualDistFromLastStop) <= 0) {
          toast.error(
            "Last stop is manual, destination has GPS. Please provide distance to destination.",
          );
          return;
        }
      }
    }

    let lastDistance = 0;
    for (let i = 0; i < upStops.length; i++) {
      const stopDistance = parseFloat(upStops[i].distanceFromOrigin);
      if (isNaN(stopDistance)) {
        toast.error(`Stop "${upStops[i].city}" has invalid distance`);
        return;
      }
      if (stopDistance <= lastDistance && i > 0) {
        toast.error(
          `Stop distances must be in increasing order. Check stop "${upStops[i].city}"`,
        );
        return;
      }
      lastDistance = stopDistance;
    }

    if (isRoundTrip) {
      if (!isDistanceCalculated.down) {
        toast.error("Please calculate DOWN route distances first");
        return;
      }

      const downTotalDistance = parseFloat(newRoute.downTotalDistance);
      if (isNaN(downTotalDistance) || downTotalDistance <= 0) {
        toast.error("DOWN route total distance must be greater than 0");
        return;
      }

      const invalidDownStops = downStops.filter((stop) => {
        if (!stop.city?.trim()) return true;
        if (
          !stop.isManualStop &&
          (!stop.coordinates ||
            (stop.coordinates.lat === 0 && stop.coordinates.lng === 0))
        ) {
          return true;
        }
        return false;
      });

      if (invalidDownStops.length > 0) {
        toast.error(
          `DOWN route stop(s) missing required fields: ${invalidDownStops.map((s) => s.city || "Unknown").join(", ")}`,
        );
        return;
      }

      let lastDownDistance = 0;
      for (let i = 0; i < downStops.length; i++) {
        const stopDistance = parseFloat(downStops[i].distanceFromOrigin);
        if (isNaN(stopDistance)) {
          toast.error(`DOWN stop "${downStops[i].city}" has invalid distance`);
          return;
        }
        if (stopDistance <= lastDownDistance && i > 0) {
          toast.error(
            `DOWN stop distances must be in increasing order. Check stop "${downStops[i].city}"`,
          );
          return;
        }
        lastDownDistance = stopDistance;
      }
    }

    setIsCreatingRoute(true);

    try {
      const originCoordinates = isOriginManualLocal
        ? { lat: 0, lng: 0 }
        : {
            lat: newRoute.upOriginCoords.lat,
            lng: newRoute.upOriginCoords.lng,
          };

      const destCoordinates = isDestManualLocal
        ? { lat: 0, lng: 0 }
        : { lat: newRoute.upDestCoords.lat, lng: newRoute.upDestCoords.lng };

      const originData = {
        city: newRoute.upOriginCity.trim(),
        state: newRoute.upOriginState?.trim() || "",
        address:
          newRoute.upOriginAddress?.trim() || `${newRoute.upOriginCity}, India`,
        terminal:
          newRoute.upOriginTerminal?.trim() ||
          `${newRoute.upOriginCity} Terminal`,
        coordinates: originCoordinates,
        distanceFromOrigin: 0,
        isManual: isOriginManualLocal,
      };

      const destData = {
        city: newRoute.upDestCity.trim(),
        state: newRoute.upDestState?.trim() || "",
        address:
          newRoute.upDestAddress?.trim() || `${newRoute.upDestCity}, India`,
        terminal:
          newRoute.upDestTerminal?.trim() || `${newRoute.upDestCity} Terminal`,
        coordinates: destCoordinates,
        distanceFromOrigin: upTotalDistance,
        isManual: isDestManualLocal,
      };

      const cleanStops = (list, isReturnJourney = false) => {
        return list.map((s, index) => {
          const city = s.city?.trim();
          if (!city) {
            throw new Error(`Stop ${index + 1} is missing city name`);
          }

          const state = s.state?.trim() || "";
          const address = s.address?.trim() || `${city}, ${state}, India`;
          const terminal = s.terminal?.trim() || `${city} Terminal`;

          let distanceFromOrigin = parseFloat(s.distanceFromOrigin);
          if (isNaN(distanceFromOrigin)) {
            distanceFromOrigin = 0;
          }

          const stopPayload = {
            sequence: index + 1,
            city: city,
            state: state,
            address: address,
            terminal: terminal,
            stopType: s.stopType || "none",
            coordinates:
              s.coordinates && s.coordinates.lat && s.coordinates.lng
                ? {
                    lat: s.coordinates.lat,
                    lng: s.coordinates.lng,
                  }
                : { lat: 0, lng: 0 },
            distanceFromOrigin: parseFloat(distanceFromOrigin.toFixed(1)),
          };

          if (s.manualDistFromPrev && parseFloat(s.manualDistFromPrev) > 0) {
            stopPayload.manualDistFromPrev = parseFloat(s.manualDistFromPrev);
          }
          if (s.manualDistToNext && parseFloat(s.manualDistToNext) > 0) {
            stopPayload.manualDistToNext = parseFloat(s.manualDistToNext);
          }

          return stopPayload;
        });
      };

      const finalPayload = {
        masterRouteName: newRoute.masterRouteName.trim(),
        description: newRoute.description?.trim() || "",
        via: newRoute.via.map((v) => ({
          city: v.city.trim(),
          state: v.state || "",
          sequence: v.sequence,
        })),
        origin: originData,
        destination: destData,
        intermediateStops: cleanStops(upStops, false),
        routeDetails: {
          totalDistance: parseFloat(upTotalDistance.toFixed(1)),
          estimatedDuration: {
            hours: parseInt(newRoute.upDurationHours || 0, 10),
            minutes: parseInt(newRoute.upDurationMinutes || 0, 10),
          },
        },
        isRoundTrip: isRoundTrip,
      };

      if (isRoundTrip) {
        const downTotalDistance = parseFloat(newRoute.downTotalDistance);

        const returnOriginData = {
          city: destData.city,
          state: destData.state,
          address: destData.address,
          terminal: destData.terminal,
          coordinates: destData.coordinates,
          distanceFromOrigin: 0,
          isManual: destData.isManual,
        };

        const returnDestData = {
          city: originData.city,
          state: originData.state,
          address: originData.address,
          terminal: originData.terminal,
          coordinates: originData.coordinates,
          distanceFromOrigin: downTotalDistance,
          isManual: originData.isManual,
        };

        finalPayload.returnJourney = {
          origin: returnOriginData,
          destination: returnDestData,
          intermediateStops: cleanStops(downStops, true),
          routeDetails: {
            totalDistance: parseFloat(downTotalDistance.toFixed(1)),
            estimatedDuration: {
              hours: parseInt(newRoute.downDurationHours || 0, 10),
              minutes: parseInt(newRoute.downDurationMinutes || 0, 10),
            },
          },
        };
      }

      console.log("Final Payload:", JSON.stringify(finalPayload, null, 2));

      const response = await createMasterRoute(finalPayload, token);

      if (response && response.success) {
        toast.success(
          isRoundTrip
            ? "Round trip master route created successfully!"
            : "Master route created successfully!",
        );

        setShowAddModal(false);
        resetNewRouteForm();
        await fetchRoutes();
      } else {
        throw new Error(response?.message || "Failed to create master route");
      }
    } catch (err) {
      console.error("Error creating master route:", err);
      if (err.response) {
        const serverError =
          err.response.data?.message || err.response.data?.error || err.message;
        toast.error(serverError);
        console.error("Server error details:", err.response.data);
      } else if (err.request) {
        toast.error(
          "No response from server. Please check your network connection.",
        );
      } else {
        toast.error(
          err.message || "Failed to create master route. Please try again.",
        );
      }
    } finally {
      setIsCreatingRoute(false);
    }
  };

  const resetNewRouteForm = () => {
    setNewRoute({
      masterRouteName: "",
      description: "",
      via: [],
      upOriginCity: "",
      upOriginState: "",
      upOriginAddress: "",
      upOriginTerminal: "",
      upOriginCoords: null,
      upDestCity: "",
      upDestState: "",
      upDestAddress: "",
      upDestTerminal: "",
      upDestCoords: null,
      upTotalDistance: "",
      upDurationHours: "",
      upDurationMinutes: "",
      upManualFirstLeg: "",
      downManualFirstLeg: "",
      upManualFinalLeg: "",
      downManualFinalLeg: "",
      destManualDistFromLastStop: "",
      downTotalDistance: "",
      downDurationHours: "",
      downDurationMinutes: "",
      stopCity: "",
      stopState: "",
      stopAddress: "",
      stopTerminal: "",
      stopCoords: null,
      stopDistFromPrev: "",
      stopDistToNext: "",
      isBoarding: false,
      isDropping: false,
    });
    setViaInput("");
    setUpStops([]);
    setDownStops([]);
    setIsRoundTrip(false);
    setActiveRouteTab("UP");
    setIsDistanceCalculated({ up: false, down: false });
    setActiveTab("basic");
    setSelectedMasterRoute(null);
    setIsOriginManual(false);
    setIsDestinationManual(false);
    setSelectorKey((prev) => prev + 1);
  };

  const handleViewRoute = async (route) => {
    try {
      const routeData = await getMasterRouteById(route.id, token);
      setViewingRoute(routeData.data || routeData);
    } catch (err) {
      setViewingRoute(route.fullData);
      toast.warning(
        "Could not fetch latest route details. Showing cached data.",
      );
    }
  };

  const handleEditRoute = async (route) => {
    try {
      const response = await getMasterRouteById(route.id, token);
      const routeData = response.data || route.fullData;

      console.log("Master route data for edit:", routeData);

      setEditingRoute(routeData);

      const origin = routeData.origin || {};
      const destination = routeData.destination || {};
      const routeDetails = routeData.routeDetails || {};
      const estimatedDuration = routeDetails.estimatedDuration || {};

      const hasOriginCoords =
        origin.coordinates &&
        (origin.coordinates.lat !== 0 || origin.coordinates.lng !== 0);
      const hasDestCoords =
        destination.coordinates &&
        (destination.coordinates.lat !== 0 ||
          destination.coordinates.lng !== 0);

      setIsOriginManual(!hasOriginCoords);
      setIsDestinationManual(!hasDestCoords);

      const viaData = (routeData.via || []).map((v, index) => ({
        city: v.city || "",
        state: v.state || "",
        sequence: v.sequence || index + 1,
      }));

      console.log("Via data loaded:", viaData);

      setNewRoute((prev) => ({
        ...prev,
        masterRouteName: routeData.masterRouteName || "",
        description: routeData.description || "",
        via: viaData,
        upOriginCity: origin.city || "",
        upOriginState: origin.state || "",
        upOriginAddress:
          origin.address || `${origin.city || ""}, ${origin.state || "India"}`,
        upOriginTerminal: origin.terminal || `${origin.city || ""} Terminal`,
        upOriginCoords: origin.coordinates || { lat: 0, lng: 0 },
        upDestCity: destination.city || "",
        upDestState: destination.state || "",
        upDestAddress:
          destination.address ||
          `${destination.city || ""}, ${destination.state || "India"}`,
        upDestTerminal:
          destination.terminal || `${destination.city || ""} Terminal`,
        upDestCoords: destination.coordinates || { lat: 0, lng: 0 },
        upTotalDistance: routeDetails.totalDistance || "",
        upDurationHours: estimatedDuration.hours || "",
        upDurationMinutes: estimatedDuration.minutes || "",
      }));

      let upManualFinalLeg = "";
      const upTotalDist = parseFloat(routeDetails.totalDistance) || 0;

      if (routeData.intermediateStops &&
      routeData.intermediateStops.length > 0) {
        const lastStop =
          routeData.intermediateStops[routeData.intermediateStops.length - 1];
        const lastStopDistance = lastStop.distanceFromOrigin || 0;
        const distanceToDest = upTotalDist - lastStopDistance;
        if (distanceToDest > 0) {
          upManualFinalLeg = distanceToDest.toFixed(1);
        }
      } else if (upTotalDist > 0 && !hasDestCoords) {
        upManualFinalLeg = upTotalDist.toFixed(1);
      }

      const transformedStops = (routeData.intermediateStops || []).map(
        (stop, index, array) => ({
          city: stop.city,
          state: stop.state || "",
          address:
            stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
          terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
          stopType: stop.stopType || "none",
          coordinates: stop.coordinates || { lat: 0, lng: 0 },
          distanceFromOrigin: stop.distanceFromOrigin || 0,
          manualDistFromPrev:
            index === 0
              ? stop.distanceFromOrigin - (origin.distanceFromOrigin || 0)
              : stop.distanceFromOrigin -
                (array[index - 1].distanceFromOrigin || 0),
          manualDistToNext: stop.manualDistToNext || null,
          isManualStop:
            !stop.coordinates ||
            (stop.coordinates.lat === 0 && stop.coordinates.lng === 0),
        }),
      );

      transformedStops.forEach((stop) => {
        if (stop.manualDistFromPrev > 0) {
          stop.manualDistFromPrev = parseFloat(
            stop.manualDistFromPrev.toFixed(1),
          );
        }
      });

      setUpStops(transformedStops);

      const upDistancesCalculated = transformedStops.every(
        (stop) => stop.distanceFromOrigin > 0,
      );
      setIsDistanceCalculated((prev) => ({
        ...prev,
        up: upDistancesCalculated,
      }));

      const editFormData = {
        masterRouteNumber: routeData.masterRouteNumber || "",
        masterRouteName: routeData.masterRouteName || "",
        description: routeData.description || "",
        via: viaData,
        originCity: origin.city || "",
        originState: origin.state || "",
        originAddress:
          origin.address || `${origin.city || ""}, ${origin.state || "India"}`,
        originTerminal: origin.terminal || `${origin.city || ""} Terminal`,
        originCoords: origin.coordinates || { lat: 0, lng: 0 },
        destCity: destination.city || "",
        destState: destination.state || "",
        destAddress:
          destination.address ||
          `${destination.city || ""}, ${destination.state || "India"}`,
        destTerminal:
          destination.terminal || `${destination.city || ""} Terminal`,
        destCoords: destination.coordinates || { lat: 0, lng: 0 },
        totalDistance: routeDetails.totalDistance || "",
        durationHours: estimatedDuration.hours || "",
        durationMinutes: estimatedDuration.minutes || "",
        isActive: routeData.isActive,
        isRoundTrip: routeData.isRoundTrip || false,
        upManualFinalLeg: upManualFinalLeg,
        returnManualFinalLeg: "",
      };

      if (routeData.isRoundTrip && routeData.returnJourney) {
        const returnJourney = routeData.returnJourney;
        const returnOrigin = returnJourney.origin || {};
        const returnDestination = returnJourney.destination || {};
        const returnRouteDetails = returnJourney.routeDetails || {};
        const returnEstimatedDuration =
          returnRouteDetails.estimatedDuration || {};

        let returnManualFinalLeg = "";
        const returnTotalDist =
          parseFloat(returnRouteDetails.totalDistance) || 0;

        const hasReturnDestCoords =
          returnDestination.coordinates &&
          (returnDestination.coordinates.lat !== 0 ||
            returnDestination.coordinates.lng !== 0);

        if (
          returnJourney.intermediateStops &&
          returnJourney.intermediateStops.length > 0
        ) {
          const returnLastStop =
            returnJourney.intermediateStops[
              returnJourney.intermediateStops.length - 1
            ];
          const returnLastStopDistance = returnLastStop.distanceFromOrigin || 0;
          const returnDistanceToDest = returnTotalDist - returnLastStopDistance;
          if (returnDistanceToDest > 0) {
            returnManualFinalLeg = returnDistanceToDest.toFixed(1);
          }
        } else if (returnTotalDist > 0 && !hasReturnDestCoords) {
          returnManualFinalLeg = returnTotalDist.toFixed(1);
        }

        const transformedReturnStops = (
          returnJourney.intermediateStops || []
        ).map((stop, index, array) => ({
          city: stop.city,
          state: stop.state || "",
          address:
            stop.address || `${stop.city || ""}, ${stop.state || "India"}`,
          terminal: stop.terminal || `${stop.city || ""} Bus Stand`,
          stopType: stop.stopType || "none",
          coordinates: stop.coordinates || { lat: 0, lng: 0 },
          distanceFromOrigin: stop.distanceFromOrigin || 0,
          manualDistFromPrev:
            index === 0
              ? stop.distanceFromOrigin - (returnOrigin.distanceFromOrigin || 0)
              : stop.distanceFromOrigin -
                (array[index - 1].distanceFromOrigin || 0),
          manualDistToNext: stop.manualDistToNext || null,
          isManualStop:
            !stop.coordinates ||
            (stop.coordinates.lat === 0 && stop.coordinates.lng === 0),
        }));

        transformedReturnStops.forEach((stop) => {
          if (stop.manualDistFromPrev > 0) {
            stop.manualDistFromPrev = parseFloat(
              stop.manualDistFromPrev.toFixed(1),
            );
          }
        });

        setDownStops(transformedReturnStops);

        const downDistancesCalculated = transformedReturnStops.every(
          (stop) => stop.distanceFromOrigin > 0,
        );
        setIsDistanceCalculated((prev) => ({
          ...prev,
          down: downDistancesCalculated,
        }));

        editFormData.returnOriginCity = returnOrigin.city || "";
        editFormData.returnOriginState = returnOrigin.state || "";
        editFormData.returnOriginAddress =
          returnOrigin.address ||
          `${returnOrigin.city || ""}, ${returnOrigin.state || "India"}`;
        editFormData.returnOriginTerminal =
          returnOrigin.terminal || `${returnOrigin.city || ""} Terminal`;
        editFormData.returnOriginCoords = returnOrigin.coordinates || {
          lat: 0,
          lng: 0,
        };
        editFormData.returnDestCity = returnDestination.city || "";
        editFormData.returnDestState = returnDestination.state || "";
        editFormData.returnDestAddress =
          returnDestination.address ||
          `${returnDestination.city || ""}, ${returnDestination.state || "India"}`;
        editFormData.returnDestTerminal =
          returnDestination.terminal ||
          `${returnDestination.city || ""} Terminal`;
        editFormData.returnDestCoords = returnDestination.coordinates || {
          lat: 0,
          lng: 0,
        };
        editFormData.returnTotalDistance =
          returnRouteDetails.totalDistance || "";
        editFormData.returnDurationHours = returnEstimatedDuration.hours || "";
        editFormData.returnDurationMinutes =
          returnEstimatedDuration.minutes || "";
        editFormData.returnManualFinalLeg = returnManualFinalLeg;

        setIsRoundTrip(true);
      } else {
        setIsRoundTrip(false);
        setDownStops([]);
      }

      setEditForm(editFormData);
      setShowEditModal(true);
    } catch (err) {
      console.error("Error fetching master route for edit:", err);
      toast.error("Failed to load master route for editing");
    }
  };

  if (loading && routes.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  const handleUpdateRoute = async () => {
    setIsUpdatingRoute(true);

    try {
      if (!editForm.originCity || !editForm.destCity) {
        toast.error("Origin and Destination are required");
        setIsUpdatingRoute(false);
        return;
      }

      const originData = {
        city: editForm.originCity,
        state: editForm.originState || "",
        address: editForm.originAddress || `${editForm.originCity}, India`,
        terminal: editForm.originTerminal || `${editForm.originCity} Terminal`,
        coordinates: editForm.originCoords || { lat: 0, lng: 0 },
        distanceFromOrigin: 0,
      };

      const destData = {
        city: editForm.destCity,
        state: editForm.destState || "",
        address: editForm.destAddress || `${editForm.destCity}, India`,
        terminal: editForm.destTerminal || `${editForm.destCity} Terminal`,
        coordinates: editForm.destCoords || { lat: 0, lng: 0 },
        distanceFromOrigin: parseFloat(editForm.totalDistance || 0),
      };

      const cleanStops = (list) =>
        list.map((s, index) => {
          const stopPayload = {
            sequence: index + 1,
            city: s.city,
            state: s.state || "",
            address: s.address || `${s.city}, India`,
            terminal: s.terminal || `${s.city} Terminal`,
            stopType: s.stopType || "none",
            coordinates: s.coordinates || { lat: 0, lng: 0 },
            distanceFromOrigin: parseFloat(s.distanceFromOrigin || 0),
          };

          if (s.manualDistFromPrev)
            stopPayload.manualDistFromPrev = parseFloat(s.manualDistFromPrev);
          if (s.manualDistToNext)
            stopPayload.manualDistToNext = parseFloat(s.manualDistToNext);

          return stopPayload;
        });

      const updatePayload = {
        masterRouteName: editForm.masterRouteName.trim(),
        description: editForm.description || "",
        via: editForm.via || [],
        origin: originData,
        destination: destData,
        intermediateStops: cleanStops(upStops),
        routeDetails: {
          totalDistance: parseFloat(editForm.totalDistance || 0),
          estimatedDuration: {
            hours: parseInt(editForm.durationHours || 0, 10),
            minutes: parseInt(editForm.durationMinutes || 0, 10),
          },
        },
        isActive: editForm.isActive,
        isRoundTrip: editForm.isRoundTrip || false,
      };
      if (editForm.isRoundTrip) {
        if (!editForm.returnOriginCity || !editForm.returnDestCity) {
          toast.error(
            "Return Origin and Destination are required for Round Trip",
          );
          setIsUpdatingRoute(false);
          return;
        }

        const returnOriginData = {
          city: editForm.returnOriginCity,
          state: editForm.returnOriginState || "",
          address:
            editForm.returnOriginAddress ||
            `${editForm.returnOriginCity}, India`,
          terminal:
            editForm.returnOriginTerminal ||
            `${editForm.returnOriginCity} Terminal`,
          coordinates: editForm.returnOriginCoords || { lat: 0, lng: 0 },
          distanceFromOrigin: 0,
        };

        const returnDestData = {
          city: editForm.returnDestCity,
          state: editForm.returnDestState || "",
          address:
            editForm.returnDestAddress || `${editForm.returnDestCity}, India`,
          terminal:
            editForm.returnDestTerminal ||
            `${editForm.returnDestCity} Terminal`,
          coordinates: editForm.returnDestCoords || { lat: 0, lng: 0 },
          distanceFromOrigin: parseFloat(
            editForm.returnTotalDistance || editForm.totalDistance || 0,
          ),
        };

        updatePayload.returnJourney = {
          origin: returnOriginData,
          destination: returnDestData,
          intermediateStops: cleanStops(downStops),
          routeDetails: {
            totalDistance: parseFloat(
              editForm.returnTotalDistance || editForm.totalDistance || 0,
            ),
            estimatedDuration: {
              hours: parseInt(
                editForm.returnDurationHours || editForm.durationHours || 0,
                10,
              ),
              minutes: parseInt(
                editForm.returnDurationMinutes || editForm.durationMinutes || 0,
                10,
              ),
            },
          },
        };
      }

      console.log("Update Payload:", JSON.stringify(updatePayload, null, 2));

      const response = await updateMasterRoute(
        editingRoute._id,
        updatePayload,
        token,
      );

      if (response.success) {
        toast.success(
          editForm.isRoundTrip
            ? "Master route updated to Round Trip successfully!"
            : "Master route updated successfully!",
        );
        setShowEditModal(false);
        setEditingRoute(null);
        setEditForm({});
        setUpStops([]);
        setDownStops([]);
        fetchRoutes();
      } else {
        throw new Error(response.message || "Failed to update master route");
      }
    } catch (err) {
      console.error("Error updating master route:", err);
      toast.error(err.message || "Failed to update master route");
    } finally {
      setIsUpdatingRoute(false);
    }
  };

  const handleEditOriginSelect = (location) => {
    setEditForm((prev) => ({
      ...prev,
      originCity: location.city || location.name || "",
      originState: location.state || "",
      originAddress: location.address || "",
      originCoords: location.coordinates || { lat: 0, lng: 0 },
    }));
  };

  const handleEditDestSelect = (location) => {
    setEditForm((prev) => ({
      ...prev,
      destCity: location.city || location.name || "",
      destState: location.state || "",
      destAddress: location.address || "",
      destCoords: location.coordinates || { lat: 0, lng: 0 },
    }));
  };

  const handleToggleStatus = async (routeId, currentStatus) => {
    const newStatus = !currentStatus;
    const action = newStatus ? "activate" : "deactivate";

    if (
      window.confirm(`Are you sure you want to ${action} this master route?`)
    ) {
      try {
        const response = await toggleMasterRouteStatus(
          routeId,
          newStatus,
          token,
        );

        if (response.success) {
          setRoutes((prevRoutes) =>
            prevRoutes.map((route) =>
              route.id === routeId
                ? {
                    ...route,
                    isActive: newStatus,
                    status: newStatus ? "Active" : "Inactive",
                  }
                : route,
            ),
          );
          toast.success(`Master route ${action}d successfully!`);
        } else {
          throw new Error(
            response.message || `Failed to ${action} master route`,
          );
        }
      } catch (err) {
        console.error(`Error ${action}ing master route:`, err);
        toast.error(`Failed to ${action} master route`);
      }
    }
  };

  const handleDeleteRoute = async (routeId) => {
    if (
      window.confirm(
        "Are you sure you want to delete this master route? This action cannot be undone.",
      )
    ) {
      try {
        const response = await deleteMasterRoute(routeId, token);

        if (response.success) {
          setRoutes((prevRoutes) =>
            prevRoutes.filter((route) => route.id !== routeId),
          );
          setTotalRoutes((prev) => prev - 1);
          toast.success("Master route deleted successfully!");
        } else {
          throw new Error(response.message || "Failed to delete master route");
        }
      } catch (err) {
        console.error("Error deleting master route:", err);
        toast.error("Failed to delete master route");
      }
    }
  };

  const renderInsertButton = (idx, type = "up") => {
    const isOpen = inlineInsertIndex === idx;
    const stops = getActiveStops();

    return (
      <div
        key={`insert-wrap-${idx}`}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >

        <div
          style={{
            width: 2,
            height: 16,
            background: "var(--color-border-tertiary, rgba(0,0,0,.12))",
            flexShrink: 0,
          }}
        />


        <button
          onClick={() => {
            if (isOpen) {
              setInlineInsertIndex(null);
              setInlineInsertCitySuggestions([]);
              setShowInlineInsertDropdown(false);
            } else {
              let defaultState = "";
              const currentStops = type === "up" ? upStops : downStops;
              if (idx > 0 && currentStops[idx - 1]?.state)
                defaultState = currentStops[idx - 1].state;
              else if (newRoute.upOriginState)
                defaultState = newRoute.upOriginState;

              setInlineInsertForm({
                city: "",
                state: defaultState,
                address: "",
                terminal: "",
                stopType: "none",
                distFromPrev: "",
                distToNext: "",
                isManual: true,
              });
              setInlineInsertCitySuggestions([]);
              setShowInlineInsertDropdown(false);
              setInlineInsertIndex(idx);
            }
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "5px 14px",
            borderRadius: 999,
            border: `1.5px ${isOpen ? "solid" : "dashed"} ${isOpen ? "#378add" : "rgba(0,0,0,.25)"}`,
            background: isOpen
              ? "#e6f1fb"
              : "var(--color-background-primary, #fff)",
            fontSize: 12,
            fontWeight: 500,
            color: isOpen ? "#185fa5" : "var(--color-text-secondary, #666)",
            cursor: "pointer",
            whiteSpace: "nowrap",
            transition: "all .15s",
          }}
        >
          <span style={{ fontSize: 15 }}>{isOpen ? "✕" : "+"}</span>
          {isOpen ? "Cancel insert" : "Insert stop here"}
        </button>


        <div
          style={{
            width: 2,
            height: isOpen ? 0 : 16,
            background: "var(--color-border-tertiary, rgba(0,0,0,.12))",
            flexShrink: 0,
          }}
        />


        {isOpen && renderInlineInsertPanel(idx)}
      </div>
    );
  };
  const activeRoutes = routes.filter((r) => r.isActive).length;
  const totalDistance = routes.reduce(
    (sum, route) => sum + (parseInt(route.distance) || 0),
    0,
  );
  const totalStops = routes.reduce(
    (sum, route) => sum + (parseInt(route.stops) || 0),
    0,
  );

  if (loading && routes.length === 0) {
    return (
      <div className="management-page">
        <div className="loading-container">
          <p>Loading master routes...</p>
        </div>
      </div>
    );
  }

    return (
        <div className="prm-page">
            {/* ============================== HERO ============================== */}
            <div className="prm-hero">
                <div className="prm-hero-road" aria-hidden="true">
                    <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
                </div>
                <div className="prm-hero-text">
                    <span className="prm-eyebrow"><Icon name="route" size={13} /> Master Routes</span>
                    <h1>Master Route Management</h1>
                    <p>Define, edit and manage the master route templates used across all buses.</p>
                </div>
                <div className="prm-hero-actions">
                    <div className="prm-search">
                        <Icon name="search" size={17} />
                        <input
                            type="text"
                            placeholder="Search master routes by name, origin or destination…"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && <button className="prm-search-clear" onClick={() => setSearchTerm('')}>×</button>}
                    </div>
                    <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={fetchRoutes} title="Refresh">
                        <Icon name="refresh" size={16} />
                    </button>
                    <button className="prm-add-btn" onClick={() => { setSelectorKey((prev) => prev + 1); setShowAddModal(true); }}>
                        <span className="plus"><Icon name="plus" size={14} /></span> Add Master Route
                    </button>
                </div>
            </div>

            {/* ============================== STATS ============================== */}
            <div className="prm-stats">
                <StatCard icon="route" tone="indigo" label="Total Routes" value={totalRoutes} hint="All registered master routes" delay={80} />
                <StatCard icon="check" tone="green" label="Active Routes" value={activeRoutes} hint="Currently active" delay={160} />
                <StatCard icon="bus" tone="amber" label="Total Stops" value={totalStops} hint="Across all routes" delay={240} />
                <StatCard icon="pin" tone="cyan" label="Total Distance" value={totalDistance} hint="km covered" delay={320} />
            </div>

            {/* ============================== TOOLBAR ============================== */}
            <div className="prm-toolbar">
                <div className="prm-toolbar-left">
                    <span className="prm-tag navy"><Icon name="route" size={12} /> Master Route Templates</span>
                </div>
                <div className="prm-toolbar-right">
                    <span className="prm-result-count">Showing <b>{routes.length}</b> of {totalRoutes}</span>
                </div>
            </div>

            {/* ============================== TABLE ============================== */}
            {routes.length === 0 ? (
                <div className="prm-empty">
                    <div className="icon"><Icon name={searchTerm ? 'search' : 'route'} size={44} /></div>
                    <h3>{searchTerm ? 'No master routes match your search' : 'No master routes yet'}</h3>
                    <p>{searchTerm ? 'Try a different search term.' : 'Create your first master route template.'}</p>
                    {searchTerm && <button className="prm-btn ghost" onClick={() => setSearchTerm('')}>Clear search</button>}
                </div>
            ) : (
                <div className="prm-table-wrap">
                    <table className="prm-table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Route Name</th>
                                <th>Origin → Destination</th>
                                <th>Distance</th>
                                <th>Stops</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {routes.map((route, i) => (
                                <tr key={route.id} style={{ animationDelay: `${i * 60}ms` }}>
                                    <td><b style={{ color: 'var(--muted)' }}>{route.serialNo}</b></td>
                                    <td>
                                        <div className="name">{route.masterRouteName}</div>
                                        {route.description && <div className="sub">{route.description}</div>}
                                    </td>
                                    <td>
                                        <div className="name">{route.originCity}</div>
                                        <div className="sub">{route.originTerminal || 'N/A'} → {route.destinationCity}</div>
                                        {route?.via?.length > 0 && (
                                            <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 4 }}>
                                                Via: {route.via.map((v) => v.city).join(', ')}
                                            </div>
                                        )}
                                    </td>
                                    <td><b>{route.distance} km</b></td>
                                    <td>{route.stops}</td>
                                    <td>
                                        <span className="prm-tag" style={{
                                            background: route.isRoundTrip ? 'var(--amber-soft)' : 'var(--blue-soft)',
                                            color: route.isRoundTrip ? 'var(--amber-deep)' : 'var(--navy-800)'
                                        }}>
                                            {route.isRoundTrip ? '🔄 Round Trip' : '➡️ One Way'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`prm-status ${route.isActive ? 'active' : 'inactive'}`}>
                                            {route.status}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="prm-row-actions">
                                            <button className="prm-btn view icon-only" onClick={() => handleViewRoute(route)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                                            <button className="prm-btn ghost icon-only" onClick={() => handleEditRoute(route)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                                            <button className={`prm-btn ${route.isActive ? 'ghost' : 'primary'} icon-only`} onClick={() => handleToggleStatus(route.id, route.isActive)} title={route.isActive ? 'Deactivate' : 'Activate'}><Icon name={route.isActive ? 'x' : 'check'} size={14} /></button>
                                            <button className="prm-btn danger icon-only" onClick={() => handleDeleteRoute(route.id)} title="Delete" aria-label="Delete"><Icon name="trash" size={14} /></button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ============================== PAGINATION ============================== */}
            {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 22 }}>
                    <button className="prm-btn ghost" onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={currentPage === 1}>Previous</button>
                    <span style={{ padding: '11px 16px', fontWeight: 700, color: 'var(--navy-800)' }}>Page {currentPage} of {totalPages}</span>
                    <button className="prm-btn ghost" onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>Next</button>
                </div>
            )}

            {/* ============================================================
             * ADD MODAL — Modern redesign
             * ============================================================ */}
            {showAddModal && (
                <div className="prm-overlay" onClick={() => setShowAddModal(false)}>
                    <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="bus" size={24} /></span>
                                <div>
                                    <h3>Create New Master Route</h3>
                                    <p>{isRoundTrip ? 'Round trip template' : 'One-way template'}</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowAddModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            <div className="prm-callout amber">
                                <Icon name="info" size={18} />
                                <div style={{ flex: 1 }}>
                                    <strong>Round Trip Route</strong>
                                    <span>Enable to include both UP (Main) and DOWN (Return) journeys.</span>
                                </div>
                                <Switch checked={isRoundTrip} onChange={toggleRoundTrip} />
                            </div>

                            {isRoundTrip && (
                                <div className="prm-segment" style={{ gridTemplateColumns: '1fr 1fr' }}>
                                    <span className="prm-segment-pill" style={{ transform: `translateX(${activeRouteTab === 'UP' ? 0 : 100}%)` }} />
                                    <button className={activeRouteTab === 'UP' ? 'active' : ''} onClick={() => handleTabSwitch('UP')}>
                                        <Icon name="map" size={15} /> UP (Main) Route
                                    </button>
                                    <button className={activeRouteTab === 'DOWN' ? 'active' : ''} onClick={() => handleTabSwitch('DOWN')}>
                                        <Icon name="map" size={15} /> DOWN (Return) Route
                                    </button>
                                </div>
                            )}

                            {/* 1 — Route Identity */}
                            <FormSection n="1" title="Route Identity" hint="Name this master route template." delay={40}>
                                <div className="prm-fgrid">
                                    <Field label="Select Master Route Name" full>
                                        <MasterRouteSelector
                                            key={selectorKey}
                                            token={token}
                                            value={selectedMasterRoute}
                                            onChange={(masterRoute) => {
                                                if (masterRoute) autoFillFromMasterRoute(masterRoute);
                                                else { setSelectedMasterRoute(null); resetNewRouteForm(); setSelectorKey((prev) => prev + 1); }
                                            }}
                                            onRouteNameChange={(routeName) => {
                                                setNewRoute((prev) => ({ ...prev, masterRouteName: routeName }));
                                                if (selectedMasterRoute) setSelectedMasterRoute({ ...selectedMasterRoute, masterRouteName: routeName });
                                            }}
                                        />
                                    </Field>
                                    <Field label="Description" full>
                                        <textarea
                                            value={newRoute.description}
                                            onChange={(e) => setNewRoute((prev) => ({ ...prev, description: e.target.value }))}
                                            placeholder="Route description (optional)"
                                            className="prm-input"
                                            rows="3"
                                        />
                                    </Field>
                                </div>
                            </FormSection>

                            {/* 2 — Via Cities */}
                            <FormSection n="2" title="Via Cities" hint="Add cities the route passes through (optional)." delay={80}>
                                {newRoute.via.length > 0 && (
                                    <div style={{ marginBottom: 12 }}>
                                        {newRoute.via.map((viaCity, index) => (
                                            <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                                                <span className="prm-tag navy" style={{ minWidth: 30 }}>#{index + 1}</span>
                                                <input type="text" value={viaCity.city} onChange={(e) => updateViaCity(index, 'city', e.target.value)} placeholder="City name" className="prm-input" style={{ flex: 2 }} />
                                                <input type="text" value={viaCity.state} onChange={(e) => updateViaCity(index, 'state', e.target.value)} placeholder="State (optional)" className="prm-input" style={{ flex: 2 }} />
                                                <button type="button" className="prm-btn danger sm" onClick={() => removeViaCity(index)}>
                                                    <Icon name="trash" size={13} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <input
                                        type="text"
                                        value={viaInput}
                                        onChange={(e) => setViaInput(e.target.value)}
                                        onKeyPress={(e) => { if (e.key === 'Enter') addViaCity(); }}
                                        placeholder="Enter via city name…"
                                        className="prm-input"
                                        style={{ flex: 3 }}
                                    />
                                    <button type="button" className="prm-btn teal" onClick={addViaCity}>
                                        <Icon name="plus" size={14} /> Add Via City
                                    </button>
                                </div>
                            </FormSection>

                            {/* 3 — Origin */}
                            <FormSection n="3" title={activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'} hint={activeRouteTab === 'UP' ? 'Main origin details.' : 'Return origin (auto-filled).'} delay={120}>
                                {activeRouteTab === 'UP' ? (
                                    <div className="prm-fgrid">
                                        <Field label="Search City" required full>
                                            <CitySearchInput
                                                token={token}
                                                value={newRoute.upOriginCity}
                                                onChange={(val) => setNewRoute((prev) => ({ ...prev, upOriginCity: val }))}
                                                onCitySelect={handleOriginCitySelect}
                                                placeholder="Type origin city (min 2 chars)…"
                                                searchType="origin"
                                            />
                                        </Field>
                                        <Field label="Address" full>
                                            <input type="text" value={newRoute.upOriginAddress} onChange={(e) => setNewRoute((prev) => ({ ...prev, upOriginAddress: e.target.value }))} className="prm-input" placeholder="Auto-filled on city selection" />
                                        </Field>
                                        <Field label="State">
                                            <input type="text" value={newRoute.upOriginState} onChange={(e) => setNewRoute((prev) => ({ ...prev, upOriginState: toProperCase(e.target.value) }))} className="prm-input" />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.upOriginTerminal} onChange={(e) => setNewRoute((prev) => ({ ...prev, upOriginTerminal: e.target.value }))} className="prm-input" />
                                        </Field>
                                        {upStops.length > 0 && checkOriginManual() !== isFirstStopManual() && (
                                            <Field label="Distance from Origin to First Stop (km)" required full>
                                                <input type="number" value={newRoute.upManualFirstLeg} onChange={(e) => setNewRoute((prev) => ({ ...prev, upManualFirstLeg: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        )}
                                    </div>
                                ) : (
                                    <Field label="Return Origin" full>
                                        <input type="text" value={newRoute.upDestCity || 'Auto-filled from Main Destination'} className="prm-input" disabled />
                                    </Field>
                                )}
                            </FormSection>

                            {/* 4 — Destination */}
                            <FormSection n="4" title={activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'} hint={activeRouteTab === 'UP' ? 'Main destination details.' : 'Return destination (auto-filled).'} delay={160}>
                                {activeRouteTab === 'UP' ? (
                                    <div className="prm-fgrid">
                                        <Field label="Search City" required full>
                                            <CitySearchInput
                                                token={token}
                                                value={newRoute.upDestCity}
                                                onChange={(val) => setNewRoute((prev) => ({ ...prev, upDestCity: val }))}
                                                onCitySelect={handleDestCitySelect}
                                                placeholder="Type destination city (min 2 chars)…"
                                                searchType="destination"
                                            />
                                        </Field>
                                        <Field label="Address" full>
                                            <input type="text" value={newRoute.upDestAddress} onChange={(e) => setNewRoute((prev) => ({ ...prev, upDestAddress: e.target.value }))} className="prm-input" placeholder="Auto-filled on city selection" />
                                        </Field>
                                        <Field label="State">
                                            <input type="text" value={newRoute.upDestState} onChange={(e) => setNewRoute((prev) => ({ ...prev, upDestState: toProperCase(e.target.value) }))} className="prm-input" />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.upDestTerminal} onChange={(e) => setNewRoute((prev) => ({ ...prev, upDestTerminal: e.target.value }))} className="prm-input" />
                                        </Field>
                                        {upStops.length > 0 && checkDestinationManual() && (
                                            <Field label="Distance from Last Stop to Destination (km)" required full>
                                                <input type="number" value={newRoute.upManualFinalLeg} onChange={(e) => syncDestinationDistance(e.target.value, 'upManualFinalLeg')} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        )}
                                        {upStops.length > 0 && !checkDestinationManual() && isLastStopManual() && (
                                            <Field label="Distance from Last Stop to Destination (km)" required full>
                                                <input type="number" value={newRoute.destManualDistFromLastStop} onChange={(e) => syncDestinationDistance(e.target.value, 'destManualDistFromLastStop')} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        )}
                                    </div>
                                ) : (
                                    <Field label="Return Destination" full>
                                        <input type="text" value={newRoute.upOriginCity || 'Auto-filled from Main Origin'} className="prm-input" disabled />
                                    </Field>
                                )}
                            </FormSection>

                            {/* 5 — Stops */}
                            <FormSection n="5" title={`Intermediate Stops (${activeRouteTab})`} hint="Add boarding / dropping points between origin and destination." delay={200}>
                                {activeRouteTab === 'DOWN' && (
                                    <button className="prm-btn teal" style={{ marginBottom: 12 }} onClick={() => syncDownStopsWithUpStops(true)}>
                                        <Icon name="refresh" size={15} /> Auto-Fill / Sync Reversed Stops from UP Route
                                    </button>
                                )}

                                <div className="prm-stop-list">
                                    {getActiveStops().map((stop, index) => (
                                        <React.Fragment key={index}>
                                            <div className="prm-stop-item">
                                                <div className="prm-stop-num">{index + 1}</div>
                                                <div className="prm-stop-info">
                                                    <div className="prm-stop-name">
                                                        {stop.city}
                                                        <span className="prm-tag navy">{formatDistance(stop.distanceFromOrigin)} km</span>
                                                    </div>
                                                    <div className="prm-stop-times">📍 {stop.address || `${stop.city}, ${stop.state || 'India'}`}</div>
                                                    <div className="prm-stop-times">
                                                        {stop.state && <>State: {stop.state} <i>•</i> </>}
                                                        {stop.terminal && <>Terminal: {stop.terminal}</>}
                                                    </div>
                                                    {stop.manualDistToNext && (
                                                        <div className="prm-stop-times" style={{ color: 'var(--rose)' }}>→ Next: {stop.manualDistToNext} km</div>
                                                    )}
                                                </div>
                                                <div className="prm-stop-actions">
                                                    <button className="prm-btn ghost sm" onClick={() => handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down')}>
                                                        <Icon name="edit" size={14} /> Edit
                                                    </button>
                                                    <button className="prm-btn danger sm" onClick={() => handleDeleteStop(index)}>
                                                        <Icon name="trash" size={14} />
                                                    </button>
                                                </div>
                                            </div>
                                            {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
                                        </React.Fragment>
                                    ))}
                                </div>

                                <div style={{ marginTop: 12, padding: 12, borderTop: '1px dashed var(--line)' }}>
                                    <PrmCheckbox
                                        label="Manually Typed Stop (No Map Suggestions)"
                                        checked={isManualStop}
                                        onChange={() => {
                                            setIsManualStop(!isManualStop);
                                            setNewRoute((prev) => ({ ...prev, stopCity: '', stopCoords: null, stopDistFromPrev: '', stopDistToNext: '', stopAddress: '', stopState: '', stopTerminal: '' }));
                                            setCitySuggestions([]);
                                            setShowCityDropdown(false);
                                        }}
                                    />

                                    <div className="prm-fgrid" style={{ marginTop: 14 }}>
                                        <Field label={isManualStop ? 'Search City' : 'Search Location'} required full>
                                            {!isManualStop ? (
                                                <LocationInput value={newRoute.stopCity} onChange={(value) => setNewRoute((prev) => ({ ...prev, stopCity: value }))} onLocationSelect={handleSelectStop} placeholder="Search stop city or address…" />
                                            ) : (
                                                <CitySearchDropdown
                                                    value={newRoute.stopCity}
                                                    onChange={(v) => setNewRoute((prev) => ({ ...prev, stopCity: v }))}
                                                    onSelect={(city) => {
                                                        setNewRoute((prev) => ({ ...prev, stopCity: city.name, stopAddress: city.address || city.name, stopState: city.state || '', stopTerminal: city.terminal || `${city.name} Bus Stand`, stopCoords: city.coordinates || null }));
                                                        toast.success(`Auto-filled ${city.name}`);
                                                    }}
                                                    token={token}
                                                    activeRouteTab={activeRouteTab}
                                                />
                                            )}
                                        </Field>
                                        <Field label="Address" full>
                                            <input type="text" value={newRoute.stopAddress} onChange={(e) => setNewRoute((prev) => ({ ...prev, stopAddress: e.target.value }))} className="prm-input" placeholder="Full address" />
                                        </Field>
                                        <Field label="State">
                                            <input type="text" value={newRoute.stopState} onChange={(e) => setNewRoute((prev) => ({ ...prev, stopState: toProperCase(e.target.value) }))} className="prm-input" />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.stopTerminal} onChange={(e) => setNewRoute((prev) => ({ ...prev, stopTerminal: e.target.value }))} className="prm-input" />
                                        </Field>
                                        {(isManualStop || !newRoute.stopCoords || (newRoute.stopCoords?.lat === 0 && newRoute.stopCoords?.lng === 0)) && (
                                            <Field label="Distance from Previous Stop (km)" required>
                                                <input type="number" value={newRoute.stopDistFromPrev} onChange={(e) => setNewRoute((prev) => ({ ...prev, stopDistFromPrev: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        )}
                                        {isManualStop && (() => {
                                            const stops = getActiveStops();
                                            const currentIndex = editingStopIndex !== null ? editingStopIndex : insertIndex !== null ? insertIndex : stops.length;
                                            const nextStop = stops[currentIndex];
                                            const isNextAuto = nextStop && nextStop.coordinates && (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
                                            if (isNextAuto) return (
                                                <Field label={`Distance to Next Stop (${nextStop.city}) (km)`} required>
                                                    <input type="number" value={newRoute.stopDistToNext} onChange={(e) => setNewRoute((prev) => ({ ...prev, stopDistToNext: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                                </Field>
                                            );
                                            return null;
                                        })()}
                                    </div>

                                    <button
                                        className="prm-btn teal"
                                        style={{ marginTop: 12 }}
                                        onClick={() => addIntermediateStop(activeRouteTab === 'UP' ? 'up' : 'down')}
                                        disabled={!newRoute.stopCity || ((isManualStop || !newRoute.stopCoords) && (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0))}
                                    >
                                        <Icon name={editingStopIndex !== null ? 'check' : 'plus'} size={14} />
                                        {editingStopIndex !== null ? 'Save Changes' : insertIndex !== null ? 'Confirm Insertion' : 'Add Stop'}
                                    </button>
                                </div>
                            </FormSection>

                            {/* 6 — Summary */}
                            <FormSection n="6" title={`${activeRouteTab} Summary`} hint="Calculate distances and set total duration." delay={240}>
                                <div className="prm-summary">
                                    <button className="prm-btn teal" onClick={handleCalculateDistances} disabled={isCalculatingDistances}>
                                        <Icon name="calc" size={16} />
                                        {isCalculatingDistances ? 'Calculating…' : 'Auto-Calculate Distances'}
                                    </button>
                                    <span className={`prm-tag ${isDistanceCalculated.up ? 'teal' : 'amber'}`}>
                                        {isDistanceCalculated.up ? '✓ UP calculated' : 'UP not calculated'}
                                    </span>
                                    {isRoundTrip && (
                                        <span className={`prm-tag ${isDistanceCalculated.down ? 'teal' : 'amber'}`}>
                                            {isDistanceCalculated.down ? '✓ DOWN calculated' : 'DOWN not calculated'}
                                        </span>
                                    )}
                                </div>

                                {isLastStopManual() && (
                                    <div className="prm-callout rose" style={{ marginBottom: 12, background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
                                        <Icon name="info" size={18} />
                                        <div>
                                            <strong>Last stop is manual</strong>
                                            <span>Please provide distance from last stop to destination.</span>
                                        </div>
                                    </div>
                                )}

                                <div className="prm-fgrid">
                                    <Field label="Distance from Last Stop to Destination (km)" full>
                                        <input
                                            type="number"
                                            value={activeRouteTab === 'UP' ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (activeRouteTab === 'UP') syncDestinationDistance(value, 'upManualFinalLeg');
                                                else setNewRoute((prev) => ({ ...prev, downManualFinalLeg: value }));
                                            }}
                                            className="prm-input" min="0" step="0.1"
                                        />
                                    </Field>
                                     <Field label="Total Distance (km)">
        <input type="number"
            value={activeRouteTab === 'UP' ? editForm.totalDistance : editForm.returnTotalDistance}
            onChange={(e) => {
                if (activeRouteTab === 'UP') setEditForm((prev) => ({ ...prev, totalDistance: e.target.value }));
                else setEditForm((prev) => ({ ...prev, returnTotalDistance: e.target.value }));
            }}
            className="prm-input" min="0" step="0.1" />
    </Field>
                                    <Field label="Estimated Duration">
                                        <div className="prm-dur">
                                            <input type="number" value={activeRouteTab === 'UP' ? newRoute.upDurationHours : newRoute.downDurationHours}
                                                onChange={(e) => setNewRoute((prev) => ({ ...prev, [activeRouteTab === 'UP' ? 'upDurationHours' : 'downDurationHours']: e.target.value }))}
                                                className="prm-input" placeholder="0" min="0" />
                                            <span>h</span>
                                            <input type="number" value={activeRouteTab === 'UP' ? newRoute.upDurationMinutes : newRoute.downDurationMinutes}
                                                onChange={(e) => setNewRoute((prev) => ({ ...prev, [activeRouteTab === 'UP' ? 'upDurationMinutes' : 'downDurationMinutes']: e.target.value }))}
                                                className="prm-input" placeholder="0" min="0" max="59" />
                                            <span>m</span>
                                        </div>
                                    </Field>
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <button
                                className="prm-btn ghost"
                                onClick={() => {
                                    if (window.confirm('Clear all form data?')) {
                                        resetNewRouteForm();
                                        setSelectedMasterRoute(null);
                                        setSelectorKey((prev) => prev + 1);
                                        toast.info('Form cleared');
                                    }
                                }}
                            >
                                Clear All
                            </button>
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowAddModal(false)}>Cancel</button>
                                <button className="prm-btn primary" onClick={handleSaveRoute}
                                    disabled={isCreatingRoute || !isDistanceCalculated.up || (isRoundTrip && !isDistanceCalculated.down)}>
                                    {isCreatingRoute ? 'Creating…' : <><Icon name="check" size={16} /> Add Master Route</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
             * VIEW MODAL — Modern redesign
             * ============================================================ */}
            {viewingRoute && (
                <div className="prm-overlay" onClick={() => setViewingRoute(null)}>
                    <div className="prm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 900 }}>
                        <div className="prm-modal-head">
                            <h3>{viewingRoute.masterRouteName}</h3>
                            <p><Icon name="tag" size={14} /> {viewingRoute.isRoundTrip ? 'Round Trip' : 'One Way'} · {viewingRoute.routeDetails?.totalDistance || 0} km</p>
                            <button className="prm-modal-close" onClick={() => setViewingRoute(null)}>×</button>
                        </div>

                        <div className="prm-modal-body">
                            <div className="prm-info-grid">
                                <div className="prm-info"><div className="l">Distance</div><div className="v"><Icon name="pin" size={17} /> {viewingRoute.routeDetails?.totalDistance || 0} km</div></div>
                                <div className="prm-info"><div className="l">Duration</div><div className="v"><Icon name="clock" size={17} /> {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</div></div>
                                <div className="prm-info"><div className="l">Stops</div><div className="v"><Icon name="stop" size={17} /> {viewingRoute.intermediateStops?.length || 0}</div></div>
                                <div className="prm-info"><div className="l">Status</div><div className="v"><span className={`prm-status ${viewingRoute.isActive ? 'active' : 'inactive'}`}>{viewingRoute.isActive ? 'Active' : 'Inactive'}</span></div></div>
                            </div>

                            {viewingRoute.description && (
                                <>
                                    <div className="prm-section-title">Description</div>
                                    <div className="prm-info" style={{ marginBottom: 22 }}><div className="v" style={{ fontWeight: 500 }}>{viewingRoute.description}</div></div>
                                </>
                            )}

                            {viewingRoute?.via?.length > 0 && (
                                <>
                                    <div className="prm-section-title">Via Cities</div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 22 }}>
                                        {viewingRoute.via.map((v, i) => <span key={i} className="prm-tag navy">{v.city}{v.state ? `, ${v.state}` : ''}</span>)}
                                    </div>
                                </>
                            )}

                            <div className="prm-section-title">Journey Timeline</div>
                            <div className="prm-timeline">
                                <div className="prm-tl-item origin">
                                    <div className="prm-tl-city">{viewingRoute.origin?.city}<small>{viewingRoute.origin?.terminal}</small></div>
                                    <div className="prm-tl-time">{viewingRoute.origin?.state} · {viewingRoute.origin?.address}</div>
                                </div>
                                {viewingRoute.intermediateStops?.map((stop, i) => (
                                    <div key={i} className="prm-tl-item stop" style={{ animationDelay: `${(i + 1) * 80}ms` }}>
                                        <div className="prm-tl-city">{stop.sequence}. {stop.city}<small>{stop.distanceFromOrigin} km from origin</small></div>
                                        <div className="prm-tl-time">{stop.state} · {stop.terminal}</div>
                                    </div>
                                ))}
                                <div className="prm-tl-item dest" style={{ animationDelay: `${((viewingRoute.intermediateStops?.length || 0) + 1) * 80}ms` }}>
                                    <div className="prm-tl-city">{viewingRoute.destination?.city}<small>{viewingRoute.destination?.terminal}</small></div>
                                    <div className="prm-tl-time">{viewingRoute.destination?.state} · {viewingRoute.destination?.address}</div>
                                </div>
                            </div>

                            {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
                                <>
                                    <div className="prm-section-title" style={{ marginTop: 24 }}>🔄 Return Journey</div>
                                    <div className="prm-info-grid" style={{ marginBottom: 20 }}>
                                        <div className="prm-info"><div className="l">Return From</div><div className="v">{viewingRoute.returnJourney.origin?.city}</div></div>
                                        <div className="prm-info"><div className="l">Return To</div><div className="v">{viewingRoute.returnJourney.destination?.city}</div></div>
                                        <div className="prm-info"><div className="l">Distance</div><div className="v">{viewingRoute.returnJourney.routeDetails?.totalDistance || 0} km</div></div>
                                        <div className="prm-info"><div className="l">Duration</div><div className="v">{viewingRoute.returnJourney.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.returnJourney.routeDetails?.estimatedDuration?.minutes || 0}m</div></div>
                                    </div>

                                    {viewingRoute.returnJourney.intermediateStops?.length > 0 && (
                                        <>
                                            <div className="prm-section-title">Return Stops ({viewingRoute.returnJourney.intermediateStops.length})</div>
                                            <div className="prm-table-wrap" style={{ marginBottom: 20 }}>
                                                <table className="prm-table">
                                                    <thead><tr><th>#</th><th>City</th><th>Distance</th><th>Type</th></tr></thead>
                                                    <tbody>
                                                        {viewingRoute.returnJourney.intermediateStops.map((s, i) => (
                                                            <tr key={i}>
                                                                <td>{s.sequence}</td>
                                                                <td><b>{s.city}</b></td>
                                                                <td>{s.distanceFromOrigin || 0} km</td>
                                                                <td><span className="prm-tag navy">{s.stopType || 'none'}</span></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}

                            <div className="prm-section-title">Status</div>
                            <div className="prm-info-grid">
                                <div className="prm-info"><div className="l">Created By</div><div className="v">{viewingRoute.creatorName || 'Admin'}</div></div>
                                <div className="prm-info"><div className="l">Created At</div><div className="v">{new Date(viewingRoute.createdAt).toLocaleDateString()}</div></div>
                                <div className="prm-info"><div className="l">Updated At</div><div className="v">{new Date(viewingRoute.updatedAt).toLocaleDateString()}</div></div>
                            </div>
                        </div>

                        <div className="prm-modal-foot">
                            <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={() => setViewingRoute(null)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
             * EDIT MODAL — Modern redesign
             * ============================================================ */}
            {showEditModal && editingRoute && (
                <div className="prm-overlay" onClick={() => setShowEditModal(false)}>
                    <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="edit" size={24} /></span>
                                <div>
                                    <h3>Edit Master Route</h3>
                                    <p>{editingRoute.masterRouteName}</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowEditModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            <div className="prm-callout amber">
                                <Icon name="info" size={18} />
                                <div style={{ flex: 1 }}>
                                    <strong>Round Trip Route</strong>
                                    <span>Enable to include both UP (Main) and DOWN (Return) journeys.</span>
                                </div>
                                <Switch
                                    checked={editForm.isRoundTrip}
                                    onChange={() => {
                                        const newIsRoundTrip = !editForm.isRoundTrip;
                                        if (newIsRoundTrip && !editForm.isRoundTrip) {
                                            const upPointsWithDistances = [
                                                { city: editForm.originCity, distanceFromOrigin: 0, coordinates: editForm.originCoords, isManualStop: false },
                                                ...upStops.map((stop, idx) => {
                                                    const prevDistance = idx === 0 ? 0 : upStops[idx - 1]?.distanceFromOrigin || 0;
                                                    return { ...stop, distanceFromPrev: stop.distanceFromOrigin - prevDistance };
                                                }),
                                                { city: editForm.destCity, distanceFromOrigin: parseFloat(editForm.totalDistance) || 0, coordinates: editForm.destCoords, isManualStop: false, distanceFromPrev: parseFloat(editForm.totalDistance) - (upStops[upStops.length - 1]?.distanceFromOrigin || 0) }
                                            ];
                                            const returnOriginData = { city: editForm.destCity, state: editForm.destState || '', address: editForm.destAddress || '', terminal: editForm.destTerminal || editForm.destCity + ' Terminal', coordinates: editForm.destCoords || { lat: 0, lng: 0 } };
                                            const returnDestData = { city: editForm.originCity, state: editForm.originState || '', address: editForm.originAddress || '', terminal: editForm.originTerminal || editForm.originCity + ' Terminal', coordinates: editForm.originCoords || { lat: 0, lng: 0 } };
                                            const downPoints = [...upPointsWithDistances].reverse();
                                            let cumulativeDist = 0;
                                            const reversedStops = [];
                                            for (let i = 1; i < downPoints.length - 1; i++) {
                                                const currentPoint = downPoints[i];
                                                let segmentDistance = currentPoint.distanceFromPrev || 0;
                                                cumulativeDist += segmentDistance;
                                                let newStopType = currentPoint.stopType;
                                                if (currentPoint.stopType === 'boarding') newStopType = 'dropping';
                                                else if (currentPoint.stopType === 'dropping') newStopType = 'boarding';
                                                reversedStops.push({ sequence: i, city: currentPoint.city, state: currentPoint.state || '', address: currentPoint.address || '', terminal: currentPoint.terminal || '', stopType: newStopType, coordinates: currentPoint.coordinates || { lat: 0, lng: 0 }, distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: segmentDistance > 0 ? parseFloat(segmentDistance.toFixed(1)) : null, manualDistToNext: null, isManualStop: currentPoint.isManualStop || false });
                                            }
                                            setEditForm((prev) => ({ ...prev, isRoundTrip: true, returnOriginCity: returnOriginData.city, returnOriginState: returnOriginData.state, returnOriginAddress: returnOriginData.address, returnOriginTerminal: returnOriginData.terminal, returnOriginCoords: returnOriginData.coordinates, returnDestCity: returnDestData.city, returnDestState: returnDestData.state, returnDestAddress: returnDestData.address, returnDestTerminal: returnDestData.terminal, returnDestCoords: returnDestData.coordinates, returnTotalDistance: cumulativeDist.toFixed(1), returnDurationHours: editForm.durationHours, returnDurationMinutes: editForm.durationMinutes, returnManualFinalLeg: '' }));
                                            setDownStops(reversedStops);
                                            setIsDistanceCalculated((prev) => ({ ...prev, down: false }));
                                            toast.info(`Return route auto-populated with ${reversedStops.length} stops.`);
                                        } else {
                                            setEditForm((prev) => ({ ...prev, isRoundTrip: newIsRoundTrip }));
                                            if (!newIsRoundTrip) setDownStops([]);
                                        }
                                    }}
                                />
                            </div>

                            {editForm.isRoundTrip && (
                                <div className="prm-segment" style={{ gridTemplateColumns: '1fr 1fr' }}>
                                    <span className="prm-segment-pill" style={{ transform: `translateX(${activeRouteTab === 'UP' ? 0 : 100}%)` }} />
                                    <button className={activeRouteTab === 'UP' ? 'active' : ''} onClick={() => setActiveRouteTab('UP')}>
                                        <Icon name="map" size={15} /> UP Route
                                    </button>
                                    <button className={activeRouteTab === 'DOWN' ? 'active' : ''} onClick={() => setActiveRouteTab('DOWN')}>
                                        <Icon name="map" size={15} /> DOWN Route
                                    </button>
                                </div>
                            )}

                            {/* 1 — Route Identity */}
                            <FormSection n="1" title="Route Identity" hint="Edit route name and description." delay={40}>
                                <div className="prm-fgrid">
                                    <Field label="Route Name" required>
                                        <input type="text" value={editForm.masterRouteName} onChange={(e) => setEditForm((prev) => ({ ...prev, masterRouteName: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="Description" full>
                                        <textarea value={editForm.description} onChange={(e) => setEditForm((prev) => ({ ...prev, description: e.target.value }))} className="prm-input" rows="2" />
                                    </Field>
                                </div>
                            </FormSection>

                            {/* 2 — Via Cities */}
                            <FormSection n="2" title="Via Cities" hint="Cities the route passes through." delay={80}>
                                {editForm.via?.length > 0 && (
                                    <div style={{ marginBottom: 12 }}>
                                        {editForm.via.map((viaCity, index) => (
                                            <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                                                <span className="prm-tag navy" style={{ minWidth: 30 }}>#{index + 1}</span>
                                                <input type="text" value={viaCity.city} onChange={(e) => updateEditViaCity(index, 'city', e.target.value)} className="prm-input" style={{ flex: 2 }} />
                                                <input type="text" value={viaCity.state || ''} onChange={(e) => updateEditViaCity(index, 'state', e.target.value)} className="prm-input" style={{ flex: 2 }} />
                                                <button type="button" className="prm-btn danger sm" onClick={() => removeEditViaCity(index)}>
                                                    <Icon name="trash" size={13} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <input type="text" value={editViaInput} onChange={(e) => setEditViaInput(e.target.value)} onKeyPress={(e) => { if (e.key === 'Enter') addEditViaCity(); }} placeholder="Enter via city name…" className="prm-input" style={{ flex: 3 }} />
                                    <button type="button" className="prm-btn teal" onClick={addEditViaCity}>
                                        <Icon name="plus" size={14} /> Add Via
                                    </button>
                                </div>
                            </FormSection>

                            {/* 3 — Origin */}
                            <FormSection n="3" title={activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'} hint={activeRouteTab === 'UP' ? 'Main origin details.' : 'Return origin details.'} delay={120}>
                                {activeRouteTab === 'UP' ? (
                                    <div className="prm-fgrid">
                                        <Field label="Search Location" required full>
                                            <LocationInput value={editForm.originCity} onChange={(value) => setEditForm((prev) => ({ ...prev, originCity: value }))} onLocationSelect={handleEditOriginSelect} placeholder="Search origin city…" />
                                        </Field>
                                        <Field label="Address" full><input type="text" value={editForm.originAddress} onChange={(e) => setEditForm((prev) => ({ ...prev, originAddress: e.target.value }))} className="prm-input" /></Field>
                                        <Field label="State"><input type="text" value={editForm.originState} onChange={(e) => setEditForm((prev) => ({ ...prev, originState: e.target.value }))} className="prm-input" /></Field>
                                        <Field label="Terminal"><input type="text" value={editForm.originTerminal} onChange={(e) => setEditForm((prev) => ({ ...prev, originTerminal: e.target.value }))} className="prm-input" /></Field>
                                    </div>
                                ) : (
                                    <Field label="Return Origin City" full><input type="text" value={editForm.returnOriginCity || ''} onChange={(e) => setEditForm((prev) => ({ ...prev, returnOriginCity: e.target.value }))} className="prm-input" /></Field>
                                )}
                            </FormSection>

                            {/* 4 — Destination */}
                            <FormSection n="4" title={activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'} hint={activeRouteTab === 'UP' ? 'Main destination details.' : 'Return destination details.'} delay={160}>
                                {activeRouteTab === 'UP' ? (
                                    <div className="prm-fgrid">
                                        <Field label="Search Location" required full>
                                            <LocationInput value={editForm.destCity} onChange={(value) => setEditForm((prev) => ({ ...prev, destCity: value }))} onLocationSelect={handleEditDestSelect} placeholder="Search destination city…" />
                                        </Field>
                                        <Field label="Address" full><input type="text" value={editForm.destAddress} onChange={(e) => setEditForm((prev) => ({ ...prev, destAddress: e.target.value }))} className="prm-input" /></Field>
                                        <Field label="State"><input type="text" value={editForm.destState} onChange={(e) => setEditForm((prev) => ({ ...prev, destState: e.target.value }))} className="prm-input" /></Field>
                                        <Field label="Terminal"><input type="text" value={editForm.destTerminal} onChange={(e) => setEditForm((prev) => ({ ...prev, destTerminal: e.target.value }))} className="prm-input" /></Field>
                                    </div>
                                ) : (
                                    <Field label="Return Destination City" full><input type="text" value={editForm.returnDestCity || ''} onChange={(e) => setEditForm((prev) => ({ ...prev, returnDestCity: e.target.value }))} className="prm-input" /></Field>
                                )}
                            </FormSection>

                            {/* 5 — Stops */}
                            <FormSection n="5" title={`Intermediate Stops (${activeRouteTab})`} hint="Edit intermediate stops." delay={200}>
                                {activeRouteTab === 'DOWN' && editForm.isRoundTrip && (
                                    <button className="prm-btn teal" style={{ marginBottom: 12 }} onClick={() => {
                                        if (!window.confirm('Update Return Route stops from Main Route?')) return;
                                        const upTotalDist = parseFloat(editForm.totalDistance) || 0;
                                        const originPoint = { city: editForm.originCity, distanceFromOrigin: 0, coordinates: editForm.originCoords, isManualStop: false };
                                        const destPoint = { city: editForm.destCity, distanceFromOrigin: upTotalDist, coordinates: editForm.destCoords, isManualStop: false, distanceFromPrev: upTotalDist - (upStops.length > 0 ? upStops[upStops.length - 1]?.distanceFromOrigin || 0 : 0) };
                                        const stopsWithPrev = upStops.map((stop, idx) => {
                                            const prevDistance = idx === 0 ? 0 : upStops[idx - 1]?.distanceFromOrigin || 0;
                                            return { ...stop, distanceFromPrev: (stop.distanceFromOrigin || 0) - prevDistance };
                                        });
                                        const upPoints = [originPoint, ...stopsWithPrev, destPoint];
                                        const downPoints = [...upPoints].reverse();
                                        let cumulativeDist = 0;
                                        const reversedStops = [];
                                        for (let i = 1; i < downPoints.length - 1; i++) {
                                            const currentPoint = downPoints[i];
                                            const segmentDistance = currentPoint.distanceFromPrev || 0;
                                            cumulativeDist += segmentDistance;
                                            let newStopType = currentPoint.stopType;
                                            if (currentPoint.stopType === 'boarding') newStopType = 'dropping';
                                            else if (currentPoint.stopType === 'dropping') newStopType = 'boarding';
                                            reversedStops.push({ sequence: i, city: currentPoint.city, state: currentPoint.state || '', address: currentPoint.address || `${currentPoint.city || ''}, ${currentPoint.state || 'India'}`, terminal: currentPoint.terminal || `${currentPoint.city || ''} Bus Stand`, stopType: newStopType, coordinates: currentPoint.coordinates || { lat: 0, lng: 0 }, distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: segmentDistance > 0 ? parseFloat(segmentDistance.toFixed(1)) : null, manualDistToNext: null, isManualStop: currentPoint.isManualStop || false });
                                        }
                                        setDownStops(reversedStops);
                                        setIsDistanceCalculated((prev) => ({ ...prev, down: false }));
                                        toast.info(`Return route synced with ${reversedStops.length} stops.`);
                                    }}>
                                        <Icon name="refresh" size={15} /> Auto-Fill / Sync Reversed Stops from UP Route
                                    </button>
                                )}

                                <div className="prm-stop-list">
                                    {getActiveStops().map((stop, index) => (
                                        <React.Fragment key={index}>
                                            <div className="prm-stop-item">
                                                <div className="prm-stop-num">{index + 1}</div>
                                                <div className="prm-stop-info">
                                                    <div className="prm-stop-name">
                                                        {stop.city}
                                                        <span className="prm-tag navy">{formatDistance(stop.distanceFromOrigin)} km</span>
                                                    </div>
                                                    <div className="prm-stop-times">📍 {stop.address || `${stop.city}, ${stop.state || 'India'}`}</div>
                                                    {stop.manualDistToNext && (
                                                        <div className="prm-stop-times" style={{ color: 'var(--rose)' }}>→ Next: {stop.manualDistToNext} km</div>
                                                    )}
                                                </div>
                                                <div className="prm-stop-actions">
                                                    <button className="prm-btn ghost sm" onClick={() => handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down')}>
                                                        <Icon name="edit" size={14} /> Edit
                                                    </button>
                                                    <button className="prm-btn danger sm" onClick={() => handleDeleteStop(index)}>
                                                        <Icon name="trash" size={14} />
                                                    </button>
                                                </div>
                                            </div>
                                            {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </FormSection>

                            {/* 6 — Summary */}
                            <FormSection n="6" title={`${activeRouteTab} Summary`} hint="Recalculate distances." delay={240}>
                                <div className="prm-summary">
                                    <button className="prm-btn teal" onClick={() => {
                                        setNewRoute((prev) => ({
                                            ...prev,
                                            upOriginCity: editForm.originCity || prev.upOriginCity,
                                            upOriginState: editForm.originState || prev.upOriginState,
                                            upOriginAddress: editForm.originAddress || prev.upOriginAddress,
                                            upOriginCoords: editForm.originCoords || prev.upOriginCoords,
                                            upOriginTerminal: editForm.originTerminal || prev.upOriginTerminal,
                                            upDestCity: editForm.destCity || prev.upDestCity,
                                            upDestState: editForm.destState || prev.upDestState,
                                            upDestAddress: editForm.destAddress || prev.upDestAddress,
                                            upDestCoords: editForm.destCoords || prev.upDestCoords,
                                            upDestTerminal: editForm.destTerminal || prev.upDestTerminal,
                                            upTotalDistance: editForm.totalDistance || prev.upTotalDistance,
                                            downTotalDistance: editForm.returnTotalDistance || prev.downTotalDistance,
                                            upManualFinalLeg: editForm.upManualFinalLeg || prev.upManualFinalLeg,
                                            downManualFinalLeg: editForm.returnManualFinalLeg || prev.downManualFinalLeg,
                                            upDurationHours: editForm.durationHours || prev.upDurationHours,
                                            upDurationMinutes: editForm.durationMinutes || prev.upDurationMinutes,
                                            downDurationHours: editForm.returnDurationHours || prev.downDurationHours,
                                            downDurationMinutes: editForm.returnDurationMinutes || prev.downDurationMinutes,
                                        }));
                                        setTimeout(() => handleCalculateDistances(), 100);
                                    }} disabled={isCalculatingDistances}>
                                        <Icon name="calc" size={16} />
                                        {isCalculatingDistances ? 'Calculating…' : 'Auto-Calculate Distances'}
                                    </button>
                                </div>

                                {isLastStopManual() && (
                                    <div className="prm-callout rose" style={{ marginBottom: 12, background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
                                        <Icon name="info" size={18} />
                                        <div><strong>Last stop is manual</strong><span>Please provide distance from last stop to destination.</span></div>
                                    </div>
                                )}

                                <div className="prm-fgrid">
                                    <Field label="Distance from Last Stop to Destination (km)" full>
                                        <input type="number"
                                            value={activeRouteTab === 'UP' ? editForm.upManualFinalLeg : editForm.returnManualFinalLeg}
                                            onChange={(e) => {
                                                if (activeRouteTab === 'UP') setEditForm((prev) => ({ ...prev, upManualFinalLeg: e.target.value }));
                                                else setEditForm((prev) => ({ ...prev, returnManualFinalLeg: e.target.value }));
                                            }}
                                            className="prm-input" min="0" step="0.1" />
                                    </Field>
                                      <Field label="Estimated Duration">
        <div className="prm-dur">
            <input
                type="number"
                value={(activeRouteTab === 'UP' ? editForm.durationHours : editForm.returnDurationHours) ?? ''}
                onChange={(e) => setEditForm((prev) => ({ ...prev, [activeRouteTab === 'UP' ? 'durationHours' : 'returnDurationHours']: e.target.value }))}
                className="prm-input" placeholder="0" min="0" />
            <span>h</span>
            <input
                type="number"
                value={(activeRouteTab === 'UP' ? editForm.durationMinutes : editForm.returnDurationMinutes) ?? ''}
                onChange={(e) => setEditForm((prev) => ({ ...prev, [activeRouteTab === 'UP' ? 'durationMinutes' : 'returnDurationMinutes']: e.target.value }))}
                className="prm-input" placeholder="0" min="0" max="59" />
            <span>m</span>
        </div>
    </Field>
                                </div>

                                <div style={{ marginTop: 16 }}>
                                    <PrmCheckbox
                                        label="Route is Active"
                                        checked={editForm.isActive}
                                        onChange={() => setEditForm((prev) => ({ ...prev, isActive: !prev.isActive }))}
                                    />
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span />
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowEditModal(false)}>Cancel</button>
                                <button className="prm-btn primary" onClick={handleUpdateRoute} disabled={isUpdatingRoute}>
                                    {isUpdatingRoute ? 'Updating…' : <><Icon name="check" size={16} /> Update Route</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
             * STOP EDIT MODAL — Modern redesign
             * ============================================================ */}
            {showStopEditModal && stopBeingEdited && (
                <div className="prm-overlay prm-overlay-top" onClick={() => setShowStopEditModal(false)}>
                    <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                                <div>
                                    <h3>Edit Stop #{stopBeingEdited.index + 1}</h3>
                                    <p>{stopBeingEdited.originalStop.city}</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowStopEditModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            <FormSection n="1" title="Stop Details" hint="Update location and stop info." delay={40}>
                                <PrmCheckbox
                                    label="Manually Typed Stop (No Map Suggestions)"
                                    checked={stopEditForm.isManualStop}
                                    onChange={() => setStopEditForm((prev) => ({ ...prev, isManualStop: !prev.isManualStop, manualDistFromPrev: !prev.isManualStop ? prev.manualDistFromPrev : '' }))}
                                />
                                <div className="prm-fgrid" style={{ marginTop: 14 }}>
                                    <Field label="City Name" required full>
                                        <input type="text" value={stopEditForm.city} onChange={(e) => setStopEditForm((prev) => ({ ...prev, city: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="Address" full>
                                        <input type="text" value={stopEditForm.address} onChange={(e) => setStopEditForm((prev) => ({ ...prev, address: e.target.value }))} className="prm-input" />
                                    </Field>
                                    {(stopEditForm.isManualStop || (!stopBeingEdited.originalStop.coordinates?.lat && !stopBeingEdited.originalStop.coordinates?.lng)) && (
                                        <Field label="Distance from Previous Stop (km)" required full>
                                            <input type="number" value={stopEditForm.manualDistFromPrev} onChange={(e) => setStopEditForm((prev) => ({ ...prev, manualDistFromPrev: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                        </Field>
                                    )}
                                    {stopEditForm.isManualStop && (() => {
                                        const stops = activeRouteTab === 'UP' ? upStops : downStops;
                                        const nextStop = stops[stopBeingEdited.index + 1];
                                        const isNextAuto = nextStop && nextStop.coordinates && (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
                                        if (isNextAuto) return (
                                            <Field label={`Distance to Next Stop (${nextStop.city}) (km)`} required full>
                                                <input type="number" value={stopEditForm.manualDistToNext} onChange={(e) => setStopEditForm((prev) => ({ ...prev, manualDistToNext: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        );
                                        return null;
                                    })()}
                                    <Field label="State"><input type="text" value={stopEditForm.state} onChange={(e) => setStopEditForm((prev) => ({ ...prev, state: toProperCase(e.target.value) }))} className="prm-input" /></Field>
                                    <Field label="Terminal"><input type="text" value={stopEditForm.terminal} onChange={(e) => setStopEditForm((prev) => ({ ...prev, terminal: e.target.value }))} className="prm-input" /></Field>
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span />
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowStopEditModal(false)}>Cancel</button>
                                <button className="prm-btn primary" onClick={saveEditedStop} disabled={!stopEditForm.city || !stopEditForm.address}>
                                    <Icon name="check" size={15} /> Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
             * STOP MODAL — Modern redesign
             * ============================================================ */}
            {showStopModal && (
                <div className="prm-overlay prm-overlay-top" onClick={() => setShowStopModal(false)}>
                    <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name={stopModalMode === 'edit' ? 'edit' : 'plus'} size={22} /></span>
                                <div>
                                    <h3>
                                        {stopModalMode === 'add' && 'Add New Stop'}
                                        {stopModalMode === 'insert' && `Insert Stop at Position ${tempInsertIndex + 1}`}
                                        {stopModalMode === 'edit' && `Edit Stop #${tempEditStopIndex?.index + 1}`}
                                    </h3>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowStopModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            <FormSection n="1" title="Stop Details" hint="Enter stop information." delay={40}>
                                <PrmCheckbox
                                    label="Manually Typed Stop (No Map Suggestions)"
                                    checked={tempStopForm.isManual}
                                    onChange={() => setTempStopForm((prev) => ({ ...prev, isManual: !prev.isManual, distFromPrev: !prev.isManual ? prev.distFromPrev : '' }))}
                                />

                                <div className="prm-fgrid" style={{ marginTop: 14 }}>
                                    <Field label={tempStopForm.isManual ? 'City Name' : 'Search Location'} required full>
                                        {!tempStopForm.isManual ? (
                                            <LocationInput value={tempStopForm.city} onChange={(value) => setTempStopForm((prev) => ({ ...prev, city: value }))} onLocationSelect={(location) => setTempStopForm((prev) => ({ ...prev, city: location.city || location.name || '', state: location.state || prev.state, address: location.address || '' }))} placeholder="Search stop city or address…" />
                                        ) : (
                                            <CitySearchDropdown
                                                value={tempStopForm.city}
                                                onChange={(v) => setTempStopForm((prev) => ({ ...prev, city: v }))}
                                                onSelect={(city) => { setTempStopForm((prev) => ({ ...prev, city: city.name, address: city.address || city.name, state: city.state || '', terminal: city.terminal || `${city.name} Bus Stand` })); toast.success(`Auto-filled ${city.name}`); }}
                                                token={token}
                                                activeRouteTab={activeRouteTab}
                                            />
                                        )}
                                    </Field>
                                    <Field label="Address" full>
                                        <input type="text" value={tempStopForm.address} onChange={(e) => setTempStopForm((prev) => ({ ...prev, address: e.target.value }))} className="prm-input" />
                                    </Field>
                                    {(tempStopForm.isManual || stopModalMode === 'edit') && (
                                        <Field label="Distance from Previous Stop (km)" required>
                                            <input type="number" value={tempStopForm.distFromPrev} onChange={(e) => setTempStopForm((prev) => ({ ...prev, distFromPrev: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                        </Field>
                                    )}
                                    {(() => {
                                        const nextStop = getNextStopInfo();
                                        if (nextStop && (tempStopForm.isManual || tempStopForm.distToNext)) return (
                                            <Field label={`Distance to Next Stop (${nextStop.city}) (km)`}>
                                                <input type="number" value={tempStopForm.distToNext} onChange={(e) => setTempStopForm((prev) => ({ ...prev, distToNext: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        );
                                        return null;
                                    })()}
                                    <Field label="State"><input type="text" value={tempStopForm.state} onChange={(e) => setTempStopForm((prev) => ({ ...prev, state: toProperCase(e.target.value) }))} className="prm-input" /></Field>
                                    <Field label="Terminal"><input type="text" value={tempStopForm.terminal} onChange={(e) => setTempStopForm((prev) => ({ ...prev, terminal: e.target.value }))} className="prm-input" /></Field>
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span />
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowStopModal(false)}>Cancel</button>
                                <button className="prm-btn primary" onClick={saveStopFromModal} disabled={!tempStopForm.city}>
                                    <Icon name="check" size={15} /> {stopModalMode === 'edit' ? 'Save Changes' : 'Add Stop'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MasterRouteManage;
